const R0 = ["licensePlate", "inspectionExpiryDate"];
function Yu({ firstRegistration: o }) {
  return o == null ? !0 : typeof o == "string" && o.trim() === "";
}
function O0(o, n) {
  return R0.some((r) => r === o) && Yu(n);
}
const z0 = [
  "registrationDocument",
  "registrationDocumentPartTwo"
];
function G0(o, n) {
  return z0.some((r) => r === o) && Yu(n);
}
const U0 = [
  // Visibility-only: visible Back Office where shown, hidden elsewhere.
  "useType",
  "engineBrand",
  "engineModel",
  "width",
  "height",
  // Responsibility-varying: always visible; Back Office/Inspector and required both vary.
  "length",
  "axles",
  "wheels",
  "wheelsSizeAxle1",
  "wheelsSizeAxle2",
  "wheelsSizeAxle3",
  "inspectionExpiryDate",
  "cylinders",
  // Inspector or hidden.
  "hasDepotService"
], eT = [
  "cocDocument",
  "registrationDocument",
  "registrationDocumentPartTwo",
  "maintenanceCard",
  "technicalSheet",
  "inspectionAndMileageCheck"
], yo = { visibility: "hidden" }, E = { visibility: "visible", responsibility: "BackOffice", required: !0 }, Wo = { visibility: "visible", responsibility: "BackOffice", required: !1 }, ko = { visibility: "visible", responsibility: "Inspector", required: !0 }, Bo = { visibility: "visible", responsibility: "Inspector", required: !1 }, ki = {
  useType: { default: yo, overrides: { IT: E } },
  engineBrand: {
    default: yo,
    overrides: {
      IT: E,
      ES: E,
      PT: E,
      BE: E,
      AT: E,
      NL: E
    }
  },
  engineModel: { default: yo, overrides: { IT: E, ES: E, AT: E } },
  width: {
    default: yo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  height: {
    default: yo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  length: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      BE: E,
      DE: E,
      AT: E,
      CZ: E,
      NL: E,
      LU: E,
      PT: Bo
    }
  },
  axles: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      DE: E,
      AT: E,
      LU: E,
      PT: Bo
    }
  },
  wheels: {
    default: ko,
    overrides: {
      IT: E,
      ES: E,
      DE: E,
      AT: E,
      LU: E,
      PT: Bo
    }
  },
  wheelsSizeAxle1: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: E }
  },
  wheelsSizeAxle2: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: Wo }
  },
  wheelsSizeAxle3: {
    default: Bo,
    overrides: { IT: E, ES: E, DE: E, AT: E, LU: Wo }
  },
  inspectionExpiryDate: { default: E, overrides: { PT: ko, DE: ko } },
  cylinders: { default: Bo, overrides: { ES: E } },
  // Deliberately NOT aligned to PT-703 (BSD-4329): the sheet's "Depot Service" (code 60) is an attribute the
  // inspector observes, whereas this column is a commercial flag, set when the seller accepts the depot terms
  // (BusAsset.depotTermsAcceptedAt). Same name, different thing — do not sync this row from the sheet.
  hasDepotService: { default: yo, overrides: { IT: Bo } }
}, Di = {
  cocDocument: { default: Wo, overrides: { BE: E, NL: E } },
  registrationDocument: { default: E, overrides: { DE: ko, AT: ko, CZ: ko } },
  registrationDocumentPartTwo: { default: yo, overrides: { DE: E, AT: E, CZ: E } },
  maintenanceCard: { default: Wo },
  technicalSheet: { default: yo, overrides: { ES: E } },
  inspectionAndMileageCheck: { default: yo, overrides: { IT: Wo, ES: Wo, PL: Wo } }
};
function At(o, n) {
  const { default: r, overrides: a } = o;
  if (n != null && a !== void 0) {
    const u = a[n];
    if (u !== void 0) return u;
  }
  return r;
}
function oT(o, n) {
  return At(ki[o], n).visibility === "hidden";
}
function Z0(o, n, r) {
  if (r !== void 0 && O0(o, r)) return !1;
  const a = At(ki[o], n);
  return a.visibility === "visible" && a.required;
}
function tT(o, n) {
  const r = At(ki[o], n);
  return r.visibility === "visible" ? r.responsibility : void 0;
}
function nT(o, n) {
  return U0.filter((r) => Z0(r, o, n));
}
function rT(o, n) {
  return At(Di[o], n).visibility === "hidden";
}
function iT(o, n, r) {
  if (r !== void 0 && G0(o, r)) return !1;
  const a = At(Di[o], n);
  return a.visibility === "visible" && a.required;
}
function aT(o, n) {
  const r = At(Di[o], n);
  return r.visibility === "visible" ? r.responsibility : void 0;
}
const sT = ["Autobus", "Minibus", "Other"], uT = ["ClassOne", "ClassTwo", "ClassThree", "ClassA", "ClassB", "SchoolBus"], $0 = [
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 13 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 12 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 11.5 },
  { axles: 3, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 11 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 9 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 8 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 7.5 },
  { axles: 3, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !1, cubicMetres: 10 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !1, cubicMetres: 9 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !1, driverBerth: !0, cubicMetres: 8.5 },
  { axles: 2, passThroughLuggageCompartment: !0, toilet: !0, driverBerth: !0, cubicMetres: 8 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !1, cubicMetres: 7 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !1, cubicMetres: 6 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !1, driverBerth: !0, cubicMetres: 5.5 },
  { axles: 2, passThroughLuggageCompartment: !1, toilet: !0, driverBerth: !0, cubicMetres: 5 }
], K0 = 2;
function lT(o) {
  if (o.class === "ClassOne") return null;
  if (o.type === "Minibus") return K0;
  if (o.type !== "Autobus" || o.class !== "ClassTwo" && o.class !== "ClassThree") return null;
  const { axles: n, passThroughLuggageCompartment: r, toilet: a, driverBerth: u } = o;
  return n == null || r === null || r === void 0 || a === null || a === void 0 || u === null || u === void 0 ? null : $0.find(
    (d) => d.axles === n && d.passThroughLuggageCompartment === r && d.toilet === a && d.driverBerth === u
  )?.cubicMetres ?? null;
}
function I(o, n, r) {
  function a(_, T) {
    if (_._zod || Object.defineProperty(_, "_zod", {
      value: {
        def: T,
        constr: d,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), _._zod.traits.has(o))
      return;
    _._zod.traits.add(o), n(_, T);
    const v = d.prototype, w = Object.keys(v);
    for (let z = 0; z < w.length; z++) {
      const B = w[z];
      B in _ || (_[B] = v[B].bind(_));
    }
  }
  const u = r?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: o });
  function d(_) {
    var T;
    const v = r?.Parent ? new f() : this;
    a(v, _), (T = v._zod).deferred ?? (T.deferred = []);
    for (const w of v._zod.deferred)
      w();
    return v;
  }
  return Object.defineProperty(d, "init", { value: a }), Object.defineProperty(d, Symbol.hasInstance, {
    value: (_) => r?.Parent && _ instanceof r.Parent ? !0 : _?._zod?.traits?.has(o)
  }), Object.defineProperty(d, "name", { value: o }), d;
}
class mt extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Xu extends Error {
  constructor(n) {
    super(`Encountered unidirectional transform during encode: ${n}`), this.name = "ZodEncodeError";
  }
}
const Qu = {};
function Vo(o) {
  return Qu;
}
function el(o) {
  const n = Object.values(o).filter((a) => typeof a == "number");
  return Object.entries(o).filter(([a, u]) => n.indexOf(+a) === -1).map(([a, u]) => u);
}
function Fi(o, n) {
  return typeof n == "bigint" ? n.toString() : n;
}
function Li(o) {
  return {
    get value() {
      {
        const n = o();
        return Object.defineProperty(this, "value", { value: n }), n;
      }
    }
  };
}
function Pi(o) {
  return o == null;
}
function Ri(o) {
  const n = o.startsWith("^") ? 1 : 0, r = o.endsWith("$") ? o.length - 1 : o.length;
  return o.slice(n, r);
}
function q0(o, n) {
  const r = (o.toString().split(".")[1] || "").length, a = n.toString();
  let u = (a.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(a)) {
    const T = a.match(/\d?e-(\d?)/);
    T?.[1] && (u = Number.parseInt(T[1]));
  }
  const f = r > u ? r : u, d = Number.parseInt(o.toFixed(f).replace(".", "")), _ = Number.parseInt(n.toFixed(f).replace(".", ""));
  return d % _ / 10 ** f;
}
const vu = /* @__PURE__ */ Symbol("evaluating");
function j(o, n, r) {
  let a;
  Object.defineProperty(o, n, {
    get() {
      if (a !== vu)
        return a === void 0 && (a = vu, a = r()), a;
    },
    set(u) {
      Object.defineProperty(o, n, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function jo(o, n, r) {
  Object.defineProperty(o, n, {
    value: r,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Do(...o) {
  const n = {};
  for (const r of o) {
    const a = Object.getOwnPropertyDescriptors(r);
    Object.assign(n, a);
  }
  return Object.defineProperties({}, n);
}
function Nu(o) {
  return JSON.stringify(o);
}
function H0(o) {
  return o.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const ol = "captureStackTrace" in Error ? Error.captureStackTrace : (...o) => {
};
function qn(o) {
  return typeof o == "object" && o !== null && !Array.isArray(o);
}
const W0 = Li(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const o = Function;
    return new o(""), !0;
  } catch {
    return !1;
  }
});
function Wt(o) {
  if (qn(o) === !1)
    return !1;
  const n = o.constructor;
  if (n === void 0 || typeof n != "function")
    return !0;
  const r = n.prototype;
  return !(qn(r) === !1 || Object.prototype.hasOwnProperty.call(r, "isPrototypeOf") === !1);
}
function tl(o) {
  return Wt(o) ? { ...o } : Array.isArray(o) ? [...o] : o;
}
const V0 = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function _t(o) {
  return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Lo(o, n, r) {
  const a = new o._zod.constr(n ?? o._zod.def);
  return (!n || r?.parent) && (a._zod.parent = o), a;
}
function k(o) {
  const n = o;
  if (!n)
    return {};
  if (typeof n == "string")
    return { error: () => n };
  if (n?.message !== void 0) {
    if (n?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    n.error = n.message;
  }
  return delete n.message, typeof n.error == "string" ? { ...n, error: () => n.error } : n;
}
function J0(o) {
  return Object.keys(o).filter((n) => o[n]._zod.optin === "optional" && o[n]._zod.optout === "optional");
}
const j0 = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Y0(o, n) {
  const r = o._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Do(o._zod.def, {
    get shape() {
      const d = {};
      for (const _ in n) {
        if (!(_ in r.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        n[_] && (d[_] = r.shape[_]);
      }
      return jo(this, "shape", d), d;
    },
    checks: []
  });
  return Lo(o, f);
}
function X0(o, n) {
  const r = o._zod.def, a = r.checks;
  if (a && a.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Do(o._zod.def, {
    get shape() {
      const d = { ...o._zod.def.shape };
      for (const _ in n) {
        if (!(_ in r.shape))
          throw new Error(`Unrecognized key: "${_}"`);
        n[_] && delete d[_];
      }
      return jo(this, "shape", d), d;
    },
    checks: []
  });
  return Lo(o, f);
}
function Q0(o, n) {
  if (!Wt(n))
    throw new Error("Invalid input to extend: expected a plain object");
  const r = o._zod.def.checks;
  if (r && r.length > 0) {
    const f = o._zod.def.shape;
    for (const d in n)
      if (Object.getOwnPropertyDescriptor(f, d) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Do(o._zod.def, {
    get shape() {
      const f = { ...o._zod.def.shape, ...n };
      return jo(this, "shape", f), f;
    }
  });
  return Lo(o, u);
}
function eb(o, n) {
  if (!Wt(n))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const r = Do(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...n };
      return jo(this, "shape", a), a;
    }
  });
  return Lo(o, r);
}
function ob(o, n) {
  const r = Do(o._zod.def, {
    get shape() {
      const a = { ...o._zod.def.shape, ...n._zod.def.shape };
      return jo(this, "shape", a), a;
    },
    get catchall() {
      return n._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Lo(o, r);
}
function tb(o, n, r) {
  const u = n._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const d = Do(n._zod.def, {
    get shape() {
      const _ = n._zod.def.shape, T = { ..._ };
      if (r)
        for (const v in r) {
          if (!(v in _))
            throw new Error(`Unrecognized key: "${v}"`);
          r[v] && (T[v] = o ? new o({
            type: "optional",
            innerType: _[v]
          }) : _[v]);
        }
      else
        for (const v in _)
          T[v] = o ? new o({
            type: "optional",
            innerType: _[v]
          }) : _[v];
      return jo(this, "shape", T), T;
    },
    checks: []
  });
  return Lo(n, d);
}
function nb(o, n, r) {
  const a = Do(n._zod.def, {
    get shape() {
      const u = n._zod.def.shape, f = { ...u };
      if (r)
        for (const d in r) {
          if (!(d in f))
            throw new Error(`Unrecognized key: "${d}"`);
          r[d] && (f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          }));
        }
      else
        for (const d in u)
          f[d] = new o({
            type: "nonoptional",
            innerType: u[d]
          });
      return jo(this, "shape", f), f;
    }
  });
  return Lo(n, a);
}
function ft(o, n = 0) {
  if (o.aborted === !0)
    return !0;
  for (let r = n; r < o.issues.length; r++)
    if (o.issues[r]?.continue !== !0)
      return !0;
  return !1;
}
function nl(o, n) {
  return n.map((r) => {
    var a;
    return (a = r).path ?? (a.path = []), r.path.unshift(o), r;
  });
}
function Zn(o) {
  return typeof o == "string" ? o : o?.message;
}
function Jo(o, n, r) {
  const a = { ...o, path: o.path ?? [] };
  if (!o.message) {
    const u = Zn(o.inst?._zod.def?.error?.(o)) ?? Zn(n?.error?.(o)) ?? Zn(r.customError?.(o)) ?? Zn(r.localeError?.(o)) ?? "Invalid input";
    a.message = u;
  }
  return delete a.inst, delete a.continue, n?.reportInput || delete a.input, a;
}
function Oi(o) {
  return Array.isArray(o) ? "array" : typeof o == "string" ? "string" : "unknown";
}
function Vt(...o) {
  const [n, r, a] = o;
  return typeof n == "string" ? {
    message: n,
    code: "custom",
    input: r,
    inst: a
  } : { ...n };
}
const rl = (o, n) => {
  o.name = "$ZodError", Object.defineProperty(o, "_zod", {
    value: o._zod,
    enumerable: !1
  }), Object.defineProperty(o, "issues", {
    value: n,
    enumerable: !1
  }), o.message = JSON.stringify(n, Fi, 2), Object.defineProperty(o, "toString", {
    value: () => o.message,
    enumerable: !1
  });
}, il = I("$ZodError", rl), al = I("$ZodError", rl, { Parent: Error });
function rb(o, n = (r) => r.message) {
  const r = {}, a = [];
  for (const u of o.issues)
    u.path.length > 0 ? (r[u.path[0]] = r[u.path[0]] || [], r[u.path[0]].push(n(u))) : a.push(n(u));
  return { formErrors: a, fieldErrors: r };
}
function ib(o, n = (r) => r.message) {
  const r = { _errors: [] }, a = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((d) => a({ issues: d }));
      else if (f.code === "invalid_key")
        a({ issues: f.issues });
      else if (f.code === "invalid_element")
        a({ issues: f.issues });
      else if (f.path.length === 0)
        r._errors.push(n(f));
      else {
        let d = r, _ = 0;
        for (; _ < f.path.length; ) {
          const T = f.path[_];
          _ === f.path.length - 1 ? (d[T] = d[T] || { _errors: [] }, d[T]._errors.push(n(f))) : d[T] = d[T] || { _errors: [] }, d = d[T], _++;
        }
      }
  };
  return a(o), r;
}
const zi = (o) => (n, r, a, u) => {
  const f = a ? Object.assign(a, { async: !1 }) : { async: !1 }, d = n._zod.run({ value: r, issues: [] }, f);
  if (d instanceof Promise)
    throw new mt();
  if (d.issues.length) {
    const _ = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, Vo())));
    throw ol(_, u?.callee), _;
  }
  return d.value;
}, Gi = (o) => async (n, r, a, u) => {
  const f = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let d = n._zod.run({ value: r, issues: [] }, f);
  if (d instanceof Promise && (d = await d), d.issues.length) {
    const _ = new (u?.Err ?? o)(d.issues.map((T) => Jo(T, f, Vo())));
    throw ol(_, u?.callee), _;
  }
  return d.value;
}, jn = (o) => (n, r, a) => {
  const u = a ? { ...a, async: !1 } : { async: !1 }, f = n._zod.run({ value: r, issues: [] }, u);
  if (f instanceof Promise)
    throw new mt();
  return f.issues.length ? {
    success: !1,
    error: new (o ?? il)(f.issues.map((d) => Jo(d, u, Vo())))
  } : { success: !0, data: f.value };
}, ab = /* @__PURE__ */ jn(al), Yn = (o) => async (n, r, a) => {
  const u = a ? Object.assign(a, { async: !0 }) : { async: !0 };
  let f = n._zod.run({ value: r, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new o(f.issues.map((d) => Jo(d, u, Vo())))
  } : { success: !0, data: f.value };
}, sb = /* @__PURE__ */ Yn(al), ub = (o) => (n, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return zi(o)(n, r, u);
}, lb = (o) => (n, r, a) => zi(o)(n, r, a), cb = (o) => async (n, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Gi(o)(n, r, u);
}, db = (o) => async (n, r, a) => Gi(o)(n, r, a), pb = (o) => (n, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return jn(o)(n, r, u);
}, fb = (o) => (n, r, a) => jn(o)(n, r, a), hb = (o) => async (n, r, a) => {
  const u = a ? Object.assign(a, { direction: "backward" }) : { direction: "backward" };
  return Yn(o)(n, r, u);
}, mb = (o) => async (n, r, a) => Yn(o)(n, r, a), _b = /^[cC][^\s-]{8,}$/, bb = /^[0-9a-z]+$/, Ab = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, gb = /^[0-9a-vA-V]{20}$/, yb = /^[A-Za-z0-9]{27}$/, Tb = /^[a-zA-Z0-9_-]{21}$/, Mb = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Ib = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Fu = (o) => o ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${o}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, xb = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Sb = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function vb() {
  return new RegExp(Sb, "u");
}
const Nb = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, wb = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Cb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Eb = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, sl = /^[A-Za-z0-9_-]*$/, Bb = /^\+[1-9]\d{6,14}$/, ul = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", kb = /* @__PURE__ */ new RegExp(`^${ul}$`);
function ll(o) {
  const n = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof o.precision == "number" ? o.precision === -1 ? `${n}` : o.precision === 0 ? `${n}:[0-5]\\d` : `${n}:[0-5]\\d\\.\\d{${o.precision}}` : `${n}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Db(o) {
  return new RegExp(`^${ll(o)}$`);
}
function Lb(o) {
  const n = ll({ precision: o.precision }), r = ["Z"];
  o.local && r.push(""), o.offset && r.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const a = `${n}(?:${r.join("|")})`;
  return new RegExp(`^${ul}T(?:${a})$`);
}
const Pb = (o) => {
  const n = o ? `[\\s\\S]{${o?.minimum ?? 0},${o?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${n}$`);
}, Rb = /^-?\d+$/, Ob = /^-?\d+(?:\.\d+)?$/, zb = /^[^A-Z]*$/, Gb = /^[^a-z]*$/, Ce = /* @__PURE__ */ I("$ZodCheck", (o, n) => {
  var r;
  o._zod ?? (o._zod = {}), o._zod.def = n, (r = o._zod).onattach ?? (r.onattach = []);
}), cl = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, dl = /* @__PURE__ */ I("$ZodCheckLessThan", (o, n) => {
  Ce.init(o, n);
  const r = cl[typeof n.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (n.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    n.value < f && (n.inclusive ? u.maximum = n.value : u.exclusiveMaximum = n.value);
  }), o._zod.check = (a) => {
    (n.inclusive ? a.value <= n.value : a.value < n.value) || a.issues.push({
      origin: r,
      code: "too_big",
      maximum: typeof n.value == "object" ? n.value.getTime() : n.value,
      input: a.value,
      inclusive: n.inclusive,
      inst: o,
      continue: !n.abort
    });
  };
}), pl = /* @__PURE__ */ I("$ZodCheckGreaterThan", (o, n) => {
  Ce.init(o, n);
  const r = cl[typeof n.value];
  o._zod.onattach.push((a) => {
    const u = a._zod.bag, f = (n.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    n.value > f && (n.inclusive ? u.minimum = n.value : u.exclusiveMinimum = n.value);
  }), o._zod.check = (a) => {
    (n.inclusive ? a.value >= n.value : a.value > n.value) || a.issues.push({
      origin: r,
      code: "too_small",
      minimum: typeof n.value == "object" ? n.value.getTime() : n.value,
      input: a.value,
      inclusive: n.inclusive,
      inst: o,
      continue: !n.abort
    });
  };
}), Ub = /* @__PURE__ */ I("$ZodCheckMultipleOf", (o, n) => {
  Ce.init(o, n), o._zod.onattach.push((r) => {
    var a;
    (a = r._zod.bag).multipleOf ?? (a.multipleOf = n.value);
  }), o._zod.check = (r) => {
    if (typeof r.value != typeof n.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof r.value == "bigint" ? r.value % n.value === BigInt(0) : q0(r.value, n.value) === 0) || r.issues.push({
      origin: typeof r.value,
      code: "not_multiple_of",
      divisor: n.value,
      input: r.value,
      inst: o,
      continue: !n.abort
    });
  };
}), Zb = /* @__PURE__ */ I("$ZodCheckNumberFormat", (o, n) => {
  Ce.init(o, n), n.format = n.format || "float64";
  const r = n.format?.includes("int"), a = r ? "int" : "number", [u, f] = j0[n.format];
  o._zod.onattach.push((d) => {
    const _ = d._zod.bag;
    _.format = n.format, _.minimum = u, _.maximum = f, r && (_.pattern = Rb);
  }), o._zod.check = (d) => {
    const _ = d.value;
    if (r) {
      if (!Number.isInteger(_)) {
        d.issues.push({
          expected: a,
          format: n.format,
          code: "invalid_type",
          continue: !1,
          input: _,
          inst: o
        });
        return;
      }
      if (!Number.isSafeInteger(_)) {
        _ > 0 ? d.issues.push({
          input: _,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !n.abort
        }) : d.issues.push({
          input: _,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: o,
          origin: a,
          inclusive: !0,
          continue: !n.abort
        });
        return;
      }
    }
    _ < u && d.issues.push({
      origin: "number",
      input: _,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: o,
      continue: !n.abort
    }), _ > f && d.issues.push({
      origin: "number",
      input: _,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: o,
      continue: !n.abort
    });
  };
}), $b = /* @__PURE__ */ I("$ZodCheckMaxLength", (o, n) => {
  var r;
  Ce.init(o, n), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    n.maximum < u && (a._zod.bag.maximum = n.maximum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length <= n.maximum)
      return;
    const d = Oi(u);
    a.issues.push({
      origin: d,
      code: "too_big",
      maximum: n.maximum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !n.abort
    });
  };
}), Kb = /* @__PURE__ */ I("$ZodCheckMinLength", (o, n) => {
  var r;
  Ce.init(o, n), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    n.minimum > u && (a._zod.bag.minimum = n.minimum);
  }), o._zod.check = (a) => {
    const u = a.value;
    if (u.length >= n.minimum)
      return;
    const d = Oi(u);
    a.issues.push({
      origin: d,
      code: "too_small",
      minimum: n.minimum,
      inclusive: !0,
      input: u,
      inst: o,
      continue: !n.abort
    });
  };
}), qb = /* @__PURE__ */ I("$ZodCheckLengthEquals", (o, n) => {
  var r;
  Ce.init(o, n), (r = o._zod.def).when ?? (r.when = (a) => {
    const u = a.value;
    return !Pi(u) && u.length !== void 0;
  }), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.minimum = n.length, u.maximum = n.length, u.length = n.length;
  }), o._zod.check = (a) => {
    const u = a.value, f = u.length;
    if (f === n.length)
      return;
    const d = Oi(u), _ = f > n.length;
    a.issues.push({
      origin: d,
      ..._ ? { code: "too_big", maximum: n.length } : { code: "too_small", minimum: n.length },
      inclusive: !0,
      exact: !0,
      input: a.value,
      inst: o,
      continue: !n.abort
    });
  };
}), Xn = /* @__PURE__ */ I("$ZodCheckStringFormat", (o, n) => {
  var r, a;
  Ce.init(o, n), o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = n.format, n.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(n.pattern));
  }), n.pattern ? (r = o._zod).check ?? (r.check = (u) => {
    n.pattern.lastIndex = 0, !n.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: n.format,
      input: u.value,
      ...n.pattern ? { pattern: n.pattern.toString() } : {},
      inst: o,
      continue: !n.abort
    });
  }) : (a = o._zod).check ?? (a.check = () => {
  });
}), Hb = /* @__PURE__ */ I("$ZodCheckRegex", (o, n) => {
  Xn.init(o, n), o._zod.check = (r) => {
    n.pattern.lastIndex = 0, !n.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: r.value,
      pattern: n.pattern.toString(),
      inst: o,
      continue: !n.abort
    });
  };
}), Wb = /* @__PURE__ */ I("$ZodCheckLowerCase", (o, n) => {
  n.pattern ?? (n.pattern = zb), Xn.init(o, n);
}), Vb = /* @__PURE__ */ I("$ZodCheckUpperCase", (o, n) => {
  n.pattern ?? (n.pattern = Gb), Xn.init(o, n);
}), Jb = /* @__PURE__ */ I("$ZodCheckIncludes", (o, n) => {
  Ce.init(o, n);
  const r = _t(n.includes), a = new RegExp(typeof n.position == "number" ? `^.{${n.position}}${r}` : r);
  n.pattern = a, o._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(a);
  }), o._zod.check = (u) => {
    u.value.includes(n.includes, n.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: n.includes,
      input: u.value,
      inst: o,
      continue: !n.abort
    });
  };
}), jb = /* @__PURE__ */ I("$ZodCheckStartsWith", (o, n) => {
  Ce.init(o, n);
  const r = new RegExp(`^${_t(n.prefix)}.*`);
  n.pattern ?? (n.pattern = r), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), o._zod.check = (a) => {
    a.value.startsWith(n.prefix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: n.prefix,
      input: a.value,
      inst: o,
      continue: !n.abort
    });
  };
}), Yb = /* @__PURE__ */ I("$ZodCheckEndsWith", (o, n) => {
  Ce.init(o, n);
  const r = new RegExp(`.*${_t(n.suffix)}$`);
  n.pattern ?? (n.pattern = r), o._zod.onattach.push((a) => {
    const u = a._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), o._zod.check = (a) => {
    a.value.endsWith(n.suffix) || a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: n.suffix,
      input: a.value,
      inst: o,
      continue: !n.abort
    });
  };
}), Xb = /* @__PURE__ */ I("$ZodCheckOverwrite", (o, n) => {
  Ce.init(o, n), o._zod.check = (r) => {
    r.value = n.tx(r.value);
  };
});
class Qb {
  constructor(n = []) {
    this.content = [], this.indent = 0, this && (this.args = n);
  }
  indented(n) {
    this.indent += 1, n(this), this.indent -= 1;
  }
  write(n) {
    if (typeof n == "function") {
      n(this, { execution: "sync" }), n(this, { execution: "async" });
      return;
    }
    const a = n.split(`
`).filter((d) => d), u = Math.min(...a.map((d) => d.length - d.trimStart().length)), f = a.map((d) => d.slice(u)).map((d) => " ".repeat(this.indent * 2) + d);
    for (const d of f)
      this.content.push(d);
  }
  compile() {
    const n = Function, r = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new n(...r, u.join(`
`));
  }
}
const eA = {
  major: 4,
  minor: 3,
  patch: 6
}, ce = /* @__PURE__ */ I("$ZodType", (o, n) => {
  var r;
  o ?? (o = {}), o._zod.def = n, o._zod.bag = o._zod.bag || {}, o._zod.version = eA;
  const a = [...o._zod.def.checks ?? []];
  o._zod.traits.has("$ZodCheck") && a.unshift(o);
  for (const u of a)
    for (const f of u._zod.onattach)
      f(o);
  if (a.length === 0)
    (r = o._zod).deferred ?? (r.deferred = []), o._zod.deferred?.push(() => {
      o._zod.run = o._zod.parse;
    });
  else {
    const u = (d, _, T) => {
      let v = ft(d), w;
      for (const z of _) {
        if (z._zod.def.when) {
          if (!z._zod.def.when(d))
            continue;
        } else if (v)
          continue;
        const B = d.issues.length, R = z._zod.check(d);
        if (R instanceof Promise && T?.async === !1)
          throw new mt();
        if (w || R instanceof Promise)
          w = (w ?? Promise.resolve()).then(async () => {
            await R, d.issues.length !== B && (v || (v = ft(d, B)));
          });
        else {
          if (d.issues.length === B)
            continue;
          v || (v = ft(d, B));
        }
      }
      return w ? w.then(() => d) : d;
    }, f = (d, _, T) => {
      if (ft(d))
        return d.aborted = !0, d;
      const v = u(_, a, T);
      if (v instanceof Promise) {
        if (T.async === !1)
          throw new mt();
        return v.then((w) => o._zod.parse(w, T));
      }
      return o._zod.parse(v, T);
    };
    o._zod.run = (d, _) => {
      if (_.skipChecks)
        return o._zod.parse(d, _);
      if (_.direction === "backward") {
        const v = o._zod.parse({ value: d.value, issues: [] }, { ..._, skipChecks: !0 });
        return v instanceof Promise ? v.then((w) => f(w, d, _)) : f(v, d, _);
      }
      const T = o._zod.parse(d, _);
      if (T instanceof Promise) {
        if (_.async === !1)
          throw new mt();
        return T.then((v) => u(v, a, _));
      }
      return u(T, a, _);
    };
  }
  j(o, "~standard", () => ({
    validate: (u) => {
      try {
        const f = ab(o, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return sb(o, u).then((d) => d.success ? { value: d.data } : { issues: d.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Ui = /* @__PURE__ */ I("$ZodString", (o, n) => {
  ce.init(o, n), o._zod.pattern = [...o?._zod.bag?.patterns ?? []].pop() ?? Pb(o._zod.bag), o._zod.parse = (r, a) => {
    if (n.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: o
    }), r;
  };
}), ne = /* @__PURE__ */ I("$ZodStringFormat", (o, n) => {
  Xn.init(o, n), Ui.init(o, n);
}), oA = /* @__PURE__ */ I("$ZodGUID", (o, n) => {
  n.pattern ?? (n.pattern = Ib), ne.init(o, n);
}), tA = /* @__PURE__ */ I("$ZodUUID", (o, n) => {
  if (n.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[n.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${n.version}"`);
    n.pattern ?? (n.pattern = Fu(a));
  } else
    n.pattern ?? (n.pattern = Fu());
  ne.init(o, n);
}), nA = /* @__PURE__ */ I("$ZodEmail", (o, n) => {
  n.pattern ?? (n.pattern = xb), ne.init(o, n);
}), rA = /* @__PURE__ */ I("$ZodURL", (o, n) => {
  ne.init(o, n), o._zod.check = (r) => {
    try {
      const a = r.value.trim(), u = new URL(a);
      n.hostname && (n.hostname.lastIndex = 0, n.hostname.test(u.hostname) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: n.hostname.source,
        input: r.value,
        inst: o,
        continue: !n.abort
      })), n.protocol && (n.protocol.lastIndex = 0, n.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || r.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: n.protocol.source,
        input: r.value,
        inst: o,
        continue: !n.abort
      })), n.normalize ? r.value = u.href : r.value = a;
      return;
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "url",
        input: r.value,
        inst: o,
        continue: !n.abort
      });
    }
  };
}), iA = /* @__PURE__ */ I("$ZodEmoji", (o, n) => {
  n.pattern ?? (n.pattern = vb()), ne.init(o, n);
}), aA = /* @__PURE__ */ I("$ZodNanoID", (o, n) => {
  n.pattern ?? (n.pattern = Tb), ne.init(o, n);
}), sA = /* @__PURE__ */ I("$ZodCUID", (o, n) => {
  n.pattern ?? (n.pattern = _b), ne.init(o, n);
}), uA = /* @__PURE__ */ I("$ZodCUID2", (o, n) => {
  n.pattern ?? (n.pattern = bb), ne.init(o, n);
}), lA = /* @__PURE__ */ I("$ZodULID", (o, n) => {
  n.pattern ?? (n.pattern = Ab), ne.init(o, n);
}), cA = /* @__PURE__ */ I("$ZodXID", (o, n) => {
  n.pattern ?? (n.pattern = gb), ne.init(o, n);
}), dA = /* @__PURE__ */ I("$ZodKSUID", (o, n) => {
  n.pattern ?? (n.pattern = yb), ne.init(o, n);
}), pA = /* @__PURE__ */ I("$ZodISODateTime", (o, n) => {
  n.pattern ?? (n.pattern = Lb(n)), ne.init(o, n);
}), fA = /* @__PURE__ */ I("$ZodISODate", (o, n) => {
  n.pattern ?? (n.pattern = kb), ne.init(o, n);
}), hA = /* @__PURE__ */ I("$ZodISOTime", (o, n) => {
  n.pattern ?? (n.pattern = Db(n)), ne.init(o, n);
}), mA = /* @__PURE__ */ I("$ZodISODuration", (o, n) => {
  n.pattern ?? (n.pattern = Mb), ne.init(o, n);
}), _A = /* @__PURE__ */ I("$ZodIPv4", (o, n) => {
  n.pattern ?? (n.pattern = Nb), ne.init(o, n), o._zod.bag.format = "ipv4";
}), bA = /* @__PURE__ */ I("$ZodIPv6", (o, n) => {
  n.pattern ?? (n.pattern = Fb), ne.init(o, n), o._zod.bag.format = "ipv6", o._zod.check = (r) => {
    try {
      new URL(`http://[${r.value}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: r.value,
        inst: o,
        continue: !n.abort
      });
    }
  };
}), AA = /* @__PURE__ */ I("$ZodCIDRv4", (o, n) => {
  n.pattern ?? (n.pattern = wb), ne.init(o, n);
}), gA = /* @__PURE__ */ I("$ZodCIDRv6", (o, n) => {
  n.pattern ?? (n.pattern = Cb), ne.init(o, n), o._zod.check = (r) => {
    const a = r.value.split("/");
    try {
      if (a.length !== 2)
        throw new Error();
      const [u, f] = a;
      if (!f)
        throw new Error();
      const d = Number(f);
      if (`${d}` !== f)
        throw new Error();
      if (d < 0 || d > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      r.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: r.value,
        inst: o,
        continue: !n.abort
      });
    }
  };
});
function fl(o) {
  if (o === "")
    return !0;
  if (o.length % 4 !== 0)
    return !1;
  try {
    return atob(o), !0;
  } catch {
    return !1;
  }
}
const yA = /* @__PURE__ */ I("$ZodBase64", (o, n) => {
  n.pattern ?? (n.pattern = Eb), ne.init(o, n), o._zod.bag.contentEncoding = "base64", o._zod.check = (r) => {
    fl(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64",
      input: r.value,
      inst: o,
      continue: !n.abort
    });
  };
});
function TA(o) {
  if (!sl.test(o))
    return !1;
  const n = o.replace(/[-_]/g, (a) => a === "-" ? "+" : "/"), r = n.padEnd(Math.ceil(n.length / 4) * 4, "=");
  return fl(r);
}
const MA = /* @__PURE__ */ I("$ZodBase64URL", (o, n) => {
  n.pattern ?? (n.pattern = sl), ne.init(o, n), o._zod.bag.contentEncoding = "base64url", o._zod.check = (r) => {
    TA(r.value) || r.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: r.value,
      inst: o,
      continue: !n.abort
    });
  };
}), IA = /* @__PURE__ */ I("$ZodE164", (o, n) => {
  n.pattern ?? (n.pattern = Bb), ne.init(o, n);
});
function xA(o, n = null) {
  try {
    const r = o.split(".");
    if (r.length !== 3)
      return !1;
    const [a] = r;
    if (!a)
      return !1;
    const u = JSON.parse(atob(a));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || n && (!("alg" in u) || u.alg !== n));
  } catch {
    return !1;
  }
}
const SA = /* @__PURE__ */ I("$ZodJWT", (o, n) => {
  ne.init(o, n), o._zod.check = (r) => {
    xA(r.value, n.alg) || r.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: r.value,
      inst: o,
      continue: !n.abort
    });
  };
}), hl = /* @__PURE__ */ I("$ZodNumber", (o, n) => {
  ce.init(o, n), o._zod.pattern = o._zod.bag.pattern ?? Ob, o._zod.parse = (r, a) => {
    if (n.coerce)
      try {
        r.value = Number(r.value);
      } catch {
      }
    const u = r.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return r;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return r.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: o,
      ...f ? { received: f } : {}
    }), r;
  };
}), vA = /* @__PURE__ */ I("$ZodNumberFormat", (o, n) => {
  Zb.init(o, n), hl.init(o, n);
}), NA = /* @__PURE__ */ I("$ZodUnknown", (o, n) => {
  ce.init(o, n), o._zod.parse = (r) => r;
}), FA = /* @__PURE__ */ I("$ZodNever", (o, n) => {
  ce.init(o, n), o._zod.parse = (r, a) => (r.issues.push({
    expected: "never",
    code: "invalid_type",
    input: r.value,
    inst: o
  }), r);
});
function wu(o, n, r) {
  o.issues.length && n.issues.push(...nl(r, o.issues)), n.value[r] = o.value;
}
const wA = /* @__PURE__ */ I("$ZodArray", (o, n) => {
  ce.init(o, n), o._zod.parse = (r, a) => {
    const u = r.value;
    if (!Array.isArray(u))
      return r.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: o
      }), r;
    r.value = Array(u.length);
    const f = [];
    for (let d = 0; d < u.length; d++) {
      const _ = u[d], T = n.element._zod.run({
        value: _,
        issues: []
      }, a);
      T instanceof Promise ? f.push(T.then((v) => wu(v, r, d))) : wu(T, r, d);
    }
    return f.length ? Promise.all(f).then(() => r) : r;
  };
});
function Hn(o, n, r, a, u) {
  if (o.issues.length) {
    if (u && !(r in a))
      return;
    n.issues.push(...nl(r, o.issues));
  }
  o.value === void 0 ? r in a && (n.value[r] = void 0) : n.value[r] = o.value;
}
function ml(o) {
  const n = Object.keys(o.shape);
  for (const a of n)
    if (!o.shape?.[a]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${a}": expected a Zod schema`);
  const r = J0(o.shape);
  return {
    ...o,
    keys: n,
    keySet: new Set(n),
    numKeys: n.length,
    optionalKeys: new Set(r)
  };
}
function _l(o, n, r, a, u, f) {
  const d = [], _ = u.keySet, T = u.catchall._zod, v = T.def.type, w = T.optout === "optional";
  for (const z in n) {
    if (_.has(z))
      continue;
    if (v === "never") {
      d.push(z);
      continue;
    }
    const B = T.run({ value: n[z], issues: [] }, a);
    B instanceof Promise ? o.push(B.then((R) => Hn(R, r, z, n, w))) : Hn(B, r, z, n, w);
  }
  return d.length && r.issues.push({
    code: "unrecognized_keys",
    keys: d,
    input: n,
    inst: f
  }), o.length ? Promise.all(o).then(() => r) : r;
}
const CA = /* @__PURE__ */ I("$ZodObject", (o, n) => {
  if (ce.init(o, n), !Object.getOwnPropertyDescriptor(n, "shape")?.get) {
    const _ = n.shape;
    Object.defineProperty(n, "shape", {
      get: () => {
        const T = { ..._ };
        return Object.defineProperty(n, "shape", {
          value: T
        }), T;
      }
    });
  }
  const a = Li(() => ml(n));
  j(o._zod, "propValues", () => {
    const _ = n.shape, T = {};
    for (const v in _) {
      const w = _[v]._zod;
      if (w.values) {
        T[v] ?? (T[v] = /* @__PURE__ */ new Set());
        for (const z of w.values)
          T[v].add(z);
      }
    }
    return T;
  });
  const u = qn, f = n.catchall;
  let d;
  o._zod.parse = (_, T) => {
    d ?? (d = a.value);
    const v = _.value;
    if (!u(v))
      return _.issues.push({
        expected: "object",
        code: "invalid_type",
        input: v,
        inst: o
      }), _;
    _.value = {};
    const w = [], z = d.shape;
    for (const B of d.keys) {
      const R = z[B], ae = R._zod.optout === "optional", ee = R._zod.run({ value: v[B], issues: [] }, T);
      ee instanceof Promise ? w.push(ee.then((uo) => Hn(uo, _, B, v, ae))) : Hn(ee, _, B, v, ae);
    }
    return f ? _l(w, v, _, T, a.value, o) : w.length ? Promise.all(w).then(() => _) : _;
  };
}), EA = /* @__PURE__ */ I("$ZodObjectJIT", (o, n) => {
  CA.init(o, n);
  const r = o._zod.parse, a = Li(() => ml(n)), u = (B) => {
    const R = new Qb(["shape", "payload", "ctx"]), ae = a.value, ee = (Be) => {
      const oe = Nu(Be);
      return `shape[${oe}]._zod.run({ value: input[${oe}], issues: [] }, ctx)`;
    };
    R.write("const input = payload.value;");
    const uo = /* @__PURE__ */ Object.create(null);
    let Ee = 0;
    for (const Be of ae.keys)
      uo[Be] = `key_${Ee++}`;
    R.write("const newResult = {};");
    for (const Be of ae.keys) {
      const oe = uo[Be], me = Nu(Be), Po = B[Be]?._zod?.optout === "optional";
      R.write(`const ${oe} = ${ee(Be)};`), Po ? R.write(`
        if (${oe}.issues.length) {
          if (${me} in input) {
            payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${me}, ...iss.path] : [${me}]
            })));
          }
        }
        
        if (${oe}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${oe}.value;
        }
        
      `) : R.write(`
        if (${oe}.issues.length) {
          payload.issues = payload.issues.concat(${oe}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${me}, ...iss.path] : [${me}]
          })));
        }
        
        if (${oe}.value === undefined) {
          if (${me} in input) {
            newResult[${me}] = undefined;
          }
        } else {
          newResult[${me}] = ${oe}.value;
        }
        
      `);
    }
    R.write("payload.value = newResult;"), R.write("return payload;");
    const To = R.compile();
    return (Be, oe) => To(B, Be, oe);
  };
  let f;
  const d = qn, _ = !Qu.jitless, v = _ && W0.value, w = n.catchall;
  let z;
  o._zod.parse = (B, R) => {
    z ?? (z = a.value);
    const ae = B.value;
    return d(ae) ? _ && v && R?.async === !1 && R.jitless !== !0 ? (f || (f = u(n.shape)), B = f(B, R), w ? _l([], ae, B, R, z, o) : B) : r(B, R) : (B.issues.push({
      expected: "object",
      code: "invalid_type",
      input: ae,
      inst: o
    }), B);
  };
});
function Cu(o, n, r, a) {
  for (const f of o)
    if (f.issues.length === 0)
      return n.value = f.value, n;
  const u = o.filter((f) => !ft(f));
  return u.length === 1 ? (n.value = u[0].value, u[0]) : (n.issues.push({
    code: "invalid_union",
    input: n.value,
    inst: r,
    errors: o.map((f) => f.issues.map((d) => Jo(d, a, Vo())))
  }), n);
}
const BA = /* @__PURE__ */ I("$ZodUnion", (o, n) => {
  ce.init(o, n), j(o._zod, "optin", () => n.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), j(o._zod, "optout", () => n.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), j(o._zod, "values", () => {
    if (n.options.every((u) => u._zod.values))
      return new Set(n.options.flatMap((u) => Array.from(u._zod.values)));
  }), j(o._zod, "pattern", () => {
    if (n.options.every((u) => u._zod.pattern)) {
      const u = n.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => Ri(f.source)).join("|")})$`);
    }
  });
  const r = n.options.length === 1, a = n.options[0]._zod.run;
  o._zod.parse = (u, f) => {
    if (r)
      return a(u, f);
    let d = !1;
    const _ = [];
    for (const T of n.options) {
      const v = T._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (v instanceof Promise)
        _.push(v), d = !0;
      else {
        if (v.issues.length === 0)
          return v;
        _.push(v);
      }
    }
    return d ? Promise.all(_).then((T) => Cu(T, u, o, f)) : Cu(_, u, o, f);
  };
}), kA = /* @__PURE__ */ I("$ZodIntersection", (o, n) => {
  ce.init(o, n), o._zod.parse = (r, a) => {
    const u = r.value, f = n.left._zod.run({ value: u, issues: [] }, a), d = n.right._zod.run({ value: u, issues: [] }, a);
    return f instanceof Promise || d instanceof Promise ? Promise.all([f, d]).then(([T, v]) => Eu(r, T, v)) : Eu(r, f, d);
  };
});
function wi(o, n) {
  if (o === n)
    return { valid: !0, data: o };
  if (o instanceof Date && n instanceof Date && +o == +n)
    return { valid: !0, data: o };
  if (Wt(o) && Wt(n)) {
    const r = Object.keys(n), a = Object.keys(o).filter((f) => r.indexOf(f) !== -1), u = { ...o, ...n };
    for (const f of a) {
      const d = wi(o[f], n[f]);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...d.mergeErrorPath]
        };
      u[f] = d.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(o) && Array.isArray(n)) {
    if (o.length !== n.length)
      return { valid: !1, mergeErrorPath: [] };
    const r = [];
    for (let a = 0; a < o.length; a++) {
      const u = o[a], f = n[a], d = wi(u, f);
      if (!d.valid)
        return {
          valid: !1,
          mergeErrorPath: [a, ...d.mergeErrorPath]
        };
      r.push(d.data);
    }
    return { valid: !0, data: r };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Eu(o, n, r) {
  const a = /* @__PURE__ */ new Map();
  let u;
  for (const _ of n.issues)
    if (_.code === "unrecognized_keys") {
      u ?? (u = _);
      for (const T of _.keys)
        a.has(T) || a.set(T, {}), a.get(T).l = !0;
    } else
      o.issues.push(_);
  for (const _ of r.issues)
    if (_.code === "unrecognized_keys")
      for (const T of _.keys)
        a.has(T) || a.set(T, {}), a.get(T).r = !0;
    else
      o.issues.push(_);
  const f = [...a].filter(([, _]) => _.l && _.r).map(([_]) => _);
  if (f.length && u && o.issues.push({ ...u, keys: f }), ft(o))
    return o;
  const d = wi(n.value, r.value);
  if (!d.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(d.mergeErrorPath)}`);
  return o.value = d.data, o;
}
const DA = /* @__PURE__ */ I("$ZodEnum", (o, n) => {
  ce.init(o, n);
  const r = el(n.entries), a = new Set(r);
  o._zod.values = a, o._zod.pattern = new RegExp(`^(${r.filter((u) => V0.has(typeof u)).map((u) => typeof u == "string" ? _t(u) : u.toString()).join("|")})$`), o._zod.parse = (u, f) => {
    const d = u.value;
    return a.has(d) || u.issues.push({
      code: "invalid_value",
      values: r,
      input: d,
      inst: o
    }), u;
  };
}), LA = /* @__PURE__ */ I("$ZodLiteral", (o, n) => {
  if (ce.init(o, n), n.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const r = new Set(n.values);
  o._zod.values = r, o._zod.pattern = new RegExp(`^(${n.values.map((a) => typeof a == "string" ? _t(a) : a ? _t(a.toString()) : String(a)).join("|")})$`), o._zod.parse = (a, u) => {
    const f = a.value;
    return r.has(f) || a.issues.push({
      code: "invalid_value",
      values: n.values,
      input: f,
      inst: o
    }), a;
  };
}), PA = /* @__PURE__ */ I("$ZodTransform", (o, n) => {
  ce.init(o, n), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new Xu(o.constructor.name);
    const u = n.transform(r.value, r);
    if (a.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((d) => (r.value = d, r));
    if (u instanceof Promise)
      throw new mt();
    return r.value = u, r;
  };
});
function Bu(o, n) {
  return o.issues.length && n === void 0 ? { issues: [], value: void 0 } : o;
}
const bl = /* @__PURE__ */ I("$ZodOptional", (o, n) => {
  ce.init(o, n), o._zod.optin = "optional", o._zod.optout = "optional", j(o._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, void 0]) : void 0), j(o._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${Ri(r.source)})?$`) : void 0;
  }), o._zod.parse = (r, a) => {
    if (n.innerType._zod.optin === "optional") {
      const u = n.innerType._zod.run(r, a);
      return u instanceof Promise ? u.then((f) => Bu(f, r.value)) : Bu(u, r.value);
    }
    return r.value === void 0 ? r : n.innerType._zod.run(r, a);
  };
}), RA = /* @__PURE__ */ I("$ZodExactOptional", (o, n) => {
  bl.init(o, n), j(o._zod, "values", () => n.innerType._zod.values), j(o._zod, "pattern", () => n.innerType._zod.pattern), o._zod.parse = (r, a) => n.innerType._zod.run(r, a);
}), OA = /* @__PURE__ */ I("$ZodNullable", (o, n) => {
  ce.init(o, n), j(o._zod, "optin", () => n.innerType._zod.optin), j(o._zod, "optout", () => n.innerType._zod.optout), j(o._zod, "pattern", () => {
    const r = n.innerType._zod.pattern;
    return r ? new RegExp(`^(${Ri(r.source)}|null)$`) : void 0;
  }), j(o._zod, "values", () => n.innerType._zod.values ? /* @__PURE__ */ new Set([...n.innerType._zod.values, null]) : void 0), o._zod.parse = (r, a) => r.value === null ? r : n.innerType._zod.run(r, a);
}), zA = /* @__PURE__ */ I("$ZodDefault", (o, n) => {
  ce.init(o, n), o._zod.optin = "optional", j(o._zod, "values", () => n.innerType._zod.values), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return n.innerType._zod.run(r, a);
    if (r.value === void 0)
      return r.value = n.defaultValue, r;
    const u = n.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => ku(f, n)) : ku(u, n);
  };
});
function ku(o, n) {
  return o.value === void 0 && (o.value = n.defaultValue), o;
}
const GA = /* @__PURE__ */ I("$ZodPrefault", (o, n) => {
  ce.init(o, n), o._zod.optin = "optional", j(o._zod, "values", () => n.innerType._zod.values), o._zod.parse = (r, a) => (a.direction === "backward" || r.value === void 0 && (r.value = n.defaultValue), n.innerType._zod.run(r, a));
}), UA = /* @__PURE__ */ I("$ZodNonOptional", (o, n) => {
  ce.init(o, n), j(o._zod, "values", () => {
    const r = n.innerType._zod.values;
    return r ? new Set([...r].filter((a) => a !== void 0)) : void 0;
  }), o._zod.parse = (r, a) => {
    const u = n.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => Du(f, o)) : Du(u, o);
  };
});
function Du(o, n) {
  return !o.issues.length && o.value === void 0 && o.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: o.value,
    inst: n
  }), o;
}
const ZA = /* @__PURE__ */ I("$ZodCatch", (o, n) => {
  ce.init(o, n), j(o._zod, "optin", () => n.innerType._zod.optin), j(o._zod, "optout", () => n.innerType._zod.optout), j(o._zod, "values", () => n.innerType._zod.values), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return n.innerType._zod.run(r, a);
    const u = n.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => (r.value = f.value, f.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: f.issues.map((d) => Jo(d, a, Vo()))
      },
      input: r.value
    }), r.issues = []), r)) : (r.value = u.value, u.issues.length && (r.value = n.catchValue({
      ...r,
      error: {
        issues: u.issues.map((f) => Jo(f, a, Vo()))
      },
      input: r.value
    }), r.issues = []), r);
  };
}), $A = /* @__PURE__ */ I("$ZodPipe", (o, n) => {
  ce.init(o, n), j(o._zod, "values", () => n.in._zod.values), j(o._zod, "optin", () => n.in._zod.optin), j(o._zod, "optout", () => n.out._zod.optout), j(o._zod, "propValues", () => n.in._zod.propValues), o._zod.parse = (r, a) => {
    if (a.direction === "backward") {
      const f = n.out._zod.run(r, a);
      return f instanceof Promise ? f.then((d) => $n(d, n.in, a)) : $n(f, n.in, a);
    }
    const u = n.in._zod.run(r, a);
    return u instanceof Promise ? u.then((f) => $n(f, n.out, a)) : $n(u, n.out, a);
  };
});
function $n(o, n, r) {
  return o.issues.length ? (o.aborted = !0, o) : n._zod.run({ value: o.value, issues: o.issues }, r);
}
const KA = /* @__PURE__ */ I("$ZodReadonly", (o, n) => {
  ce.init(o, n), j(o._zod, "propValues", () => n.innerType._zod.propValues), j(o._zod, "values", () => n.innerType._zod.values), j(o._zod, "optin", () => n.innerType?._zod?.optin), j(o._zod, "optout", () => n.innerType?._zod?.optout), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      return n.innerType._zod.run(r, a);
    const u = n.innerType._zod.run(r, a);
    return u instanceof Promise ? u.then(Lu) : Lu(u);
  };
});
function Lu(o) {
  return o.value = Object.freeze(o.value), o;
}
const qA = /* @__PURE__ */ I("$ZodCustom", (o, n) => {
  Ce.init(o, n), ce.init(o, n), o._zod.parse = (r, a) => r, o._zod.check = (r) => {
    const a = r.value, u = n.fn(a);
    if (u instanceof Promise)
      return u.then((f) => Pu(f, r, a, o));
    Pu(u, r, a, o);
  };
});
function Pu(o, n, r, a) {
  if (!o) {
    const u = {
      code: "custom",
      input: r,
      inst: a,
      // incorporates params.error into issue reporting
      path: [...a._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !a._zod.def.abort
      // params: inst._zod.def.params,
    };
    a._zod.def.params && (u.params = a._zod.def.params), n.issues.push(Vt(u));
  }
}
var Ru;
class HA {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(n, ...r) {
    const a = r[0];
    return this._map.set(n, a), a && typeof a == "object" && "id" in a && this._idmap.set(a.id, n), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(n) {
    const r = this._map.get(n);
    return r && typeof r == "object" && "id" in r && this._idmap.delete(r.id), this._map.delete(n), this;
  }
  get(n) {
    const r = n._zod.parent;
    if (r) {
      const a = { ...this.get(r) ?? {} };
      delete a.id;
      const u = { ...a, ...this._map.get(n) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(n);
  }
  has(n) {
    return this._map.has(n);
  }
}
function WA() {
  return new HA();
}
(Ru = globalThis).__zod_globalRegistry ?? (Ru.__zod_globalRegistry = WA());
const $t = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function VA(o, n) {
  return new o({
    type: "string",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function JA(o, n) {
  return new o({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Ou(o, n) {
  return new o({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Al(o, n) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function jA(o, n) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function YA(o, n) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function XA(o, n) {
  return new o({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function QA(o, n) {
  return new o({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function eg(o, n) {
  return new o({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function og(o, n) {
  return new o({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function tg(o, n) {
  return new o({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ng(o, n) {
  return new o({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function rg(o, n) {
  return new o({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ig(o, n) {
  return new o({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ag(o, n) {
  return new o({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function sg(o, n) {
  return new o({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function ug(o, n) {
  return new o({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function lg(o, n) {
  return new o({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function cg(o, n) {
  return new o({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function dg(o, n) {
  return new o({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function pg(o, n) {
  return new o({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function fg(o, n) {
  return new o({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function hg(o, n) {
  return new o({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function mg(o, n) {
  return new o({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function _g(o, n) {
  return new o({
    type: "string",
    format: "date",
    check: "string_format",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function bg(o, n) {
  return new o({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Ag(o, n) {
  return new o({
    type: "string",
    format: "duration",
    check: "string_format",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function gg(o, n) {
  return new o({
    type: "number",
    checks: [],
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function yg(o, n) {
  return new o({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Tg(o) {
  return new o({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Mg(o, n) {
  return new o({
    type: "never",
    ...k(n)
  });
}
// @__NO_SIDE_EFFECTS__
function zu(o, n) {
  return new dl({
    check: "less_than",
    ...k(n),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Si(o, n) {
  return new dl({
    check: "less_than",
    ...k(n),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Gu(o, n) {
  return new pl({
    check: "greater_than",
    ...k(n),
    value: o,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function vi(o, n) {
  return new pl({
    check: "greater_than",
    ...k(n),
    value: o,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Uu(o, n) {
  return new Ub({
    check: "multiple_of",
    ...k(n),
    value: o
  });
}
// @__NO_SIDE_EFFECTS__
function gl(o, n) {
  return new $b({
    check: "max_length",
    ...k(n),
    maximum: o
  });
}
// @__NO_SIDE_EFFECTS__
function Wn(o, n) {
  return new Kb({
    check: "min_length",
    ...k(n),
    minimum: o
  });
}
// @__NO_SIDE_EFFECTS__
function yl(o, n) {
  return new qb({
    check: "length_equals",
    ...k(n),
    length: o
  });
}
// @__NO_SIDE_EFFECTS__
function Ig(o, n) {
  return new Hb({
    check: "string_format",
    format: "regex",
    ...k(n),
    pattern: o
  });
}
// @__NO_SIDE_EFFECTS__
function xg(o) {
  return new Wb({
    check: "string_format",
    format: "lowercase",
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function Sg(o) {
  return new Vb({
    check: "string_format",
    format: "uppercase",
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function vg(o, n) {
  return new Jb({
    check: "string_format",
    format: "includes",
    ...k(n),
    includes: o
  });
}
// @__NO_SIDE_EFFECTS__
function Ng(o, n) {
  return new jb({
    check: "string_format",
    format: "starts_with",
    ...k(n),
    prefix: o
  });
}
// @__NO_SIDE_EFFECTS__
function Fg(o, n) {
  return new Yb({
    check: "string_format",
    format: "ends_with",
    ...k(n),
    suffix: o
  });
}
// @__NO_SIDE_EFFECTS__
function gt(o) {
  return new Xb({
    check: "overwrite",
    tx: o
  });
}
// @__NO_SIDE_EFFECTS__
function wg(o) {
  return /* @__PURE__ */ gt((n) => n.normalize(o));
}
// @__NO_SIDE_EFFECTS__
function Cg() {
  return /* @__PURE__ */ gt((o) => o.trim());
}
// @__NO_SIDE_EFFECTS__
function Eg() {
  return /* @__PURE__ */ gt((o) => o.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Bg() {
  return /* @__PURE__ */ gt((o) => o.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function kg() {
  return /* @__PURE__ */ gt((o) => H0(o));
}
// @__NO_SIDE_EFFECTS__
function Dg(o, n, r) {
  return new o({
    type: "array",
    element: n,
    // get element() {
    //   return element;
    // },
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Lg(o, n, r) {
  return new o({
    type: "custom",
    check: "custom",
    fn: n,
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function Pg(o) {
  const n = /* @__PURE__ */ Rg((r) => (r.addIssue = (a) => {
    if (typeof a == "string")
      r.issues.push(Vt(a, r.value, n._zod.def));
    else {
      const u = a;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = r.value), u.inst ?? (u.inst = n), u.continue ?? (u.continue = !n._zod.def.abort), r.issues.push(Vt(u));
    }
  }, o(r.value, r)));
  return n;
}
// @__NO_SIDE_EFFECTS__
function Rg(o, n) {
  const r = new Ce({
    check: "custom",
    ...k(n)
  });
  return r._zod.check = o, r;
}
function Tl(o) {
  let n = o?.target ?? "draft-2020-12";
  return n === "draft-4" && (n = "draft-04"), n === "draft-7" && (n = "draft-07"), {
    processors: o.processors ?? {},
    metadataRegistry: o?.metadata ?? $t,
    target: n,
    unrepresentable: o?.unrepresentable ?? "throw",
    override: o?.override ?? (() => {
    }),
    io: o?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: o?.cycles ?? "ref",
    reused: o?.reused ?? "inline",
    external: o?.external ?? void 0
  };
}
function Ae(o, n, r = { path: [], schemaPath: [] }) {
  var a;
  const u = o._zod.def, f = n.seen.get(o);
  if (f)
    return f.count++, r.schemaPath.includes(o) && (f.cycle = r.path), f.schema;
  const d = { schema: {}, count: 1, cycle: void 0, path: r.path };
  n.seen.set(o, d);
  const _ = o._zod.toJSONSchema?.();
  if (_)
    d.schema = _;
  else {
    const w = {
      ...r,
      schemaPath: [...r.schemaPath, o],
      path: r.path
    };
    if (o._zod.processJSONSchema)
      o._zod.processJSONSchema(n, d.schema, w);
    else {
      const B = d.schema, R = n.processors[u.type];
      if (!R)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      R(o, n, B, w);
    }
    const z = o._zod.parent;
    z && (d.ref || (d.ref = z), Ae(z, n, w), n.seen.get(z).isParent = !0);
  }
  const T = n.metadataRegistry.get(o);
  return T && Object.assign(d.schema, T), n.io === "input" && xe(o) && (delete d.schema.examples, delete d.schema.default), n.io === "input" && d.schema._prefault && ((a = d.schema).default ?? (a.default = d.schema._prefault)), delete d.schema._prefault, n.seen.get(o).schema;
}
function Ml(o, n) {
  const r = o.seen.get(n);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = /* @__PURE__ */ new Map();
  for (const d of o.seen.entries()) {
    const _ = o.metadataRegistry.get(d[0])?.id;
    if (_) {
      const T = a.get(_);
      if (T && T !== d[0])
        throw new Error(`Duplicate schema id "${_}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      a.set(_, d[0]);
    }
  }
  const u = (d) => {
    const _ = o.target === "draft-2020-12" ? "$defs" : "definitions";
    if (o.external) {
      const z = o.external.registry.get(d[0])?.id, B = o.external.uri ?? ((ae) => ae);
      if (z)
        return { ref: B(z) };
      const R = d[1].defId ?? d[1].schema.id ?? `schema${o.counter++}`;
      return d[1].defId = R, { defId: R, ref: `${B("__shared")}#/${_}/${R}` };
    }
    if (d[1] === r)
      return { ref: "#" };
    const v = `#/${_}/`, w = d[1].schema.id ?? `__schema${o.counter++}`;
    return { defId: w, ref: v + w };
  }, f = (d) => {
    if (d[1].schema.$ref)
      return;
    const _ = d[1], { ref: T, defId: v } = u(d);
    _.def = { ..._.schema }, v && (_.defId = v);
    const w = _.schema;
    for (const z in w)
      delete w[z];
    w.$ref = T;
  };
  if (o.cycles === "throw")
    for (const d of o.seen.entries()) {
      const _ = d[1];
      if (_.cycle)
        throw new Error(`Cycle detected: #/${_.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const d of o.seen.entries()) {
    const _ = d[1];
    if (n === d[0]) {
      f(d);
      continue;
    }
    if (o.external) {
      const v = o.external.registry.get(d[0])?.id;
      if (n !== d[0] && v) {
        f(d);
        continue;
      }
    }
    if (o.metadataRegistry.get(d[0])?.id) {
      f(d);
      continue;
    }
    if (_.cycle) {
      f(d);
      continue;
    }
    if (_.count > 1 && o.reused === "ref") {
      f(d);
      continue;
    }
  }
}
function Il(o, n) {
  const r = o.seen.get(n);
  if (!r)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (d) => {
    const _ = o.seen.get(d);
    if (_.ref === null)
      return;
    const T = _.def ?? _.schema, v = { ...T }, w = _.ref;
    if (_.ref = null, w) {
      a(w);
      const B = o.seen.get(w), R = B.schema;
      if (R.$ref && (o.target === "draft-07" || o.target === "draft-04" || o.target === "openapi-3.0") ? (T.allOf = T.allOf ?? [], T.allOf.push(R)) : Object.assign(T, R), Object.assign(T, v), d._zod.parent === w)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in v || delete T[ee];
      if (R.$ref && B.def)
        for (const ee in T)
          ee === "$ref" || ee === "allOf" || ee in B.def && JSON.stringify(T[ee]) === JSON.stringify(B.def[ee]) && delete T[ee];
    }
    const z = d._zod.parent;
    if (z && z !== w) {
      a(z);
      const B = o.seen.get(z);
      if (B?.schema.$ref && (T.$ref = B.schema.$ref, B.def))
        for (const R in T)
          R === "$ref" || R === "allOf" || R in B.def && JSON.stringify(T[R]) === JSON.stringify(B.def[R]) && delete T[R];
    }
    o.override({
      zodSchema: d,
      jsonSchema: T,
      path: _.path ?? []
    });
  };
  for (const d of [...o.seen.entries()].reverse())
    a(d[0]);
  const u = {};
  if (o.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : o.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : o.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : o.target, o.external?.uri) {
    const d = o.external.registry.get(n)?.id;
    if (!d)
      throw new Error("Schema is missing an `id` property");
    u.$id = o.external.uri(d);
  }
  Object.assign(u, r.def ?? r.schema);
  const f = o.external?.defs ?? {};
  for (const d of o.seen.entries()) {
    const _ = d[1];
    _.def && _.defId && (f[_.defId] = _.def);
  }
  o.external || Object.keys(f).length > 0 && (o.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const d = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(d, "~standard", {
      value: {
        ...n["~standard"],
        jsonSchema: {
          input: Vn(n, "input", o.processors),
          output: Vn(n, "output", o.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), d;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function xe(o, n) {
  const r = n ?? { seen: /* @__PURE__ */ new Set() };
  if (r.seen.has(o))
    return !1;
  r.seen.add(o);
  const a = o._zod.def;
  if (a.type === "transform")
    return !0;
  if (a.type === "array")
    return xe(a.element, r);
  if (a.type === "set")
    return xe(a.valueType, r);
  if (a.type === "lazy")
    return xe(a.getter(), r);
  if (a.type === "promise" || a.type === "optional" || a.type === "nonoptional" || a.type === "nullable" || a.type === "readonly" || a.type === "default" || a.type === "prefault")
    return xe(a.innerType, r);
  if (a.type === "intersection")
    return xe(a.left, r) || xe(a.right, r);
  if (a.type === "record" || a.type === "map")
    return xe(a.keyType, r) || xe(a.valueType, r);
  if (a.type === "pipe")
    return xe(a.in, r) || xe(a.out, r);
  if (a.type === "object") {
    for (const u in a.shape)
      if (xe(a.shape[u], r))
        return !0;
    return !1;
  }
  if (a.type === "union") {
    for (const u of a.options)
      if (xe(u, r))
        return !0;
    return !1;
  }
  if (a.type === "tuple") {
    for (const u of a.items)
      if (xe(u, r))
        return !0;
    return !!(a.rest && xe(a.rest, r));
  }
  return !1;
}
const Og = (o, n = {}) => (r) => {
  const a = Tl({ ...r, processors: n });
  return Ae(o, a), Ml(a, o), Il(a, o);
}, Vn = (o, n, r = {}) => (a) => {
  const { libraryOptions: u, target: f } = a ?? {}, d = Tl({ ...u ?? {}, target: f, io: n, processors: r });
  return Ae(o, d), Ml(d, o), Il(d, o);
}, zg = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, Gg = (o, n, r, a) => {
  const u = r;
  u.type = "string";
  const { minimum: f, maximum: d, format: _, patterns: T, contentEncoding: v } = o._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof d == "number" && (u.maxLength = d), _ && (u.format = zg[_] ?? _, u.format === "" && delete u.format, _ === "time" && delete u.format), v && (u.contentEncoding = v), T && T.size > 0) {
    const w = [...T];
    w.length === 1 ? u.pattern = w[0].source : w.length > 1 && (u.allOf = [
      ...w.map((z) => ({
        ...n.target === "draft-07" || n.target === "draft-04" || n.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: z.source
      }))
    ]);
  }
}, Ug = (o, n, r, a) => {
  const u = r, { minimum: f, maximum: d, format: _, multipleOf: T, exclusiveMaximum: v, exclusiveMinimum: w } = o._zod.bag;
  typeof _ == "string" && _.includes("int") ? u.type = "integer" : u.type = "number", typeof w == "number" && (n.target === "draft-04" || n.target === "openapi-3.0" ? (u.minimum = w, u.exclusiveMinimum = !0) : u.exclusiveMinimum = w), typeof f == "number" && (u.minimum = f, typeof w == "number" && n.target !== "draft-04" && (w >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof v == "number" && (n.target === "draft-04" || n.target === "openapi-3.0" ? (u.maximum = v, u.exclusiveMaximum = !0) : u.exclusiveMaximum = v), typeof d == "number" && (u.maximum = d, typeof v == "number" && n.target !== "draft-04" && (v <= d ? delete u.maximum : delete u.exclusiveMaximum)), typeof T == "number" && (u.multipleOf = T);
}, Zg = (o, n, r, a) => {
  r.not = {};
}, $g = (o, n, r, a) => {
}, Kg = (o, n, r, a) => {
  const u = o._zod.def, f = el(u.entries);
  f.every((d) => typeof d == "number") && (r.type = "number"), f.every((d) => typeof d == "string") && (r.type = "string"), r.enum = f;
}, qg = (o, n, r, a) => {
  const u = o._zod.def, f = [];
  for (const d of u.values)
    if (d === void 0) {
      if (n.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof d == "bigint") {
      if (n.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(d));
    } else
      f.push(d);
  if (f.length !== 0) if (f.length === 1) {
    const d = f[0];
    r.type = d === null ? "null" : typeof d, n.target === "draft-04" || n.target === "openapi-3.0" ? r.enum = [d] : r.const = d;
  } else
    f.every((d) => typeof d == "number") && (r.type = "number"), f.every((d) => typeof d == "string") && (r.type = "string"), f.every((d) => typeof d == "boolean") && (r.type = "boolean"), f.every((d) => d === null) && (r.type = "null"), r.enum = f;
}, Hg = (o, n, r, a) => {
  if (n.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Wg = (o, n, r, a) => {
  if (n.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Vg = (o, n, r, a) => {
  const u = r, f = o._zod.def, { minimum: d, maximum: _ } = o._zod.bag;
  typeof d == "number" && (u.minItems = d), typeof _ == "number" && (u.maxItems = _), u.type = "array", u.items = Ae(f.element, n, { ...a, path: [...a.path, "items"] });
}, Jg = (o, n, r, a) => {
  const u = r, f = o._zod.def;
  u.type = "object", u.properties = {};
  const d = f.shape;
  for (const v in d)
    u.properties[v] = Ae(d[v], n, {
      ...a,
      path: [...a.path, "properties", v]
    });
  const _ = new Set(Object.keys(d)), T = new Set([..._].filter((v) => {
    const w = f.shape[v]._zod;
    return n.io === "input" ? w.optin === void 0 : w.optout === void 0;
  }));
  T.size > 0 && (u.required = Array.from(T)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = Ae(f.catchall, n, {
    ...a,
    path: [...a.path, "additionalProperties"]
  })) : n.io === "output" && (u.additionalProperties = !1);
}, jg = (o, n, r, a) => {
  const u = o._zod.def, f = u.inclusive === !1, d = u.options.map((_, T) => Ae(_, n, {
    ...a,
    path: [...a.path, f ? "oneOf" : "anyOf", T]
  }));
  f ? r.oneOf = d : r.anyOf = d;
}, Yg = (o, n, r, a) => {
  const u = o._zod.def, f = Ae(u.left, n, {
    ...a,
    path: [...a.path, "allOf", 0]
  }), d = Ae(u.right, n, {
    ...a,
    path: [...a.path, "allOf", 1]
  }), _ = (v) => "allOf" in v && Object.keys(v).length === 1, T = [
    ..._(f) ? f.allOf : [f],
    ..._(d) ? d.allOf : [d]
  ];
  r.allOf = T;
}, Xg = (o, n, r, a) => {
  const u = o._zod.def, f = Ae(u.innerType, n, a), d = n.seen.get(o);
  n.target === "openapi-3.0" ? (d.ref = u.innerType, r.nullable = !0) : r.anyOf = [f, { type: "null" }];
}, Qg = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType;
}, e1 = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType, r.default = JSON.parse(JSON.stringify(u.defaultValue));
}, o1 = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType, n.io === "input" && (r._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, t1 = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType;
  let d;
  try {
    d = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  r.default = d;
}, n1 = (o, n, r, a) => {
  const u = o._zod.def, f = n.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  Ae(f, n, a);
  const d = n.seen.get(o);
  d.ref = f;
}, r1 = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType, r.readOnly = !0;
}, xl = (o, n, r, a) => {
  const u = o._zod.def;
  Ae(u.innerType, n, a);
  const f = n.seen.get(o);
  f.ref = u.innerType;
}, i1 = /* @__PURE__ */ I("ZodISODateTime", (o, n) => {
  pA.init(o, n), ie.init(o, n);
});
function a1(o) {
  return /* @__PURE__ */ mg(i1, o);
}
const s1 = /* @__PURE__ */ I("ZodISODate", (o, n) => {
  fA.init(o, n), ie.init(o, n);
});
function u1(o) {
  return /* @__PURE__ */ _g(s1, o);
}
const l1 = /* @__PURE__ */ I("ZodISOTime", (o, n) => {
  hA.init(o, n), ie.init(o, n);
});
function c1(o) {
  return /* @__PURE__ */ bg(l1, o);
}
const d1 = /* @__PURE__ */ I("ZodISODuration", (o, n) => {
  mA.init(o, n), ie.init(o, n);
});
function p1(o) {
  return /* @__PURE__ */ Ag(d1, o);
}
const f1 = (o, n) => {
  il.init(o, n), o.name = "ZodError", Object.defineProperties(o, {
    format: {
      value: (r) => ib(o, r)
      // enumerable: false,
    },
    flatten: {
      value: (r) => rb(o, r)
      // enumerable: false,
    },
    addIssue: {
      value: (r) => {
        o.issues.push(r), o.message = JSON.stringify(o.issues, Fi, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (r) => {
        o.issues.push(...r), o.message = JSON.stringify(o.issues, Fi, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return o.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = I("ZodError", f1, {
  Parent: Error
}), h1 = /* @__PURE__ */ zi(We), m1 = /* @__PURE__ */ Gi(We), _1 = /* @__PURE__ */ jn(We), b1 = /* @__PURE__ */ Yn(We), A1 = /* @__PURE__ */ ub(We), g1 = /* @__PURE__ */ lb(We), y1 = /* @__PURE__ */ cb(We), T1 = /* @__PURE__ */ db(We), M1 = /* @__PURE__ */ pb(We), I1 = /* @__PURE__ */ fb(We), x1 = /* @__PURE__ */ hb(We), S1 = /* @__PURE__ */ mb(We), de = /* @__PURE__ */ I("ZodType", (o, n) => (ce.init(o, n), Object.assign(o["~standard"], {
  jsonSchema: {
    input: Vn(o, "input"),
    output: Vn(o, "output")
  }
}), o.toJSONSchema = Og(o, {}), o.def = n, o.type = n.type, Object.defineProperty(o, "_def", { value: n }), o.check = (...r) => o.clone(Do(n, {
  checks: [
    ...n.checks ?? [],
    ...r.map((a) => typeof a == "function" ? { _zod: { check: a, def: { check: "custom" }, onattach: [] } } : a)
  ]
}), {
  parent: !0
}), o.with = o.check, o.clone = (r, a) => Lo(o, r, a), o.brand = () => o, o.register = ((r, a) => (r.add(o, a), o)), o.parse = (r, a) => h1(o, r, a, { callee: o.parse }), o.safeParse = (r, a) => _1(o, r, a), o.parseAsync = async (r, a) => m1(o, r, a, { callee: o.parseAsync }), o.safeParseAsync = async (r, a) => b1(o, r, a), o.spa = o.safeParseAsync, o.encode = (r, a) => A1(o, r, a), o.decode = (r, a) => g1(o, r, a), o.encodeAsync = async (r, a) => y1(o, r, a), o.decodeAsync = async (r, a) => T1(o, r, a), o.safeEncode = (r, a) => M1(o, r, a), o.safeDecode = (r, a) => I1(o, r, a), o.safeEncodeAsync = async (r, a) => x1(o, r, a), o.safeDecodeAsync = async (r, a) => S1(o, r, a), o.refine = (r, a) => o.check(Ay(r, a)), o.superRefine = (r) => o.check(gy(r)), o.overwrite = (r) => o.check(/* @__PURE__ */ gt(r)), o.optional = () => Hu(o), o.exactOptional = () => iy(o), o.nullable = () => Wu(o), o.nullish = () => Hu(Wu(o)), o.nonoptional = (r) => dy(o, r), o.array = () => J1(o), o.or = (r) => Nl([o, r]), o.and = (r) => Q1(o, r), o.transform = (r) => Vu(o, ny(r)), o.default = (r) => uy(o, r), o.prefault = (r) => cy(o, r), o.catch = (r) => fy(o, r), o.pipe = (r) => Vu(o, r), o.readonly = () => _y(o), o.describe = (r) => {
  const a = o.clone();
  return $t.add(a, { description: r }), a;
}, Object.defineProperty(o, "description", {
  get() {
    return $t.get(o)?.description;
  },
  configurable: !0
}), o.meta = (...r) => {
  if (r.length === 0)
    return $t.get(o);
  const a = o.clone();
  return $t.add(a, r[0]), a;
}, o.isOptional = () => o.safeParse(void 0).success, o.isNullable = () => o.safeParse(null).success, o.apply = (r) => r(o), o)), Sl = /* @__PURE__ */ I("_ZodString", (o, n) => {
  Ui.init(o, n), de.init(o, n), o._zod.processJSONSchema = (a, u, f) => Gg(o, a, u);
  const r = o._zod.bag;
  o.format = r.format ?? null, o.minLength = r.minimum ?? null, o.maxLength = r.maximum ?? null, o.regex = (...a) => o.check(/* @__PURE__ */ Ig(...a)), o.includes = (...a) => o.check(/* @__PURE__ */ vg(...a)), o.startsWith = (...a) => o.check(/* @__PURE__ */ Ng(...a)), o.endsWith = (...a) => o.check(/* @__PURE__ */ Fg(...a)), o.min = (...a) => o.check(/* @__PURE__ */ Wn(...a)), o.max = (...a) => o.check(/* @__PURE__ */ gl(...a)), o.length = (...a) => o.check(/* @__PURE__ */ yl(...a)), o.nonempty = (...a) => o.check(/* @__PURE__ */ Wn(1, ...a)), o.lowercase = (a) => o.check(/* @__PURE__ */ xg(a)), o.uppercase = (a) => o.check(/* @__PURE__ */ Sg(a)), o.trim = () => o.check(/* @__PURE__ */ Cg()), o.normalize = (...a) => o.check(/* @__PURE__ */ wg(...a)), o.toLowerCase = () => o.check(/* @__PURE__ */ Eg()), o.toUpperCase = () => o.check(/* @__PURE__ */ Bg()), o.slugify = () => o.check(/* @__PURE__ */ kg());
}), v1 = /* @__PURE__ */ I("ZodString", (o, n) => {
  Ui.init(o, n), Sl.init(o, n), o.email = (r) => o.check(/* @__PURE__ */ JA(N1, r)), o.url = (r) => o.check(/* @__PURE__ */ QA(F1, r)), o.jwt = (r) => o.check(/* @__PURE__ */ hg($1, r)), o.emoji = (r) => o.check(/* @__PURE__ */ eg(w1, r)), o.guid = (r) => o.check(/* @__PURE__ */ Ou(Zu, r)), o.uuid = (r) => o.check(/* @__PURE__ */ Al(Kt, r)), o.uuidv4 = (r) => o.check(/* @__PURE__ */ jA(Kt, r)), o.uuidv6 = (r) => o.check(/* @__PURE__ */ YA(Kt, r)), o.uuidv7 = (r) => o.check(/* @__PURE__ */ XA(Kt, r)), o.nanoid = (r) => o.check(/* @__PURE__ */ og(C1, r)), o.guid = (r) => o.check(/* @__PURE__ */ Ou(Zu, r)), o.cuid = (r) => o.check(/* @__PURE__ */ tg(E1, r)), o.cuid2 = (r) => o.check(/* @__PURE__ */ ng(B1, r)), o.ulid = (r) => o.check(/* @__PURE__ */ rg(k1, r)), o.base64 = (r) => o.check(/* @__PURE__ */ dg(G1, r)), o.base64url = (r) => o.check(/* @__PURE__ */ pg(U1, r)), o.xid = (r) => o.check(/* @__PURE__ */ ig(D1, r)), o.ksuid = (r) => o.check(/* @__PURE__ */ ag(L1, r)), o.ipv4 = (r) => o.check(/* @__PURE__ */ sg(P1, r)), o.ipv6 = (r) => o.check(/* @__PURE__ */ ug(R1, r)), o.cidrv4 = (r) => o.check(/* @__PURE__ */ lg(O1, r)), o.cidrv6 = (r) => o.check(/* @__PURE__ */ cg(z1, r)), o.e164 = (r) => o.check(/* @__PURE__ */ fg(Z1, r)), o.datetime = (r) => o.check(a1(r)), o.date = (r) => o.check(u1(r)), o.time = (r) => o.check(c1(r)), o.duration = (r) => o.check(p1(r));
});
function Se(o) {
  return /* @__PURE__ */ VA(v1, o);
}
const ie = /* @__PURE__ */ I("ZodStringFormat", (o, n) => {
  ne.init(o, n), Sl.init(o, n);
}), N1 = /* @__PURE__ */ I("ZodEmail", (o, n) => {
  nA.init(o, n), ie.init(o, n);
}), Zu = /* @__PURE__ */ I("ZodGUID", (o, n) => {
  oA.init(o, n), ie.init(o, n);
}), Kt = /* @__PURE__ */ I("ZodUUID", (o, n) => {
  tA.init(o, n), ie.init(o, n);
});
function Jn(o) {
  return /* @__PURE__ */ Al(Kt, o);
}
const F1 = /* @__PURE__ */ I("ZodURL", (o, n) => {
  rA.init(o, n), ie.init(o, n);
}), w1 = /* @__PURE__ */ I("ZodEmoji", (o, n) => {
  iA.init(o, n), ie.init(o, n);
}), C1 = /* @__PURE__ */ I("ZodNanoID", (o, n) => {
  aA.init(o, n), ie.init(o, n);
}), E1 = /* @__PURE__ */ I("ZodCUID", (o, n) => {
  sA.init(o, n), ie.init(o, n);
}), B1 = /* @__PURE__ */ I("ZodCUID2", (o, n) => {
  uA.init(o, n), ie.init(o, n);
}), k1 = /* @__PURE__ */ I("ZodULID", (o, n) => {
  lA.init(o, n), ie.init(o, n);
}), D1 = /* @__PURE__ */ I("ZodXID", (o, n) => {
  cA.init(o, n), ie.init(o, n);
}), L1 = /* @__PURE__ */ I("ZodKSUID", (o, n) => {
  dA.init(o, n), ie.init(o, n);
}), P1 = /* @__PURE__ */ I("ZodIPv4", (o, n) => {
  _A.init(o, n), ie.init(o, n);
}), R1 = /* @__PURE__ */ I("ZodIPv6", (o, n) => {
  bA.init(o, n), ie.init(o, n);
}), O1 = /* @__PURE__ */ I("ZodCIDRv4", (o, n) => {
  AA.init(o, n), ie.init(o, n);
}), z1 = /* @__PURE__ */ I("ZodCIDRv6", (o, n) => {
  gA.init(o, n), ie.init(o, n);
}), G1 = /* @__PURE__ */ I("ZodBase64", (o, n) => {
  yA.init(o, n), ie.init(o, n);
}), U1 = /* @__PURE__ */ I("ZodBase64URL", (o, n) => {
  MA.init(o, n), ie.init(o, n);
}), Z1 = /* @__PURE__ */ I("ZodE164", (o, n) => {
  IA.init(o, n), ie.init(o, n);
}), $1 = /* @__PURE__ */ I("ZodJWT", (o, n) => {
  SA.init(o, n), ie.init(o, n);
}), vl = /* @__PURE__ */ I("ZodNumber", (o, n) => {
  hl.init(o, n), de.init(o, n), o._zod.processJSONSchema = (a, u, f) => Ug(o, a, u), o.gt = (a, u) => o.check(/* @__PURE__ */ Gu(a, u)), o.gte = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.min = (a, u) => o.check(/* @__PURE__ */ vi(a, u)), o.lt = (a, u) => o.check(/* @__PURE__ */ zu(a, u)), o.lte = (a, u) => o.check(/* @__PURE__ */ Si(a, u)), o.max = (a, u) => o.check(/* @__PURE__ */ Si(a, u)), o.int = (a) => o.check(Ku(a)), o.safe = (a) => o.check(Ku(a)), o.positive = (a) => o.check(/* @__PURE__ */ Gu(0, a)), o.nonnegative = (a) => o.check(/* @__PURE__ */ vi(0, a)), o.negative = (a) => o.check(/* @__PURE__ */ zu(0, a)), o.nonpositive = (a) => o.check(/* @__PURE__ */ Si(0, a)), o.multipleOf = (a, u) => o.check(/* @__PURE__ */ Uu(a, u)), o.step = (a, u) => o.check(/* @__PURE__ */ Uu(a, u)), o.finite = () => o;
  const r = o._zod.bag;
  o.minValue = Math.max(r.minimum ?? Number.NEGATIVE_INFINITY, r.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, o.maxValue = Math.min(r.maximum ?? Number.POSITIVE_INFINITY, r.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, o.isInt = (r.format ?? "").includes("int") || Number.isSafeInteger(r.multipleOf ?? 0.5), o.isFinite = !0, o.format = r.format ?? null;
});
function $u(o) {
  return /* @__PURE__ */ gg(vl, o);
}
const K1 = /* @__PURE__ */ I("ZodNumberFormat", (o, n) => {
  vA.init(o, n), vl.init(o, n);
});
function Ku(o) {
  return /* @__PURE__ */ yg(K1, o);
}
const q1 = /* @__PURE__ */ I("ZodUnknown", (o, n) => {
  NA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => $g();
});
function qu() {
  return /* @__PURE__ */ Tg(q1);
}
const H1 = /* @__PURE__ */ I("ZodNever", (o, n) => {
  FA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Zg(o, r, a);
});
function W1(o) {
  return /* @__PURE__ */ Mg(H1, o);
}
const V1 = /* @__PURE__ */ I("ZodArray", (o, n) => {
  wA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Vg(o, r, a, u), o.element = n.element, o.min = (r, a) => o.check(/* @__PURE__ */ Wn(r, a)), o.nonempty = (r) => o.check(/* @__PURE__ */ Wn(1, r)), o.max = (r, a) => o.check(/* @__PURE__ */ gl(r, a)), o.length = (r, a) => o.check(/* @__PURE__ */ yl(r, a)), o.unwrap = () => o.element;
});
function J1(o, n) {
  return /* @__PURE__ */ Dg(V1, o, n);
}
const j1 = /* @__PURE__ */ I("ZodObject", (o, n) => {
  EA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Jg(o, r, a, u), j(o, "shape", () => n.shape), o.keyof = () => Fl(Object.keys(o._zod.def.shape)), o.catchall = (r) => o.clone({ ...o._zod.def, catchall: r }), o.passthrough = () => o.clone({ ...o._zod.def, catchall: qu() }), o.loose = () => o.clone({ ...o._zod.def, catchall: qu() }), o.strict = () => o.clone({ ...o._zod.def, catchall: W1() }), o.strip = () => o.clone({ ...o._zod.def, catchall: void 0 }), o.extend = (r) => Q0(o, r), o.safeExtend = (r) => eb(o, r), o.merge = (r) => ob(o, r), o.pick = (r) => Y0(o, r), o.omit = (r) => X0(o, r), o.partial = (...r) => tb(wl, o, r[0]), o.required = (...r) => nb(Cl, o, r[0]);
});
function Qn(o, n) {
  const r = {
    type: "object",
    shape: o ?? {},
    ...k(n)
  };
  return new j1(r);
}
const Y1 = /* @__PURE__ */ I("ZodUnion", (o, n) => {
  BA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => jg(o, r, a, u), o.options = n.options;
});
function Nl(o, n) {
  return new Y1({
    type: "union",
    options: o,
    ...k(n)
  });
}
const X1 = /* @__PURE__ */ I("ZodIntersection", (o, n) => {
  kA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Yg(o, r, a, u);
});
function Q1(o, n) {
  return new X1({
    type: "intersection",
    left: o,
    right: n
  });
}
const Ci = /* @__PURE__ */ I("ZodEnum", (o, n) => {
  DA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (a, u, f) => Kg(o, a, u), o.enum = n.entries, o.options = Object.values(n.entries);
  const r = new Set(Object.keys(n.entries));
  o.extract = (a, u) => {
    const f = {};
    for (const d of a)
      if (r.has(d))
        f[d] = n.entries[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new Ci({
      ...n,
      checks: [],
      ...k(u),
      entries: f
    });
  }, o.exclude = (a, u) => {
    const f = { ...n.entries };
    for (const d of a)
      if (r.has(d))
        delete f[d];
      else
        throw new Error(`Key ${d} not found in enum`);
    return new Ci({
      ...n,
      checks: [],
      ...k(u),
      entries: f
    });
  };
});
function Fl(o, n) {
  const r = Array.isArray(o) ? Object.fromEntries(o.map((a) => [a, a])) : o;
  return new Ci({
    type: "enum",
    entries: r,
    ...k(n)
  });
}
const ey = /* @__PURE__ */ I("ZodLiteral", (o, n) => {
  LA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => qg(o, r, a), o.values = new Set(n.values), Object.defineProperty(o, "value", {
    get() {
      if (n.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return n.values[0];
    }
  });
});
function oy(o, n) {
  return new ey({
    type: "literal",
    values: Array.isArray(o) ? o : [o],
    ...k(n)
  });
}
const ty = /* @__PURE__ */ I("ZodTransform", (o, n) => {
  PA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Wg(o, r), o._zod.parse = (r, a) => {
    if (a.direction === "backward")
      throw new Xu(o.constructor.name);
    r.addIssue = (f) => {
      if (typeof f == "string")
        r.issues.push(Vt(f, r.value, n));
      else {
        const d = f;
        d.fatal && (d.continue = !1), d.code ?? (d.code = "custom"), d.input ?? (d.input = r.value), d.inst ?? (d.inst = o), r.issues.push(Vt(d));
      }
    };
    const u = n.transform(r.value, r);
    return u instanceof Promise ? u.then((f) => (r.value = f, r)) : (r.value = u, r);
  };
});
function ny(o) {
  return new ty({
    type: "transform",
    transform: o
  });
}
const wl = /* @__PURE__ */ I("ZodOptional", (o, n) => {
  bl.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => xl(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Hu(o) {
  return new wl({
    type: "optional",
    innerType: o
  });
}
const ry = /* @__PURE__ */ I("ZodExactOptional", (o, n) => {
  RA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => xl(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function iy(o) {
  return new ry({
    type: "optional",
    innerType: o
  });
}
const ay = /* @__PURE__ */ I("ZodNullable", (o, n) => {
  OA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Xg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function Wu(o) {
  return new ay({
    type: "nullable",
    innerType: o
  });
}
const sy = /* @__PURE__ */ I("ZodDefault", (o, n) => {
  zA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => e1(o, r, a, u), o.unwrap = () => o._zod.def.innerType, o.removeDefault = o.unwrap;
});
function uy(o, n) {
  return new sy({
    type: "default",
    innerType: o,
    get defaultValue() {
      return typeof n == "function" ? n() : tl(n);
    }
  });
}
const ly = /* @__PURE__ */ I("ZodPrefault", (o, n) => {
  GA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => o1(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function cy(o, n) {
  return new ly({
    type: "prefault",
    innerType: o,
    get defaultValue() {
      return typeof n == "function" ? n() : tl(n);
    }
  });
}
const Cl = /* @__PURE__ */ I("ZodNonOptional", (o, n) => {
  UA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Qg(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function dy(o, n) {
  return new Cl({
    type: "nonoptional",
    innerType: o,
    ...k(n)
  });
}
const py = /* @__PURE__ */ I("ZodCatch", (o, n) => {
  ZA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => t1(o, r, a, u), o.unwrap = () => o._zod.def.innerType, o.removeCatch = o.unwrap;
});
function fy(o, n) {
  return new py({
    type: "catch",
    innerType: o,
    catchValue: typeof n == "function" ? n : () => n
  });
}
const hy = /* @__PURE__ */ I("ZodPipe", (o, n) => {
  $A.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => n1(o, r, a, u), o.in = n.in, o.out = n.out;
});
function Vu(o, n) {
  return new hy({
    type: "pipe",
    in: o,
    out: n
    // ...util.normalizeParams(params),
  });
}
const my = /* @__PURE__ */ I("ZodReadonly", (o, n) => {
  KA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => r1(o, r, a, u), o.unwrap = () => o._zod.def.innerType;
});
function _y(o) {
  return new my({
    type: "readonly",
    innerType: o
  });
}
const by = /* @__PURE__ */ I("ZodCustom", (o, n) => {
  qA.init(o, n), de.init(o, n), o._zod.processJSONSchema = (r, a, u) => Hg(o, r);
});
function Ay(o, n = {}) {
  return /* @__PURE__ */ Lg(by, o, n);
}
function gy(o) {
  return /* @__PURE__ */ Pg(o);
}
const El = Qn({
  userId: Jn(),
  companyId: Jn()
}), yy = El.extend({
  auctionId: Jn()
}), Ty = El.extend({
  directSaleId: Jn()
}), cT = Nl([yy, Ty]), dT = 50, pT = 1, fT = "bnk_", My = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    positionByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    positionAdminByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    label: "Front",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    positionByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 60
    },
    positionAdminByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    label: "3/4 Front Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    positionByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 70
    },
    positionAdminByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    label: "Left Side",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    positionByType: {
      MinibusCityIntercity: 70,
      MinibusTouristic: 70,
      AutobusNormalFloor2Axle: 70,
      AutobusNormalFloor3Axle: 70,
      AutobusLowFloorLowEntry8_12Mt: 70,
      Autobus18Mt: 70,
      DoubleDecker: 80
    },
    positionAdminByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    label: "3/4 Rear Left Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    positionByType: {
      MinibusCityIntercity: 80,
      MinibusTouristic: 80,
      AutobusNormalFloor2Axle: 80,
      AutobusNormalFloor3Axle: 80,
      AutobusLowFloorLowEntry8_12Mt: 80,
      Autobus18Mt: 80,
      DoubleDecker: 90
    },
    positionAdminByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 100,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    label: "Rear",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    positionByType: {
      MinibusCityIntercity: 90,
      MinibusTouristic: 90,
      AutobusNormalFloor2Axle: 90,
      AutobusNormalFloor3Axle: 90,
      AutobusLowFloorLowEntry8_12Mt: 90,
      Autobus18Mt: 90,
      DoubleDecker: 100
    },
    positionAdminByType: {
      MinibusCityIntercity: 110,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 110,
      DoubleDecker: 120
    },
    label: "3/4 Rear Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    positionByType: {
      MinibusCityIntercity: 100,
      MinibusTouristic: 120,
      AutobusNormalFloor2Axle: 100,
      AutobusNormalFloor3Axle: 100,
      AutobusLowFloorLowEntry8_12Mt: 100,
      Autobus18Mt: 100,
      DoubleDecker: 110
    },
    positionAdminByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 120,
      DoubleDecker: 130
    },
    label: "Right Side",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    positionByType: { Autobus18Mt: 110 },
    positionAdminByType: { Autobus18Mt: 130 },
    label: "Turntable External",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    positionByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    positionAdminByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    label: "3/4 Front Right Side",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    positionByType: {
      MinibusCityIntercity: 130,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 110,
      AutobusNormalFloor3Axle: 110,
      AutobusLowFloorLowEntry8_12Mt: 110,
      Autobus18Mt: 120,
      DoubleDecker: 120
    },
    positionAdminByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    label: "3/4 Front Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    positionByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 120,
      AutobusNormalFloor3Axle: 120,
      AutobusLowFloorLowEntry8_12Mt: 120,
      Autobus18Mt: 130,
      DoubleDecker: 130
    },
    positionAdminByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    label: "Front Door Open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    positionByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 140,
      AutobusNormalFloor2Axle: 130,
      AutobusNormalFloor3Axle: 130,
      AutobusLowFloorLowEntry8_12Mt: 130,
      Autobus18Mt: 140,
      DoubleDecker: 140
    },
    positionAdminByType: {
      MinibusCityIntercity: 160,
      MinibusTouristic: 160,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 150,
      Autobus18Mt: 160,
      DoubleDecker: 160
    },
    label: "Right Side Doors Open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    positionByType: {
      MinibusCityIntercity: 220,
      MinibusTouristic: 220,
      AutobusNormalFloor2Axle: 140,
      AutobusNormalFloor3Axle: 140,
      AutobusLowFloorLowEntry8_12Mt: 140,
      Autobus18Mt: 150,
      DoubleDecker: 150
    },
    positionAdminByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 240,
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 170,
      DoubleDecker: 170
    },
    label: "Second Door Open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    positionByType: { AutobusLowFloorLowEntry8_12Mt: 150, Autobus18Mt: 160 },
    positionAdminByType: { AutobusLowFloorLowEntry8_12Mt: 170, Autobus18Mt: 180 },
    label: "Third Door Open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    positionByType: {
      MinibusCityIntercity: 150,
      MinibusTouristic: 150,
      AutobusNormalFloor2Axle: 150,
      AutobusNormalFloor3Axle: 150,
      AutobusLowFloorLowEntry8_12Mt: 160,
      Autobus18Mt: 180,
      DoubleDecker: 160
    },
    positionAdminByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    label: "3/4 Rear Right Side Doors Open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    positionByType: { MinibusTouristic: 230, AutobusNormalFloor2Axle: 240, AutobusNormalFloor3Axle: 240, DoubleDecker: 250 },
    positionAdminByType: { MinibusTouristic: 250, AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    label: "Luggage Rack Left Side",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    positionByType: { MinibusTouristic: 240, AutobusNormalFloor2Axle: 250, AutobusNormalFloor3Axle: 250, DoubleDecker: 260 },
    positionAdminByType: { MinibusTouristic: 260, AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 280 },
    label: "Luggage",
    group: "exteriors",
    description: "A photo showing the luggage compartment of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    positionByType: { AutobusNormalFloor2Axle: 260, AutobusNormalFloor3Axle: 260, DoubleDecker: 270 },
    positionAdminByType: { AutobusNormalFloor2Axle: 280, AutobusNormalFloor3Axle: 280, DoubleDecker: 290 },
    label: "Luggage Under Carpet Photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    positionByType: {
      AutobusNormalFloor2Axle: 160,
      AutobusNormalFloor3Axle: 160,
      AutobusLowFloorLowEntry8_12Mt: 170,
      Autobus18Mt: 190,
      DoubleDecker: 170
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    label: "Rear Hatch Open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    positionByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    label: "Air Conditioning Compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    positionByType: {
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    label: "Preheater",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "Fire Suppression System",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    positionByType: {
      MinibusCityIntercity: 180,
      MinibusTouristic: 180,
      AutobusNormalFloor2Axle: 220,
      AutobusNormalFloor3Axle: 220,
      AutobusLowFloorLowEntry8_12Mt: 230,
      Autobus18Mt: 250,
      DoubleDecker: 230
    },
    positionAdminByType: {
      MinibusCityIntercity: 200,
      MinibusTouristic: 200,
      AutobusNormalFloor2Axle: 240,
      AutobusNormalFloor3Axle: 240,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 250
    },
    label: "Platform Open",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    positionByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    },
    positionAdminByType: {
      MinibusCityIntercity: 210,
      MinibusTouristic: 210,
      AutobusNormalFloor2Axle: 250,
      AutobusNormalFloor3Axle: 250,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 260
    },
    label: "Platform Code",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    positionAdminByType: {
      MinibusCityIntercity: 20,
      MinibusTouristic: 20,
      AutobusNormalFloor2Axle: 20,
      AutobusNormalFloor3Axle: 20,
      AutobusLowFloorLowEntry8_12Mt: 20,
      Autobus18Mt: 20,
      DoubleDecker: 20
    },
    label: "Vehicle Plate",
    group: "technical-data",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    positionByType: {
      MinibusCityIntercity: 230,
      MinibusTouristic: 290,
      AutobusNormalFloor2Axle: 290,
      AutobusNormalFloor3Axle: 280,
      AutobusLowFloorLowEntry8_12Mt: 250,
      Autobus18Mt: 270,
      DoubleDecker: 300
    },
    positionAdminByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 320
    },
    label: "Seats Plate",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    positionByType: { MinibusTouristic: 300, AutobusNormalFloor2Axle: 300, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    positionAdminByType: { MinibusTouristic: 320, AutobusNormalFloor2Axle: 320, AutobusNormalFloor3Axle: 310, DoubleDecker: 330 },
    label: "Driver Microphone",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    positionByType: {
      MinibusCityIntercity: 240,
      MinibusTouristic: 310,
      AutobusNormalFloor2Axle: 310,
      AutobusNormalFloor3Axle: 300,
      AutobusLowFloorLowEntry8_12Mt: 260,
      Autobus18Mt: 280,
      DoubleDecker: 320
    },
    positionAdminByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    label: "Driver's Seat",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    positionByType: {
      MinibusCityIntercity: 250,
      MinibusTouristic: 320,
      AutobusNormalFloor2Axle: 320,
      AutobusNormalFloor3Axle: 310,
      AutobusLowFloorLowEntry8_12Mt: 270,
      Autobus18Mt: 290,
      DoubleDecker: 330
    },
    positionAdminByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    label: "Steering Wheel",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    positionByType: {
      MinibusCityIntercity: 260,
      MinibusTouristic: 330,
      AutobusNormalFloor2Axle: 330,
      AutobusNormalFloor3Axle: 320,
      AutobusLowFloorLowEntry8_12Mt: 280,
      Autobus18Mt: 300,
      DoubleDecker: 340
    },
    positionAdminByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    label: "Dashboard Engine On",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    positionByType: {
      MinibusCityIntercity: 270,
      MinibusTouristic: 340,
      AutobusNormalFloor2Axle: 340,
      AutobusNormalFloor3Axle: 330,
      AutobusLowFloorLowEntry8_12Mt: 290,
      Autobus18Mt: 310,
      DoubleDecker: 350
    },
    positionAdminByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 360,
      AutobusNormalFloor3Axle: 350,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 370
    },
    label: "Complete Driver's Dashboard",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    positionByType: {
      MinibusCityIntercity: 280,
      MinibusTouristic: 350,
      AutobusNormalFloor2Axle: 350,
      AutobusNormalFloor3Axle: 340,
      AutobusLowFloorLowEntry8_12Mt: 300,
      Autobus18Mt: 320,
      DoubleDecker: 360
    },
    positionAdminByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 380
    },
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    positionByType: { AutobusNormalFloor2Axle: 360, AutobusNormalFloor3Axle: 350, DoubleDecker: 370 },
    positionAdminByType: { AutobusNormalFloor2Axle: 380, AutobusNormalFloor3Axle: 370, DoubleDecker: 390 },
    label: "Radio",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    positionByType: {
      MinibusCityIntercity: 290,
      MinibusTouristic: 360,
      AutobusNormalFloor2Axle: 370,
      AutobusNormalFloor3Axle: 360,
      AutobusLowFloorLowEntry8_12Mt: 310,
      Autobus18Mt: 330,
      DoubleDecker: 380
    },
    positionAdminByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    label: "Onboard Device 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    positionByType: {
      MinibusCityIntercity: 300,
      MinibusTouristic: 370,
      AutobusNormalFloor2Axle: 380,
      AutobusNormalFloor3Axle: 370,
      AutobusLowFloorLowEntry8_12Mt: 320,
      Autobus18Mt: 340,
      DoubleDecker: 390
    },
    positionAdminByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 390,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    label: "Onboard Device 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    positionByType: {
      MinibusCityIntercity: 310,
      MinibusTouristic: 380,
      AutobusNormalFloor2Axle: 400,
      AutobusNormalFloor3Axle: 390,
      AutobusLowFloorLowEntry8_12Mt: 340,
      Autobus18Mt: 360,
      DoubleDecker: 410
    },
    positionAdminByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 400,
      AutobusNormalFloor2Axle: 420,
      AutobusNormalFloor3Axle: 410,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 430
    },
    label: "Command Unit Indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    positionByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 410, AutobusNormalFloor3Axle: 400, DoubleDecker: 420 },
    positionAdminByType: { MinibusTouristic: 430, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    label: "Hostess Seat",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    positionByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 420, AutobusNormalFloor3Axle: 410, DoubleDecker: 430 },
    positionAdminByType: { MinibusTouristic: 440, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    label: "Hostess Microphone",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    positionByType: {
      MinibusCityIntercity: 320,
      MinibusTouristic: 430,
      AutobusNormalFloor2Axle: 450,
      AutobusNormalFloor3Axle: 440,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 460
    },
    positionAdminByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 390,
      DoubleDecker: 480
    },
    label: "Door Mechanism",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    positionByType: {
      MinibusCityIntercity: 330,
      MinibusTouristic: 440,
      AutobusNormalFloor2Axle: 460,
      AutobusNormalFloor3Axle: 450,
      AutobusLowFloorLowEntry8_12Mt: 360,
      Autobus18Mt: 380,
      DoubleDecker: 470
    },
    positionAdminByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 400,
      DoubleDecker: 490
    },
    label: "Reverse Seats From Driver Position",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !0
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    positionByType: {
      AutobusNormalFloor2Axle: 470,
      AutobusNormalFloor3Axle: 460,
      AutobusLowFloorLowEntry8_12Mt: 370,
      Autobus18Mt: 400,
      DoubleDecker: 480
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    label: "Reverse Seats From Middle Position",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    positionByType: {
      MinibusCityIntercity: 340,
      MinibusTouristic: 450,
      AutobusNormalFloor2Axle: 480,
      AutobusNormalFloor3Axle: 470,
      AutobusLowFloorLowEntry8_12Mt: 380,
      Autobus18Mt: 410,
      DoubleDecker: 490
    },
    positionAdminByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    label: "Forward Seats From End Position",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    positionByType: {
      MinibusCityIntercity: 350,
      MinibusTouristic: 460,
      AutobusNormalFloor2Axle: 490,
      AutobusNormalFloor3Axle: 480,
      AutobusLowFloorLowEntry8_12Mt: 390,
      Autobus18Mt: 420,
      DoubleDecker: 500
    },
    positionAdminByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 510,
      AutobusNormalFloor3Axle: 500,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 520
    },
    label: "Overhead Compartments",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    positionByType: { AutobusNormalFloor2Axle: 510, AutobusNormalFloor3Axle: 500, DoubleDecker: 520 },
    positionAdminByType: { AutobusNormalFloor2Axle: 530, AutobusNormalFloor3Axle: 520, DoubleDecker: 540 },
    label: "Toilette",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    positionByType: {
      AutobusNormalFloor2Axle: 500,
      AutobusNormalFloor3Axle: 490,
      AutobusLowFloorLowEntry8_12Mt: 400,
      Autobus18Mt: 430,
      DoubleDecker: 510
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 530
    },
    label: "Forward Seats From Middle Position",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    positionByType: { Autobus18Mt: 390 },
    positionAdminByType: { Autobus18Mt: 410 },
    label: "Turntable Internal",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    positionByType: {
      MinibusCityIntercity: 360,
      MinibusTouristic: 470,
      AutobusNormalFloor2Axle: 520,
      AutobusNormalFloor3Axle: 510,
      AutobusLowFloorLowEntry8_12Mt: 410,
      Autobus18Mt: 440,
      DoubleDecker: 780
    },
    positionAdminByType: {
      MinibusCityIntercity: 380,
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    label: "Roof Hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    positionByType: {
      MinibusCityIntercity: 370,
      MinibusTouristic: 480,
      AutobusNormalFloor2Axle: 530,
      AutobusNormalFloor3Axle: 520,
      AutobusLowFloorLowEntry8_12Mt: 420,
      Autobus18Mt: 450,
      DoubleDecker: 790
    },
    positionAdminByType: {
      MinibusCityIntercity: 390,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 810
    },
    label: "Roof Hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    positionByType: {
      MinibusTouristic: 490,
      AutobusNormalFloor2Axle: 540,
      AutobusNormalFloor3Axle: 530,
      AutobusLowFloorLowEntry8_12Mt: 430,
      Autobus18Mt: 460,
      DoubleDecker: 800
    },
    positionAdminByType: {
      MinibusTouristic: 510,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 820
    },
    label: "Roof Hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    positionByType: {
      MinibusCityIntercity: 380,
      AutobusNormalFloor2Axle: 550,
      AutobusNormalFloor3Axle: 540,
      AutobusLowFloorLowEntry8_12Mt: 440,
      Autobus18Mt: 470,
      DoubleDecker: 530
    },
    positionAdminByType: {
      MinibusCityIntercity: 400,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    label: "Disabled Area",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    positionByType: {
      MinibusCityIntercity: 390,
      AutobusNormalFloor2Axle: 560,
      AutobusNormalFloor3Axle: 550,
      AutobusLowFloorLowEntry8_12Mt: 450,
      Autobus18Mt: 480,
      DoubleDecker: 540
    },
    positionAdminByType: {
      MinibusCityIntercity: 410,
      AutobusNormalFloor2Axle: 580,
      AutobusNormalFloor3Axle: 570,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 560
    },
    label: "Folding Seats",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    positionByType: {
      MinibusCityIntercity: 400,
      MinibusTouristic: 500,
      AutobusNormalFloor2Axle: 570,
      AutobusNormalFloor3Axle: 560,
      AutobusLowFloorLowEntry8_12Mt: 460,
      Autobus18Mt: 490,
      DoubleDecker: 550
    },
    positionAdminByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 520,
      AutobusNormalFloor2Axle: 590,
      AutobusNormalFloor3Axle: 580,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 570
    },
    label: "Seats",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    positionByType: { MinibusTouristic: 510, AutobusNormalFloor2Axle: 590, AutobusNormalFloor3Axle: 580, DoubleDecker: 570 },
    positionAdminByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    label: "Mesh",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    positionByType: { MinibusTouristic: 520, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    positionAdminByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    label: "Table",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    positionByType: { MinibusTouristic: 530, AutobusNormalFloor2Axle: 610, AutobusNormalFloor3Axle: 600, DoubleDecker: 590 },
    positionAdminByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    label: "Usb Charging",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    positionByType: { MinibusTouristic: 540, AutobusNormalFloor2Axle: 580, AutobusNormalFloor3Axle: 570, DoubleDecker: 560 },
    positionAdminByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 600, AutobusNormalFloor3Axle: 590, DoubleDecker: 580 },
    label: "Armrest",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    positionByType: { MinibusTouristic: 550, AutobusNormalFloor2Axle: 620, AutobusNormalFloor3Axle: 610, DoubleDecker: 600 },
    positionAdminByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    label: "Footrest",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    positionByType: { MinibusTouristic: 560, AutobusNormalFloor2Axle: 640, AutobusNormalFloor3Axle: 630, DoubleDecker: 620 },
    positionAdminByType: { MinibusTouristic: 580, AutobusNormalFloor2Axle: 660, AutobusNormalFloor3Axle: 650, DoubleDecker: 640 },
    label: "Monitor",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    positionByType: { MinibusTouristic: 570, AutobusNormalFloor2Axle: 630, AutobusNormalFloor3Axle: 620, DoubleDecker: 610 },
    positionAdminByType: { MinibusTouristic: 590, AutobusNormalFloor2Axle: 650, AutobusNormalFloor3Axle: 640, DoubleDecker: 630 },
    label: "Power Outlets",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    positionByType: { MinibusTouristic: 390, AutobusNormalFloor2Axle: 430, AutobusNormalFloor3Axle: 420, DoubleDecker: 440 },
    positionAdminByType: { MinibusTouristic: 410, AutobusNormalFloor2Axle: 450, AutobusNormalFloor3Axle: 440, DoubleDecker: 460 },
    label: "Coffee Machine",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    positionByType: {
      MinibusCityIntercity: 410,
      MinibusTouristic: 580,
      AutobusNormalFloor2Axle: 650,
      AutobusNormalFloor3Axle: 640,
      AutobusLowFloorLowEntry8_12Mt: 470,
      Autobus18Mt: 500,
      DoubleDecker: 660
    },
    positionAdminByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 680
    },
    label: "Seats Bracket",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    positionByType: {
      MinibusCityIntercity: 420,
      MinibusTouristic: 590,
      AutobusNormalFloor2Axle: 660,
      AutobusNormalFloor3Axle: 650,
      AutobusLowFloorLowEntry8_12Mt: 480,
      Autobus18Mt: 510,
      DoubleDecker: 670
    },
    positionAdminByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 690
    },
    label: "Camera",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    positionByType: {
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      DoubleDecker: 1310
    },
    positionAdminByType: {
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      DoubleDecker: 1330
    },
    label: "Spare Tyre",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    positionByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 980,
      AutobusNormalFloor2Axle: 1060,
      AutobusNormalFloor3Axle: 1160,
      AutobusLowFloorLowEntry8_12Mt: 880,
      Autobus18Mt: 1060,
      DoubleDecker: 1330
    },
    positionAdminByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    label: "First Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    positionByType: {
      MinibusCityIntercity: 820,
      MinibusTouristic: 1e3,
      AutobusNormalFloor2Axle: 1080,
      AutobusNormalFloor3Axle: 1180,
      AutobusLowFloorLowEntry8_12Mt: 900,
      Autobus18Mt: 1080,
      DoubleDecker: 1350
    },
    positionAdminByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    label: "First Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    positionByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    positionAdminByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    label: "Second Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    positionByType: {
      MinibusCityIntercity: 850,
      MinibusTouristic: 1030,
      AutobusNormalFloor2Axle: 1110,
      AutobusNormalFloor3Axle: 1210,
      AutobusLowFloorLowEntry8_12Mt: 930,
      Autobus18Mt: 1110,
      DoubleDecker: 1380
    },
    positionAdminByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1230,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1130,
      DoubleDecker: 1400
    },
    label: "Second Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the second axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    positionByType: { AutobusNormalFloor3Axle: 1230, Autobus18Mt: 1130, DoubleDecker: 1400 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    label: "Third Axle Left Side: Complete Wheel",
    group: "tire-sizes",
    description: "A photo of the complete wheel on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    positionByType: { AutobusNormalFloor3Axle: 1250, Autobus18Mt: 1150, DoubleDecker: 1420 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    label: "Third Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of the tyre thickness on the third axle, left side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    positionByType: { AutobusNormalFloor3Axle: 1270, Autobus18Mt: 1170, DoubleDecker: 1440 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1290, Autobus18Mt: 1190, DoubleDecker: 1460 },
    label: "Third Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the third axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    positionByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1290,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1190,
      DoubleDecker: 1460
    },
    positionAdminByType: {
      MinibusCityIntercity: 900,
      MinibusTouristic: 1080,
      AutobusNormalFloor2Axle: 1160,
      AutobusNormalFloor3Axle: 1310,
      AutobusLowFloorLowEntry8_12Mt: 980,
      Autobus18Mt: 1210,
      DoubleDecker: 1480
    },
    label: "First Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of the tyre tread on the first axle, right side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    positionByType: {
      MinibusCityIntercity: 440,
      MinibusTouristic: 610,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 850
    },
    positionAdminByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    label: "Front Undercarriage",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    positionByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 710,
      AutobusNormalFloor3Axle: 700,
      AutobusLowFloorLowEntry8_12Mt: 530,
      Autobus18Mt: 560,
      DoubleDecker: 870
    },
    positionAdminByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    label: "First Axle Right Side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    positionByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    positionAdminByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    label: "First Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    positionByType: {
      MinibusCityIntercity: 530,
      MinibusTouristic: 700,
      AutobusNormalFloor2Axle: 730,
      AutobusNormalFloor3Axle: 720,
      AutobusLowFloorLowEntry8_12Mt: 550,
      Autobus18Mt: 580,
      DoubleDecker: 890
    },
    positionAdminByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    label: "First Axle Brake Calipers Right Side",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    positionByType: {
      MinibusCityIntercity: 540,
      MinibusTouristic: 710,
      AutobusNormalFloor2Axle: 740,
      AutobusNormalFloor3Axle: 730,
      AutobusLowFloorLowEntry8_12Mt: 560,
      Autobus18Mt: 590,
      DoubleDecker: 900
    },
    positionAdminByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    label: "First Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    positionByType: {
      MinibusCityIntercity: 550,
      MinibusTouristic: 720,
      AutobusNormalFloor2Axle: 750,
      AutobusNormalFloor3Axle: 740,
      AutobusLowFloorLowEntry8_12Mt: 570,
      Autobus18Mt: 600,
      DoubleDecker: 910
    },
    positionAdminByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    label: "First Axle Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    positionByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 860
    },
    positionAdminByType: {
      MinibusCityIntercity: 520,
      MinibusTouristic: 690,
      AutobusNormalFloor2Axle: 720,
      AutobusNormalFloor3Axle: 710,
      AutobusLowFloorLowEntry8_12Mt: 540,
      Autobus18Mt: 570,
      DoubleDecker: 880
    },
    label: "First Axle Central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    positionByType: {
      MinibusCityIntercity: 560,
      MinibusTouristic: 730,
      AutobusNormalFloor2Axle: 760,
      AutobusNormalFloor3Axle: 750,
      AutobusLowFloorLowEntry8_12Mt: 580,
      Autobus18Mt: 610,
      DoubleDecker: 920
    },
    positionAdminByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    label: "First Axle Left Side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    positionByType: {
      MinibusCityIntercity: 570,
      MinibusTouristic: 740,
      AutobusNormalFloor2Axle: 770,
      AutobusNormalFloor3Axle: 760,
      AutobusLowFloorLowEntry8_12Mt: 590,
      Autobus18Mt: 620,
      DoubleDecker: 930
    },
    positionAdminByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    label: "First Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    positionByType: {
      MinibusCityIntercity: 580,
      MinibusTouristic: 750,
      AutobusNormalFloor2Axle: 780,
      AutobusNormalFloor3Axle: 770,
      AutobusLowFloorLowEntry8_12Mt: 600,
      Autobus18Mt: 630,
      DoubleDecker: 940
    },
    positionAdminByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    label: "First Axle Brake Calipers Left Side",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    positionByType: {
      MinibusCityIntercity: 590,
      MinibusTouristic: 760,
      AutobusNormalFloor2Axle: 790,
      AutobusNormalFloor3Axle: 780,
      AutobusLowFloorLowEntry8_12Mt: 610,
      Autobus18Mt: 640,
      DoubleDecker: 950
    },
    positionAdminByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    label: "First Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    positionByType: {
      MinibusCityIntercity: 600,
      MinibusTouristic: 770,
      AutobusNormalFloor2Axle: 800,
      AutobusNormalFloor3Axle: 790,
      AutobusLowFloorLowEntry8_12Mt: 620,
      Autobus18Mt: 650,
      DoubleDecker: 960
    },
    positionAdminByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    label: "First Axle Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    positionByType: {
      MinibusCityIntercity: 610,
      MinibusTouristic: 780,
      AutobusNormalFloor2Axle: 810,
      AutobusNormalFloor3Axle: 800,
      AutobusLowFloorLowEntry8_12Mt: 630,
      Autobus18Mt: 660,
      DoubleDecker: 970
    },
    positionAdminByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    label: "Central Undercarriage",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    positionByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    positionAdminByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    label: "Second Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    positionByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    positionAdminByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    label: "Second Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "Second Axle Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "Second Axle Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    positionByType: {
      MinibusCityIntercity: 670,
      MinibusTouristic: 840,
      AutobusNormalFloor2Axle: 870,
      AutobusNormalFloor3Axle: 860,
      AutobusLowFloorLowEntry8_12Mt: 690,
      Autobus18Mt: 720,
      DoubleDecker: 1030
    },
    positionAdminByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    label: "Second Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    positionByType: {
      MinibusCityIntercity: 690,
      MinibusTouristic: 860,
      AutobusNormalFloor2Axle: 890,
      AutobusNormalFloor3Axle: 880,
      AutobusLowFloorLowEntry8_12Mt: 710,
      Autobus18Mt: 740,
      DoubleDecker: 1050
    },
    positionAdminByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    label: "Second Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    positionByType: {
      MinibusCityIntercity: 710,
      MinibusTouristic: 880,
      AutobusNormalFloor2Axle: 910,
      AutobusNormalFloor3Axle: 900,
      AutobusLowFloorLowEntry8_12Mt: 730,
      Autobus18Mt: 760,
      DoubleDecker: 1070
    },
    positionAdminByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    label: "Second Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    positionByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    positionAdminByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    label: "Second Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    positionByType: {
      MinibusCityIntercity: 730,
      MinibusTouristic: 900,
      AutobusNormalFloor2Axle: 930,
      AutobusNormalFloor3Axle: 920,
      AutobusLowFloorLowEntry8_12Mt: 750,
      Autobus18Mt: 780,
      DoubleDecker: 1090
    },
    positionAdminByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    label: "Second Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_first_shock_absorbers_right_side: {
    name: "photo_second_axle_first_shock_absorbers_right_side",
    position: 995,
    position_admin: 995,
    positionByType: {
      MinibusCityIntercity: 660,
      MinibusTouristic: 830,
      AutobusNormalFloor2Axle: 860,
      AutobusNormalFloor3Axle: 850,
      AutobusLowFloorLowEntry8_12Mt: 680,
      Autobus18Mt: 710,
      DoubleDecker: 1020
    },
    positionAdminByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    label: "Second Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    positionByType: {
      MinibusCityIntercity: 740,
      MinibusTouristic: 910,
      AutobusNormalFloor2Axle: 940,
      AutobusNormalFloor3Axle: 930,
      AutobusLowFloorLowEntry8_12Mt: 760,
      Autobus18Mt: 790,
      DoubleDecker: 1100
    },
    positionAdminByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    label: "Second Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_second_shock_absorbers_right_side: {
    name: "photo_second_axle_second_shock_absorbers_right_side",
    position: 1005,
    position_admin: 1005,
    positionByType: {
      MinibusCityIntercity: 680,
      MinibusTouristic: 850,
      AutobusNormalFloor2Axle: 880,
      AutobusNormalFloor3Axle: 870,
      AutobusLowFloorLowEntry8_12Mt: 700,
      Autobus18Mt: 730,
      DoubleDecker: 1040
    },
    positionAdminByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    label: "Second Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    positionByType: {
      MinibusCityIntercity: 750,
      MinibusTouristic: 920,
      AutobusNormalFloor2Axle: 950,
      AutobusNormalFloor3Axle: 940,
      AutobusLowFloorLowEntry8_12Mt: 770,
      Autobus18Mt: 800,
      DoubleDecker: 1110
    },
    positionAdminByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 960,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 820,
      DoubleDecker: 1130
    },
    label: "Second Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    positionByType: {
      MinibusCityIntercity: 760,
      MinibusTouristic: 930,
      AutobusNormalFloor2Axle: 960,
      AutobusNormalFloor3Axle: 950,
      AutobusLowFloorLowEntry8_12Mt: 780,
      Autobus18Mt: 810,
      DoubleDecker: 1120
    },
    positionAdminByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 970,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 830,
      DoubleDecker: 1140
    },
    label: "Second Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    positionByType: {
      MinibusCityIntercity: 620,
      MinibusTouristic: 790,
      AutobusNormalFloor2Axle: 820,
      AutobusNormalFloor3Axle: 810,
      AutobusLowFloorLowEntry8_12Mt: 640,
      Autobus18Mt: 670,
      DoubleDecker: 980
    },
    positionAdminByType: {
      MinibusCityIntercity: 640,
      MinibusTouristic: 810,
      AutobusNormalFloor2Axle: 840,
      AutobusNormalFloor3Axle: 830,
      AutobusLowFloorLowEntry8_12Mt: 660,
      Autobus18Mt: 690,
      DoubleDecker: 1e3
    },
    label: "Second Axle Central",
    group: "undercarriage",
    description: "A photo of the second axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    positionByType: {
      MinibusCityIntercity: 700,
      MinibusTouristic: 870,
      AutobusNormalFloor2Axle: 900,
      AutobusNormalFloor3Axle: 890,
      AutobusLowFloorLowEntry8_12Mt: 720,
      Autobus18Mt: 750,
      DoubleDecker: 1060
    },
    positionAdminByType: {
      MinibusCityIntercity: 720,
      MinibusTouristic: 890,
      AutobusNormalFloor2Axle: 920,
      AutobusNormalFloor3Axle: 910,
      AutobusLowFloorLowEntry8_12Mt: 740,
      Autobus18Mt: 770,
      DoubleDecker: 1080
    },
    label: "Second Axle Left Side",
    group: "undercarriage",
    description: "A photo of the second axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side: {
    name: "photo_second_axle_right_side",
    position: 1045,
    position_admin: 1045,
    positionByType: {
      MinibusCityIntercity: 630,
      MinibusTouristic: 800,
      AutobusNormalFloor2Axle: 830,
      AutobusNormalFloor3Axle: 820,
      AutobusLowFloorLowEntry8_12Mt: 650,
      Autobus18Mt: 680,
      DoubleDecker: 990
    },
    positionAdminByType: {
      MinibusCityIntercity: 650,
      MinibusTouristic: 820,
      AutobusNormalFloor2Axle: 850,
      AutobusNormalFloor3Axle: 840,
      AutobusLowFloorLowEntry8_12Mt: 670,
      Autobus18Mt: 700,
      DoubleDecker: 1010
    },
    label: "Second Axle Right Side",
    group: "undercarriage",
    description: "A photo of the second axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    positionByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    label: "Third Axle Discs Right Side",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    positionByType: { AutobusNormalFloor3Axle: 990, Autobus18Mt: 860, DoubleDecker: 1160 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    label: "Third Axle Caliper Brakes Right Side",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    positionByType: { AutobusNormalFloor3Axle: 1e3, Autobus18Mt: 870, DoubleDecker: 1170 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 890, DoubleDecker: 1190 },
    label: "Third Axle First Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    positionByType: { AutobusNormalFloor3Axle: 1010, Autobus18Mt: 880, DoubleDecker: 1180 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 900, DoubleDecker: 1200 },
    label: "Third Axle First Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    positionByType: { Autobus18Mt: 890 },
    positionAdminByType: { Autobus18Mt: 910 },
    label: "Third Axle Second Shock Absorbers Right Side",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    positionByType: { Autobus18Mt: 900 },
    positionAdminByType: { Autobus18Mt: 920 },
    label: "Third Axle Second Air Springs Right Side",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    positionByType: {
      AutobusNormalFloor3Axle: 970,
      Autobus18Mt: 840,
      DoubleDecker: 1140
    },
    positionAdminByType: {
      AutobusNormalFloor3Axle: 990,
      Autobus18Mt: 860,
      DoubleDecker: 1160
    },
    label: "Third Axle Right Side",
    group: "undercarriage",
    description: "A photo of the third axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    positionByType: { AutobusNormalFloor3Axle: 1030, Autobus18Mt: 920, DoubleDecker: 1200 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    label: "Third Axle Discs Left Side",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    positionByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    label: "Third Axle Caliper Brakes Left Side",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    positionByType: { AutobusNormalFloor3Axle: 1050, Autobus18Mt: 940, DoubleDecker: 1220 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1070, Autobus18Mt: 960, DoubleDecker: 1240 },
    label: "Third Axle First Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    positionByType: { Autobus18Mt: 960 },
    positionAdminByType: { Autobus18Mt: 980 },
    label: "Third Axle Second Shock Absorbers Left Side",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    positionByType: { AutobusNormalFloor3Axle: 1060, Autobus18Mt: 950, DoubleDecker: 1230 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1080, Autobus18Mt: 970, DoubleDecker: 1250 },
    label: "Third Axle First Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    positionByType: { Autobus18Mt: 970 },
    positionAdminByType: { Autobus18Mt: 990 },
    label: "Third Axle Second Air Springs Left Side",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    positionByType: {
      MinibusCityIntercity: 770,
      MinibusTouristic: 940,
      AutobusNormalFloor2Axle: 970,
      AutobusNormalFloor3Axle: 1070,
      AutobusLowFloorLowEntry8_12Mt: 790,
      Autobus18Mt: 980,
      DoubleDecker: 1240
    },
    positionAdminByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 960,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    label: "Differential",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    positionByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 990,
      AutobusNormalFloor3Axle: 1090,
      AutobusLowFloorLowEntry8_12Mt: 810,
      Autobus18Mt: 1e3,
      DoubleDecker: 1260
    },
    positionAdminByType: {
      MinibusCityIntercity: 470,
      MinibusTouristic: 640,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    label: "Gearbox",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    positionByType: {
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    label: "Gearbox Plate",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    positionByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 980,
      AutobusNormalFloor3Axle: 1080,
      AutobusLowFloorLowEntry8_12Mt: 800,
      Autobus18Mt: 990,
      DoubleDecker: 1250
    },
    positionAdminByType: {
      MinibusCityIntercity: 500,
      MinibusTouristic: 670,
      AutobusNormalFloor2Axle: 1e3,
      AutobusNormalFloor3Axle: 1100,
      AutobusLowFloorLowEntry8_12Mt: 820,
      Autobus18Mt: 1010,
      DoubleDecker: 1270
    },
    label: "Driveshaft",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    positionByType: {
      MinibusCityIntercity: 460,
      MinibusTouristic: 630,
      AutobusNormalFloor2Axle: 1010,
      AutobusNormalFloor3Axle: 1110,
      AutobusLowFloorLowEntry8_12Mt: 830,
      Autobus18Mt: 1020,
      DoubleDecker: 1280
    },
    positionAdminByType: {
      MinibusCityIntercity: 480,
      MinibusTouristic: 650,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    label: "Engine Without Protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    positionByType: {
      MinibusCityIntercity: 490,
      MinibusTouristic: 660,
      AutobusNormalFloor2Axle: 1020,
      AutobusNormalFloor3Axle: 1120,
      AutobusLowFloorLowEntry8_12Mt: 840,
      Autobus18Mt: 1030,
      DoubleDecker: 1290
    },
    positionAdminByType: {
      MinibusCityIntercity: 510,
      MinibusTouristic: 680,
      AutobusNormalFloor2Axle: 1040,
      AutobusNormalFloor3Axle: 1140,
      AutobusLowFloorLowEntry8_12Mt: 860,
      Autobus18Mt: 1050,
      DoubleDecker: 1310
    },
    label: "Exhaust",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    positionByType: { Autobus18Mt: 820 },
    positionAdminByType: { Autobus18Mt: 840 },
    label: "Undercarriage Turntable",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    positionByType: {
      MinibusCityIntercity: 900,
      MinibusTouristic: 1080,
      AutobusNormalFloor2Axle: 1160,
      AutobusNormalFloor3Axle: 1310,
      AutobusLowFloorLowEntry8_12Mt: 980,
      Autobus18Mt: 1210,
      DoubleDecker: 1480
    },
    positionAdminByType: {
      MinibusCityIntercity: 10,
      MinibusTouristic: 10,
      AutobusNormalFloor2Axle: 10,
      AutobusNormalFloor3Axle: 10,
      AutobusLowFloorLowEntry8_12Mt: 10,
      Autobus18Mt: 10,
      DoubleDecker: 10
    },
    label: "Vin",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 110, MinibusTouristic: 100 },
    positionAdminByType: { MinibusCityIntercity: 130, MinibusTouristic: 120 },
    label: "Front Engine",
    group: "exteriors",
    description: "A photo of the engine at the front of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_fourth_door_open: {
    name: "photo_fourth_door_open",
    position: 145,
    position_admin: 145,
    positionByType: { Autobus18Mt: 170 },
    positionAdminByType: { Autobus18Mt: 190 },
    label: "Fourth Door Open",
    group: "exteriors",
    description: "A photo of: Fourth Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_complete_tyre: {
    name: "photo_first_axle_left_side_complete_tyre",
    position: 695,
    position_admin: 695,
    positionByType: {
      MinibusCityIntercity: 790,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1050,
      DoubleDecker: 1320
    },
    positionAdminByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    label: "First Axle Left Side: Complete Tyre",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Complete Tyre.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_first_axle_left_side_tyre_thickness: {
    name: "photo_first_axle_left_side_tyre_thickness",
    position: 705,
    position_admin: 705,
    positionByType: {
      MinibusCityIntercity: 810,
      MinibusTouristic: 990,
      AutobusNormalFloor2Axle: 1070,
      AutobusNormalFloor3Axle: 1170,
      AutobusLowFloorLowEntry8_12Mt: 890,
      Autobus18Mt: 1070,
      DoubleDecker: 1340
    },
    positionAdminByType: {
      MinibusCityIntercity: 830,
      MinibusTouristic: 1010,
      AutobusNormalFloor2Axle: 1090,
      AutobusNormalFloor3Axle: 1190,
      AutobusLowFloorLowEntry8_12Mt: 910,
      Autobus18Mt: 1090,
      DoubleDecker: 1360
    },
    label: "First Axle Left Side: Tyre Thickness",
    group: "tire-sizes",
    description: "A photo of: First Axle Left Side: Tyre Thickness.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_size: {
    name: "photo_second_axle_left_side_tyre_size",
    position: 725,
    position_admin: 725,
    positionByType: {
      MinibusCityIntercity: 840,
      MinibusTouristic: 1020,
      AutobusNormalFloor2Axle: 1100,
      AutobusNormalFloor3Axle: 1200,
      AutobusLowFloorLowEntry8_12Mt: 920,
      Autobus18Mt: 1100,
      DoubleDecker: 1370
    },
    positionAdminByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    label: "Second Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_left_side_tyre_tread: {
    name: "photo_second_axle_left_side_tyre_tread",
    position: 735,
    position_admin: 735,
    positionByType: {
      MinibusCityIntercity: 860,
      MinibusTouristic: 1040,
      AutobusNormalFloor2Axle: 1120,
      AutobusNormalFloor3Axle: 1220,
      AutobusLowFloorLowEntry8_12Mt: 940,
      Autobus18Mt: 1120,
      DoubleDecker: 1390
    },
    positionAdminByType: {
      MinibusCityIntercity: 880,
      MinibusTouristic: 1060,
      AutobusNormalFloor2Axle: 1140,
      AutobusNormalFloor3Axle: 1240,
      AutobusLowFloorLowEntry8_12Mt: 960,
      Autobus18Mt: 1140,
      DoubleDecker: 1410
    },
    label: "Second Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_size: {
    name: "photo_third_axle_left_side_tyre_size",
    position: 745,
    position_admin: 745,
    positionByType: { AutobusNormalFloor3Axle: 1240, Autobus18Mt: 1140, DoubleDecker: 1410 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    label: "Third Axle Left Side: Tyre Size",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Size.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side_tyre_tread: {
    name: "photo_third_axle_left_side_tyre_tread",
    position: 755,
    position_admin: 755,
    positionByType: { AutobusNormalFloor3Axle: 1260, Autobus18Mt: 1160, DoubleDecker: 1430 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1280, Autobus18Mt: 1180, DoubleDecker: 1450 },
    label: "Third Axle Left Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Third Axle Left Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_second_axle_right_side_tyre_tread: {
    name: "photo_second_axle_right_side_tyre_tread",
    position: 765,
    position_admin: 765,
    positionByType: {
      MinibusCityIntercity: 870,
      MinibusTouristic: 1050,
      AutobusNormalFloor2Axle: 1130,
      AutobusNormalFloor3Axle: 1280,
      AutobusLowFloorLowEntry8_12Mt: 950,
      Autobus18Mt: 1180,
      DoubleDecker: 1450
    },
    positionAdminByType: {
      MinibusCityIntercity: 890,
      MinibusTouristic: 1070,
      AutobusNormalFloor2Axle: 1150,
      AutobusNormalFloor3Axle: 1300,
      AutobusLowFloorLowEntry8_12Mt: 970,
      Autobus18Mt: 1200,
      DoubleDecker: 1470
    },
    label: "Second Axle Right Side: Tyre Tread",
    group: "tire-sizes",
    description: "A photo of: Second Axle Right Side: Tyre Tread.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_left_side: {
    name: "photo_third_axle_left_side",
    position: 1185,
    position_admin: 1185,
    positionByType: { AutobusNormalFloor3Axle: 1020, Autobus18Mt: 910, DoubleDecker: 1190 },
    positionAdminByType: { AutobusNormalFloor3Axle: 1040, Autobus18Mt: 930, DoubleDecker: 1210 },
    label: "Third Axle Left Side",
    group: "undercarriage",
    description: "A photo of: Third Axle Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_third_axle_central: {
    name: "photo_third_axle_central",
    position: 1195,
    position_admin: 1195,
    positionByType: { AutobusNormalFloor3Axle: 960, Autobus18Mt: 830, DoubleDecker: 1130 },
    positionAdminByType: { AutobusNormalFloor3Axle: 980, Autobus18Mt: 850, DoubleDecker: 1150 },
    label: "Third Axle Central",
    group: "undercarriage",
    description: "A photo of: Third Axle Central.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_door_open: {
    name: "photo_driver_door_open",
    position: 1300,
    position_admin: 1300,
    positionByType: { MinibusCityIntercity: 200, MinibusTouristic: 200 },
    positionAdminByType: { MinibusCityIntercity: 220, MinibusTouristic: 220 },
    label: "Driver Door Open",
    group: "exteriors",
    description: "A photo of: Driver Door Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_doors_open: {
    name: "photo_rear_doors_open",
    position: 1310,
    position_admin: 1310,
    positionByType: { MinibusCityIntercity: 210, MinibusTouristic: 210 },
    positionAdminByType: { MinibusCityIntercity: 230, MinibusTouristic: 230 },
    label: "Rear Doors Open",
    group: "exteriors",
    description: "A photo of: Rear Doors Open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_electric_parking_brake: {
    name: "photo_electric_parking_brake",
    position: 1320,
    position_admin: 1320,
    positionByType: { MinibusCityIntercity: 470, MinibusTouristic: 640 },
    positionAdminByType: { MinibusCityIntercity: 490, MinibusTouristic: 660 },
    label: "Electric Parking Brake",
    group: "undercarriage",
    description: "A photo of: Electric Parking Brake.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_undercarriage: {
    name: "photo_rear_undercarriage",
    position: 1330,
    position_admin: 1330,
    positionByType: {
      MinibusCityIntercity: 780,
      MinibusTouristic: 950,
      AutobusNormalFloor2Axle: 1030,
      AutobusNormalFloor3Axle: 1130,
      AutobusLowFloorLowEntry8_12Mt: 850,
      Autobus18Mt: 1040,
      DoubleDecker: 1300
    },
    positionAdminByType: {
      MinibusCityIntercity: 800,
      MinibusTouristic: 970,
      AutobusNormalFloor2Axle: 1050,
      AutobusNormalFloor3Axle: 1150,
      AutobusLowFloorLowEntry8_12Mt: 870,
      Autobus18Mt: 1060,
      DoubleDecker: 1320
    },
    label: "Rear Undercarriage",
    group: "undercarriage",
    description: "A photo of: Rear Undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_1: {
    name: "photo_luggage_rear_1",
    position: 1340,
    position_admin: 1340,
    positionByType: { MinibusTouristic: 250 },
    positionAdminByType: { MinibusTouristic: 270 },
    label: "Luggage Rear 1",
    group: "exteriors",
    description: "A photo of: Luggage Rear 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_2: {
    name: "photo_luggage_rear_2",
    position: 1350,
    position_admin: 1350,
    positionByType: { MinibusTouristic: 260 },
    positionAdminByType: { MinibusTouristic: 280 },
    label: "Luggage Rear 2",
    group: "exteriors",
    description: "A photo of: Luggage Rear 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rear_3: {
    name: "photo_luggage_rear_3",
    position: 1360,
    position_admin: 1360,
    positionByType: { MinibusTouristic: 270 },
    positionAdminByType: { MinibusTouristic: 290 },
    label: "Luggage Rear 3",
    group: "exteriors",
    description: "A photo of: Luggage Rear 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage_rack_right: {
    name: "photo_luggage_rack_right",
    position: 1370,
    position_admin: 1370,
    positionByType: { MinibusTouristic: 280, DoubleDecker: 280 },
    positionAdminByType: { MinibusTouristic: 300, DoubleDecker: 300 },
    label: "Luggage Rack Right",
    group: "exteriors",
    description: "A photo of: Luggage Rack Right.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_refrigerator: {
    name: "photo_refrigerator",
    position: 1380,
    position_admin: 1380,
    positionByType: { MinibusTouristic: 400, AutobusNormalFloor2Axle: 440, AutobusNormalFloor3Axle: 430, DoubleDecker: 450 },
    positionAdminByType: { MinibusTouristic: 420, AutobusNormalFloor2Axle: 460, AutobusNormalFloor3Axle: 450, DoubleDecker: 470 },
    label: "Refrigerator",
    group: "interiors",
    description: "A photo of: Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_suppression_nozzles: {
    name: "photo_fire_suppression_nozzles",
    position: 1390,
    position_admin: 1390,
    positionByType: {
      AutobusNormalFloor2Axle: 170,
      AutobusNormalFloor3Axle: 170,
      AutobusLowFloorLowEntry8_12Mt: 180,
      Autobus18Mt: 200,
      DoubleDecker: 180
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 190,
      AutobusNormalFloor3Axle: 190,
      AutobusLowFloorLowEntry8_12Mt: 200,
      Autobus18Mt: 220,
      DoubleDecker: 200
    },
    label: "Fire Suppression Nozzles",
    group: "exteriors",
    description: "A photo of: Fire Suppression Nozzles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driver_s_bunk: {
    name: "photo_driver_s_bunk",
    position: 1400,
    position_admin: 1400,
    positionByType: { AutobusNormalFloor2Axle: 270, AutobusNormalFloor3Axle: 270, DoubleDecker: 290 },
    positionAdminByType: { AutobusNormalFloor2Axle: 290, AutobusNormalFloor3Axle: 290, DoubleDecker: 310 },
    label: "Driver's Bunk",
    group: "exteriors",
    description: "A photo of: Driver's Bunk.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_onboard_device_3_left_side: {
    name: "photo_onboard_device_3_left_side",
    position: 1410,
    position_admin: 1410,
    positionByType: {
      AutobusNormalFloor2Axle: 390,
      AutobusNormalFloor3Axle: 380,
      AutobusLowFloorLowEntry8_12Mt: 330,
      Autobus18Mt: 350,
      DoubleDecker: 400
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 410,
      AutobusNormalFloor3Axle: 400,
      AutobusLowFloorLowEntry8_12Mt: 350,
      Autobus18Mt: 370,
      DoubleDecker: 420
    },
    label: "Onboard Device 3 Left Side",
    group: "interiors",
    description: "A photo of: Onboard Device 3 Left Side.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_2: {
    name: "photo_monitor_2",
    position: 1420,
    position_admin: 1420,
    positionByType: { DoubleDecker: 630 },
    positionAdminByType: { DoubleDecker: 650 },
    label: "Monitor 2",
    group: "interiors",
    description: "A photo of: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_3: {
    name: "photo_monitor_3",
    position: 1430,
    position_admin: 1430,
    positionByType: { DoubleDecker: 640 },
    positionAdminByType: { DoubleDecker: 660 },
    label: "Monitor 3",
    group: "interiors",
    description: "A photo of: Monitor 3.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_monitor_4: {
    name: "photo_monitor_4",
    position: 1440,
    position_admin: 1440,
    positionByType: { DoubleDecker: 650 },
    positionAdminByType: { DoubleDecker: 670 },
    label: "Monitor 4",
    group: "interiors",
    description: "A photo of: Monitor 4.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_refrigerator: {
    name: "photo_second_refrigerator",
    position: 1450,
    position_admin: 1450,
    positionByType: { DoubleDecker: 680 },
    positionAdminByType: { DoubleDecker: 700 },
    label: "Second Refrigerator",
    group: "interiors",
    description: "A photo of: Second Refrigerator.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_kitchen: {
    name: "photo_kitchen",
    position: 1460,
    position_admin: 1460,
    positionByType: { DoubleDecker: 690 },
    positionAdminByType: { DoubleDecker: 710 },
    label: "Kitchen",
    group: "interiors",
    description: "A photo of: Kitchen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_1: {
    name: "photo_ladder_1",
    position: 1470,
    position_admin: 1470,
    positionByType: { DoubleDecker: 720 },
    positionAdminByType: { DoubleDecker: 740 },
    label: "Ladder 1",
    group: "interiors",
    description: "A photo of: Ladder 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_ladder_2: {
    name: "photo_ladder_2",
    position: 1480,
    position_admin: 1480,
    positionByType: { DoubleDecker: 730 },
    positionAdminByType: { DoubleDecker: 750 },
    label: "Ladder 2",
    group: "interiors",
    description: "A photo of: Ladder 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_windscreen_position: {
    name: "photo_second_floor_reverse_seats_from_windscreen_position",
    position: 1490,
    position_admin: 1490,
    positionByType: { DoubleDecker: 740 },
    positionAdminByType: { DoubleDecker: 760 },
    label: "Second Floor: Reverse Seats From Windscreen Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Windscreen Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_reverse_seats_from_middle_position: {
    name: "photo_second_floor_reverse_seats_from_middle_position",
    position: 1500,
    position_admin: 1500,
    positionByType: { DoubleDecker: 750 },
    positionAdminByType: { DoubleDecker: 770 },
    label: "Second Floor: Reverse Seats From Middle Position",
    group: "interiors",
    description: "A photo of: Second Floor: Reverse Seats From Middle Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_forward_seats_from_end_position: {
    name: "photo_second_floor_forward_seats_from_end_position",
    position: 1510,
    position_admin: 1510,
    positionByType: { DoubleDecker: 760 },
    positionAdminByType: { DoubleDecker: 780 },
    label: "Second Floor: Forward Seats From End Position",
    group: "interiors",
    description: "A photo of: Second Floor: Forward Seats From End Position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_overhead_compartments: {
    name: "photo_second_floor_overhead_compartments",
    position: 1520,
    position_admin: 1520,
    positionByType: { DoubleDecker: 770 },
    positionAdminByType: { DoubleDecker: 790 },
    label: "Second Floor: Overhead Compartments",
    group: "interiors",
    description: "A photo of: Second Floor: Overhead compartments.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_1: {
    name: "photo_second_floor_monitor_1",
    position: 1530,
    position_admin: 1530,
    positionByType: { DoubleDecker: 810 },
    positionAdminByType: { DoubleDecker: 830 },
    label: "Second Floor: Monitor 1",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 1.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_second_floor_monitor_2: {
    name: "photo_second_floor_monitor_2",
    position: 1540,
    position_admin: 1540,
    positionByType: { DoubleDecker: 820 },
    positionAdminByType: { DoubleDecker: 840 },
    label: "Second Floor: Monitor 2",
    group: "interiors",
    description: "A photo of: Second Floor: Monitor 2.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_right_side: {
    name: "photo_windscreen_from_right_side",
    position: 1620,
    position_admin: 1620,
    positionByType: {
      MinibusCityIntercity: 30,
      MinibusTouristic: 30,
      AutobusNormalFloor2Axle: 30,
      AutobusNormalFloor3Axle: 30,
      AutobusLowFloorLowEntry8_12Mt: 30,
      Autobus18Mt: 30,
      DoubleDecker: 30
    },
    positionAdminByType: {
      MinibusCityIntercity: 50,
      MinibusTouristic: 50,
      AutobusNormalFloor2Axle: 50,
      AutobusNormalFloor3Axle: 50,
      AutobusLowFloorLowEntry8_12Mt: 50,
      Autobus18Mt: 50,
      DoubleDecker: 50
    },
    label: "Windscreen From Right Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Right Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_windscreen_from_left_side: {
    name: "photo_windscreen_from_left_side",
    position: 1630,
    position_admin: 1630,
    positionByType: {
      MinibusCityIntercity: 40,
      MinibusTouristic: 40,
      AutobusNormalFloor2Axle: 40,
      AutobusNormalFloor3Axle: 40,
      AutobusLowFloorLowEntry8_12Mt: 40,
      Autobus18Mt: 40,
      DoubleDecker: 40
    },
    positionAdminByType: {
      MinibusCityIntercity: 60,
      MinibusTouristic: 60,
      AutobusNormalFloor2Axle: 60,
      AutobusNormalFloor3Axle: 60,
      AutobusLowFloorLowEntry8_12Mt: 60,
      Autobus18Mt: 60,
      DoubleDecker: 60
    },
    label: "Windscreen From Left Side",
    group: "exteriors",
    description: "A photo of: Windscreen From Left Side.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_upper_windscreen: {
    name: "photo_upper_windscreen",
    position: 1640,
    position_admin: 1640,
    positionByType: { DoubleDecker: 50 },
    positionAdminByType: { DoubleDecker: 70 },
    label: "Upper Windscreen",
    group: "exteriors",
    description: "A photo of: Upper Windscreen.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  }
}, hT = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, Iy = {
  video_internal_second_floor_reverse_seats_full: {
    name: "video_internal_second_floor_reverse_seats_full",
    label: "Video: Internal-Second Floor: Reverse Seats From Windscreen Position to the End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 830 },
    positionAdminByType: { DoubleDecker: 850 }
  },
  video_internal_second_floor_second: {
    name: "video_internal_second_floor_second",
    label: "Video: Internal-Second Floor-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: { DoubleDecker: 840 },
    positionAdminByType: { DoubleDecker: 860 }
  },
  video_engine_working: {
    name: "video_engine_working",
    label: "Video: Engine Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 120,
      MinibusTouristic: 110,
      AutobusNormalFloor2Axle: 180,
      AutobusNormalFloor3Axle: 180,
      AutobusLowFloorLowEntry8_12Mt: 190,
      Autobus18Mt: 210,
      DoubleDecker: 190
    },
    positionAdminByType: {
      MinibusCityIntercity: 140,
      MinibusTouristic: 130,
      AutobusNormalFloor2Axle: 200,
      AutobusNormalFloor3Axle: 200,
      AutobusLowFloorLowEntry8_12Mt: 210,
      Autobus18Mt: 230,
      DoubleDecker: 210
    }
  },
  video_wheelchair_ramp_working: {
    name: "video_wheelchair_ramp_working",
    label: "Video: Automatic Wheelchair Ramp Working",
    group: "exteriors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 170,
      MinibusTouristic: 170,
      AutobusNormalFloor2Axle: 210,
      AutobusNormalFloor3Axle: 210,
      AutobusLowFloorLowEntry8_12Mt: 220,
      Autobus18Mt: 240,
      DoubleDecker: 220
    },
    positionAdminByType: {
      MinibusCityIntercity: 190,
      MinibusTouristic: 190,
      AutobusNormalFloor2Axle: 230,
      AutobusNormalFloor3Axle: 230,
      AutobusLowFloorLowEntry8_12Mt: 240,
      Autobus18Mt: 260,
      DoubleDecker: 240
    }
  },
  video_internal_driver_to_end: {
    name: "video_internal_driver_to_end",
    label: "Video: Internal-From Driver Position To The End Of The Vehicle",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      MinibusCityIntercity: 430,
      MinibusTouristic: 600,
      AutobusNormalFloor2Axle: 670,
      AutobusNormalFloor3Axle: 660,
      AutobusLowFloorLowEntry8_12Mt: 490,
      Autobus18Mt: 520,
      DoubleDecker: 700
    },
    positionAdminByType: {
      MinibusCityIntercity: 450,
      MinibusTouristic: 620,
      AutobusNormalFloor2Axle: 690,
      AutobusNormalFloor3Axle: 680,
      AutobusLowFloorLowEntry8_12Mt: 510,
      Autobus18Mt: 540,
      DoubleDecker: 720
    }
  },
  video_internal_second: {
    name: "video_internal_second",
    label: "Video: Internal-Second Video",
    group: "interiors",
    isInternal: !1,
    positionByType: {
      AutobusNormalFloor2Axle: 680,
      AutobusNormalFloor3Axle: 670,
      AutobusLowFloorLowEntry8_12Mt: 500,
      Autobus18Mt: 530,
      DoubleDecker: 710
    },
    positionAdminByType: {
      AutobusNormalFloor2Axle: 700,
      AutobusNormalFloor3Axle: 690,
      AutobusLowFloorLowEntry8_12Mt: 520,
      Autobus18Mt: 550,
      DoubleDecker: 730
    }
  },
  video_warranty: {
    name: "video_warranty",
    label: "Video: Fleequid Internal Use Video",
    group: "exteriors",
    isInternal: !0,
    positionAdminByType: {
      MinibusCityIntercity: 910,
      MinibusTouristic: 14500,
      AutobusNormalFloor2Axle: 14500,
      AutobusNormalFloor3Axle: 14500,
      AutobusLowFloorLowEntry8_12Mt: 14500,
      Autobus18Mt: 14500,
      DoubleDecker: 14500
    }
  }
}, xy = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], Sy = [
  {
    name: "Abruzzo",
    code: "IT-65",
    regionMacro: "center",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    regionMacro: "south",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    regionMacro: "south",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    regionMacro: "south",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    regionMacro: "north",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    regionMacro: "north",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    regionMacro: "center",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    regionMacro: "north",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    regionMacro: "north",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    regionMacro: "center",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    regionMacro: "south",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    regionMacro: "north",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    regionMacro: "south",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    regionMacro: "excluded",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    regionMacro: "excluded",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    regionMacro: "center",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    regionMacro: "north",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    regionMacro: "center",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", regionMacro: "north", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    regionMacro: "north",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], vy = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], Ny = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], Zi = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    continent: "Asia",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93",
    continent: "Asia"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268",
    continent: "NorthAmerica"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264",
    continent: "NorthAmerica"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374",
    continent: "Asia"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244",
    continent: "Africa"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined",
    continent: "Antarctica"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54",
    continent: "SouthAmerica"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684",
    continent: "Oceania"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297",
    continent: "NorthAmerica"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    continent: "Europe",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994",
    continent: "Asia"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246",
    continent: "NorthAmerica"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880",
    continent: "Asia"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226",
    continent: "Africa"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257",
    continent: "Africa"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229",
    continent: "Africa"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441",
    continent: "NorthAmerica"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673",
    continent: "Asia"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591",
    continent: "SouthAmerica"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55",
    continent: "SouthAmerica"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242",
    continent: "NorthAmerica"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975",
    continent: "Asia"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47",
    continent: "Antarctica"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267",
    continent: "Africa"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501",
    continent: "NorthAmerica"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1",
    continent: "NorthAmerica"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243",
    continent: "Africa"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236",
    continent: "Africa"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242",
    continent: "Africa"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225",
    continent: "Africa"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682",
    continent: "Oceania"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56",
    continent: "SouthAmerica"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237",
    continent: "Africa"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86",
    continent: "Asia"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57",
    continent: "SouthAmerica"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506",
    continent: "NorthAmerica"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53",
    continent: "NorthAmerica"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238",
    continent: "Africa"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599",
    continent: "NorthAmerica"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61",
    continent: "Oceania"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czech Republic",
      it: "Repubblica Ceca",
      es: "República Checa",
      de: "Tschechische Republik",
      pl: "Czechy",
      fr: "République tchèque",
      nl: "Tsjechië",
      pt: "República Checa",
      cs: "Česko",
      ro: "Republica Cehă",
      ru: "Чешская Республика"
    },
    rootIddCode: "+420",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: xy,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253",
    continent: "Africa"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767",
    continent: "NorthAmerica"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849",
    continent: "NorthAmerica"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593",
    continent: "SouthAmerica"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289",
    continent: "Africa"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291",
    continent: "Africa"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Ny,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251",
    continent: "Africa"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679",
    continent: "Oceania"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500",
    continent: "SouthAmerica"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691",
    continent: "Oceania"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298",
    continent: "Europe"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241",
    continent: "Africa"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    continent: "Europe",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473",
    continent: "NorthAmerica"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995",
    continent: "Europe"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    continent: "SouthAmerica",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233",
    continent: "Africa"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350",
    continent: "Europe"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299",
    continent: "NorthAmerica"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220",
    continent: "Africa"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224",
    continent: "Africa"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240",
    continent: "Africa"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500",
    continent: "Oceania"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502",
    continent: "NorthAmerica"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671",
    continent: "NorthAmerica"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245",
    continent: "Africa"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592",
    continent: "NorthAmerica"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852",
    continent: "Asia"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined",
    continent: "Oceania"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504",
    continent: "NorthAmerica"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509",
    continent: "NorthAmerica"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62",
    continent: "Asia"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91",
    continent: "Asia"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246",
    continent: "Asia"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964",
    continent: "Asia"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98",
    continent: "Asia"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: Sy,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44",
    continent: "Europe"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876",
    continent: "NorthAmerica"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81",
    continent: "Asia"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254",
    continent: "Africa"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996",
    continent: "Asia"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855",
    continent: "Asia"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686",
    continent: "Oceania"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269",
    continent: "Africa"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869",
    continent: "NorthAmerica"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850",
    continent: "Asia"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82",
    continent: "Asia"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965",
    continent: "Asia"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345",
    continent: "NorthAmerica"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77",
    continent: "Asia"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856",
    continent: "Asia"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758",
    continent: "NorthAmerica"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94",
    continent: "Asia"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231",
    continent: "Africa"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266",
    continent: "Africa"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218",
    continent: "Africa"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590",
    continent: "NorthAmerica"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261",
    continent: "Africa"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692",
    continent: "Oceania"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223",
    continent: "Africa"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95",
    continent: "Asia"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976",
    continent: "Asia"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853",
    continent: "Asia"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670",
    continent: "NorthAmerica"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596",
    continent: "NorthAmerica"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222",
    continent: "Africa"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664",
    continent: "NorthAmerica"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230",
    continent: "Africa"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960",
    continent: "Asia"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265",
    continent: "Africa"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52",
    continent: "NorthAmerica"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60",
    continent: "Asia"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258",
    continent: "Africa"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264",
    continent: "Africa"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687",
    continent: "Oceania"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227",
    continent: "Africa"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672",
    continent: "Oceania"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234",
    continent: "Africa"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505",
    continent: "NorthAmerica"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977",
    continent: "Asia"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674",
    continent: "Oceania"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683",
    continent: "Oceania"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507",
    continent: "NorthAmerica"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51",
    continent: "SouthAmerica"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689",
    continent: "Oceania"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675",
    continent: "Oceania"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63",
    continent: "Asia"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92",
    continent: "Asia"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    continent: "Europe",
    blocMemberships: ["EU"],
    regions: vy,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508",
    continent: "NorthAmerica"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64",
    continent: "Oceania"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939",
    continent: "NorthAmerica"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680",
    continent: "Oceania"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595",
    continent: "SouthAmerica"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974",
    continent: "Asia"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250",
    continent: "Africa"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    continent: "Asia",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677",
    continent: "Oceania"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248",
    continent: "Africa"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65",
    continent: "Asia"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247",
    continent: "Africa"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779",
    continent: "Europe"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    continent: "Europe",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232",
    continent: "Africa"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221",
    continent: "Africa"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252",
    continent: "Africa"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597",
    continent: "SouthAmerica"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211",
    continent: "Africa"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239",
    continent: "Africa"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503",
    continent: "NorthAmerica"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721",
    continent: "NorthAmerica"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963",
    continent: "Asia"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268",
    continent: "Africa"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649",
    continent: "NorthAmerica"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235",
    continent: "Africa"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262",
    continent: "Oceania"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228",
    continent: "Africa"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66",
    continent: "Asia"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992",
    continent: "Asia"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690",
    continent: "Oceania"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670",
    continent: "Asia"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993",
    continent: "Asia"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    continent: "Africa",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676",
    continent: "Oceania"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90",
    continent: "Europe"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868",
    continent: "NorthAmerica"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688",
    continent: "Oceania"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886",
    continent: "Asia"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255",
    continent: "Africa"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256",
    continent: "Africa"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268",
    continent: "NorthAmerica"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989",
    continent: "NorthAmerica"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598",
    continent: "SouthAmerica"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998",
    continent: "Asia"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379",
    continent: "Europe"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784",
    continent: "NorthAmerica"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58",
    continent: "SouthAmerica"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284",
    continent: "NorthAmerica"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340",
    continent: "NorthAmerica"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84",
    continent: "Asia"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678",
    continent: "Oceania"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681",
    continent: "Oceania"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685",
    continent: "Oceania"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    continent: "Europe",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967",
    continent: "Asia"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262",
    continent: "Africa"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27",
    continent: "Africa"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260",
    continent: "Africa"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263",
    continent: "Africa"
  }
}, mT = (o) => Zi[o].i18nNames.en;
function _T(...o) {
  const n = /* @__PURE__ */ new Set();
  for (const [r, a] of Object.entries(Zi))
    o.includes(a.continent) && n.add(r);
  return n;
}
const Bl = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function bT(o) {
  if (Fy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return o;
}
function Fy(o) {
  return typeof o == "string" && Bl.includes(o);
}
const kl = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function wy(o) {
  return typeof o == "string" && Object.values(kl).includes(o);
}
function AT(o) {
  if (wy(o) !== !0)
    throw new Error(`'${o}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return o;
}
function gT(o) {
  return kl[o];
}
const yT = 10 * 1024 * 1024, TT = "pdf", Cy = Object.fromEntries(
  Object.entries(Zi).map(([o, n]) => [
    o,
    ("regions" in n ? n.regions : []).flatMap(
      (r) => ("provinces" in r ? r.provinces : []).map((a) => a)
    )
  ])
), Ey = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], By = Fl(Ey), MT = (o) => By.parse(o), IT = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, ky = [...Bl, "EU", "EXTRA_EU"];
function Dy(o) {
  return typeof o == "string" && ky.includes(o);
}
function xT(o) {
  if (Dy(o) !== !0)
    throw new Error(`'${o}' is not a valid tax code origin`);
  return o;
}
const ST = [
  "Locate every piece of visible text in this photo of a bus.",
  "Include liveries, operator names, destination signs, phone numbers, web addresses, registration plates, and any small print.",
  "Return one entry per distinct piece of text."
].join(`
`), $i = "https://145031484.fs1.hubspotusercontent-eu1.net/hubfs/145031484", vT = (o) => `${$i}/sales/${o}.jpeg`, NT = `${$i}/sales/fleequid-expert.webp`, FT = (o) => `${$i}/flags/${o}.svg`, wT = "backoffice@fleequid.com", CT = "+39 0287176063", ET = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, Ly = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function BT(o) {
  return Ly[o];
}
const kT = {
  cs: "CZ",
  de: "DE",
  en: "GB",
  es: "ES",
  fr: "FR",
  it: "IT",
  nl: "NL",
  pl: "PL",
  pt: "PT",
  ro: "RO",
  ru: "RU"
}, DT = 2, LT = 100, Dl = {
  addressNumber: Se().optional().nullable(),
  alternate: Se().optional().nullable(),
  country: Se(),
  countryCode: Se(),
  fullAddress: Se(),
  latitude: $u(),
  longitude: $u(),
  mapboxId: Se(),
  place: Se(),
  postcode: Se().optional().nullable(),
  region: Se(),
  streetName: Se().optional().nullable()
}, PT = Qn(Dl), RT = (o) => Qn(Dl, { error: o }), Py = "AdminUserPasswordResetToken", OT = Qn({
  type: oy(Py),
  adminUserId: Se(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: Se()
}), Ry = /^\+[1-9]\d{1,14}$/, zT = (o) => /^[+]?[\s0-9]{6,}$/.test(o), Ll = (o) => typeof o != "string" || (o.match(/\s/g)?.length ?? 0) > 1 ? !1 : Ry.test(o.replace(/\s/g, "")), Pl = "Phone must be in E.164 format (e.g. +393331234567)", GT = () => Se().refine(Ll, { message: Pl }), UT = () => Se().refine((o) => !o || Ll(o), { message: Pl }).optional(), Rl = Se().min(5).brand("Tin");
function ZT(o) {
  return Rl.safeParse(o).success;
}
function Oy(o) {
  const n = Rl.safeParse(o);
  if (n.success)
    return n.data;
  throw new Error(`Could not parse '${o}' as Tin: ${n.error.issues.map(({ message: r }) => r).join(", ")}`);
}
function $T(o) {
  return Oy(o.replace(/[^a-zA-Z0-9]/g, ""));
}
const KT = (o) => Math.ceil(o * 1.35962), qT = (o, ...n) => o ? n.map((r) => typeof r == "function" ? r() : r) : [];
function zy(o) {
  return o.length > 0 && !!o[0] && typeof o[0] == "object";
}
const HT = (o) => {
  if (!o)
    return {};
  const r = Object.keys(o).map((a) => Array.isArray(o[a]) && o[a].length > 0 ? zy(o[a]) ? o[a].map(
    (u, f) => Object.keys(u).map((d) => [`${a}[${f}][${d}]`, u[d]])
  ).flat() : [[`${a}[]`, o[a]]] : o[a] !== null && typeof o[a] == "object" && !Array.isArray(o[a]) ? Object.keys(o[a]).map((u) => [`${a}[${u}]`, o[a][u]]) : [[a, o[a]]]).flat();
  return Object.fromEntries(r);
};
var Kn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, qt = { exports: {} };
var Gy = qt.exports, Ju;
function Uy() {
  return Ju || (Ju = 1, (function(o, n) {
    (function() {
      var r, a = "4.18.1", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", d = "Expected a function", _ = "Invalid `variable` option passed into `_.template`", T = "Invalid `imports` option passed into `_.template`", v = "__lodash_hash_undefined__", w = 500, z = "__lodash_placeholder__", B = 1, R = 2, ae = 4, ee = 1, uo = 2, Ee = 1, To = 2, Be = 4, oe = 8, me = 16, oo = 32, Po = 64, lo = 128, yt = 256, tr = 512, $l = 30, Kl = "...", ql = 800, Hl = 16, Hi = 1, Wl = 2, Vl = 3, Ro = 1 / 0, Mo = 9007199254740991, Jl = 17976931348623157e292, Jt = NaN, to = 4294967295, jl = to - 1, Yl = to >>> 1, Xl = [
        ["ary", lo],
        ["bind", Ee],
        ["bindKey", To],
        ["curry", oe],
        ["curryRight", me],
        ["flip", tr],
        ["partial", oo],
        ["partialRight", Po],
        ["rearg", yt]
      ], Yo = "[object Arguments]", jt = "[object Array]", Ql = "[object AsyncFunction]", Tt = "[object Boolean]", Mt = "[object Date]", ec = "[object DOMException]", Yt = "[object Error]", Xt = "[object Function]", Wi = "[object GeneratorFunction]", Ve = "[object Map]", It = "[object Number]", oc = "[object Null]", co = "[object Object]", Vi = "[object Promise]", tc = "[object Proxy]", xt = "[object RegExp]", Je = "[object Set]", St = "[object String]", Qt = "[object Symbol]", nc = "[object Undefined]", vt = "[object WeakMap]", rc = "[object WeakSet]", Nt = "[object ArrayBuffer]", Xo = "[object DataView]", nr = "[object Float32Array]", rr = "[object Float64Array]", ir = "[object Int8Array]", ar = "[object Int16Array]", sr = "[object Int32Array]", ur = "[object Uint8Array]", lr = "[object Uint8ClampedArray]", cr = "[object Uint16Array]", dr = "[object Uint32Array]", ic = /\b__p \+= '';/g, ac = /\b(__p \+=) '' \+/g, sc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ji = /&(?:amp|lt|gt|quot|#39);/g, ji = /[&<>"']/g, uc = RegExp(Ji.source), lc = RegExp(ji.source), cc = /<%-([\s\S]+?)%>/g, dc = /<%([\s\S]+?)%>/g, Yi = /<%=([\s\S]+?)%>/g, pc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fc = /^\w*$/, hc = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, pr = /[\\^$.*+?()[\]{}|]/g, mc = RegExp(pr.source), fr = /^\s+/, _c = /\s/, bc = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Ac = /\{\n\/\* \[wrapped with (.+)\] \*/, gc = /,? & /, yc = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Xi = /[()=,{}\[\]\/\s]/, Tc = /\\(\\)?/g, Mc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Qi = /\w*$/, Ic = /^[-+]0x[0-9a-f]+$/i, xc = /^0b[01]+$/i, Sc = /^\[object .+?Constructor\]$/, vc = /^0o[0-7]+$/i, Nc = /^(?:0|[1-9]\d*)$/, Fc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, en = /($^)/, wc = /['\n\r\u2028\u2029\\]/g, on = "\\ud800-\\udfff", Cc = "\\u0300-\\u036f", Ec = "\\ufe20-\\ufe2f", Bc = "\\u20d0-\\u20ff", ea = Cc + Ec + Bc, oa = "\\u2700-\\u27bf", ta = "a-z\\xdf-\\xf6\\xf8-\\xff", kc = "\\xac\\xb1\\xd7\\xf7", Dc = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Lc = "\\u2000-\\u206f", Pc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", na = "A-Z\\xc0-\\xd6\\xd8-\\xde", ra = "\\ufe0e\\ufe0f", ia = kc + Dc + Lc + Pc, hr = "['’]", Rc = "[" + on + "]", aa = "[" + ia + "]", tn = "[" + ea + "]", sa = "\\d+", Oc = "[" + oa + "]", ua = "[" + ta + "]", la = "[^" + on + ia + sa + oa + ta + na + "]", mr = "\\ud83c[\\udffb-\\udfff]", zc = "(?:" + tn + "|" + mr + ")", ca = "[^" + on + "]", _r = "(?:\\ud83c[\\udde6-\\uddff]){2}", br = "[\\ud800-\\udbff][\\udc00-\\udfff]", Qo = "[" + na + "]", da = "\\u200d", pa = "(?:" + ua + "|" + la + ")", Gc = "(?:" + Qo + "|" + la + ")", fa = "(?:" + hr + "(?:d|ll|m|re|s|t|ve))?", ha = "(?:" + hr + "(?:D|LL|M|RE|S|T|VE))?", ma = zc + "?", _a = "[" + ra + "]?", Uc = "(?:" + da + "(?:" + [ca, _r, br].join("|") + ")" + _a + ma + ")*", Zc = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $c = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ba = _a + ma + Uc, Kc = "(?:" + [Oc, _r, br].join("|") + ")" + ba, qc = "(?:" + [ca + tn + "?", tn, _r, br, Rc].join("|") + ")", Hc = RegExp(hr, "g"), Wc = RegExp(tn, "g"), Ar = RegExp(mr + "(?=" + mr + ")|" + qc + ba, "g"), Vc = RegExp([
        Qo + "?" + ua + "+" + fa + "(?=" + [aa, Qo, "$"].join("|") + ")",
        Gc + "+" + ha + "(?=" + [aa, Qo + pa, "$"].join("|") + ")",
        Qo + "?" + pa + "+" + fa,
        Qo + "+" + ha,
        $c,
        Zc,
        sa,
        Kc
      ].join("|"), "g"), Jc = RegExp("[" + da + on + ea + ra + "]"), jc = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Yc = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Xc = -1, Q = {};
      Q[nr] = Q[rr] = Q[ir] = Q[ar] = Q[sr] = Q[ur] = Q[lr] = Q[cr] = Q[dr] = !0, Q[Yo] = Q[jt] = Q[Nt] = Q[Tt] = Q[Xo] = Q[Mt] = Q[Yt] = Q[Xt] = Q[Ve] = Q[It] = Q[co] = Q[xt] = Q[Je] = Q[St] = Q[vt] = !1;
      var X = {};
      X[Yo] = X[jt] = X[Nt] = X[Xo] = X[Tt] = X[Mt] = X[nr] = X[rr] = X[ir] = X[ar] = X[sr] = X[Ve] = X[It] = X[co] = X[xt] = X[Je] = X[St] = X[Qt] = X[ur] = X[lr] = X[cr] = X[dr] = !0, X[Yt] = X[Xt] = X[vt] = !1;
      var Qc = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, ed = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, od = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, td = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, nd = parseFloat, rd = parseInt, Aa = typeof Kn == "object" && Kn && Kn.Object === Object && Kn, id = typeof self == "object" && self && self.Object === Object && self, _e = Aa || id || Function("return this")(), gr = n && !n.nodeType && n, Oo = gr && !0 && o && !o.nodeType && o, ga = Oo && Oo.exports === gr, yr = ga && Aa.process, Ge = (function() {
        try {
          var b = Oo && Oo.require && Oo.require("util").types;
          return b || yr && yr.binding && yr.binding("util");
        } catch {
        }
      })(), ya = Ge && Ge.isArrayBuffer, Ta = Ge && Ge.isDate, Ma = Ge && Ge.isMap, Ia = Ge && Ge.isRegExp, xa = Ge && Ge.isSet, Sa = Ge && Ge.isTypedArray;
      function ke(b, y, g) {
        switch (g.length) {
          case 0:
            return b.call(y);
          case 1:
            return b.call(y, g[0]);
          case 2:
            return b.call(y, g[0], g[1]);
          case 3:
            return b.call(y, g[0], g[1], g[2]);
        }
        return b.apply(y, g);
      }
      function ad(b, y, g, F) {
        for (var O = -1, W = b == null ? 0 : b.length; ++O < W; ) {
          var pe = b[O];
          y(F, pe, g(pe), b);
        }
        return F;
      }
      function De(b, y) {
        for (var g = -1, F = b == null ? 0 : b.length; ++g < F && y(b[g], g, b) !== !1; )
          ;
        return b;
      }
      function sd(b, y) {
        for (var g = b == null ? 0 : b.length; g-- && y(b[g], g, b) !== !1; )
          ;
        return b;
      }
      function va(b, y) {
        for (var g = -1, F = b == null ? 0 : b.length; ++g < F; )
          if (!y(b[g], g, b))
            return !1;
        return !0;
      }
      function Io(b, y) {
        for (var g = -1, F = b == null ? 0 : b.length, O = 0, W = []; ++g < F; ) {
          var pe = b[g];
          y(pe, g, b) && (W[O++] = pe);
        }
        return W;
      }
      function nn(b, y) {
        var g = b == null ? 0 : b.length;
        return !!g && et(b, y, 0) > -1;
      }
      function Tr(b, y, g) {
        for (var F = -1, O = b == null ? 0 : b.length; ++F < O; )
          if (g(y, b[F]))
            return !0;
        return !1;
      }
      function te(b, y) {
        for (var g = -1, F = b == null ? 0 : b.length, O = Array(F); ++g < F; )
          O[g] = y(b[g], g, b);
        return O;
      }
      function xo(b, y) {
        for (var g = -1, F = y.length, O = b.length; ++g < F; )
          b[O + g] = y[g];
        return b;
      }
      function Mr(b, y, g, F) {
        var O = -1, W = b == null ? 0 : b.length;
        for (F && W && (g = b[++O]); ++O < W; )
          g = y(g, b[O], O, b);
        return g;
      }
      function ud(b, y, g, F) {
        var O = b == null ? 0 : b.length;
        for (F && O && (g = b[--O]); O--; )
          g = y(g, b[O], O, b);
        return g;
      }
      function Ir(b, y) {
        for (var g = -1, F = b == null ? 0 : b.length; ++g < F; )
          if (y(b[g], g, b))
            return !0;
        return !1;
      }
      var ld = xr("length");
      function cd(b) {
        return b.split("");
      }
      function dd(b) {
        return b.match(yc) || [];
      }
      function Na(b, y, g) {
        var F;
        return g(b, function(O, W, pe) {
          if (y(O, W, pe))
            return F = W, !1;
        }), F;
      }
      function rn(b, y, g, F) {
        for (var O = b.length, W = g + (F ? 1 : -1); F ? W-- : ++W < O; )
          if (y(b[W], W, b))
            return W;
        return -1;
      }
      function et(b, y, g) {
        return y === y ? Id(b, y, g) : rn(b, Fa, g);
      }
      function pd(b, y, g, F) {
        for (var O = g - 1, W = b.length; ++O < W; )
          if (F(b[O], y))
            return O;
        return -1;
      }
      function Fa(b) {
        return b !== b;
      }
      function wa(b, y) {
        var g = b == null ? 0 : b.length;
        return g ? vr(b, y) / g : Jt;
      }
      function xr(b) {
        return function(y) {
          return y == null ? r : y[b];
        };
      }
      function Sr(b) {
        return function(y) {
          return b == null ? r : b[y];
        };
      }
      function Ca(b, y, g, F, O) {
        return O(b, function(W, pe, Y) {
          g = F ? (F = !1, W) : y(g, W, pe, Y);
        }), g;
      }
      function fd(b, y) {
        var g = b.length;
        for (b.sort(y); g--; )
          b[g] = b[g].value;
        return b;
      }
      function vr(b, y) {
        for (var g, F = -1, O = b.length; ++F < O; ) {
          var W = y(b[F]);
          W !== r && (g = g === r ? W : g + W);
        }
        return g;
      }
      function Nr(b, y) {
        for (var g = -1, F = Array(b); ++g < b; )
          F[g] = y(g);
        return F;
      }
      function hd(b, y) {
        return te(y, function(g) {
          return [g, b[g]];
        });
      }
      function Ea(b) {
        return b && b.slice(0, La(b) + 1).replace(fr, "");
      }
      function Le(b) {
        return function(y) {
          return b(y);
        };
      }
      function Fr(b, y) {
        return te(y, function(g) {
          return b[g];
        });
      }
      function Ft(b, y) {
        return b.has(y);
      }
      function Ba(b, y) {
        for (var g = -1, F = b.length; ++g < F && et(y, b[g], 0) > -1; )
          ;
        return g;
      }
      function ka(b, y) {
        for (var g = b.length; g-- && et(y, b[g], 0) > -1; )
          ;
        return g;
      }
      function md(b, y) {
        for (var g = b.length, F = 0; g--; )
          b[g] === y && ++F;
        return F;
      }
      var _d = Sr(Qc), bd = Sr(ed);
      function Ad(b) {
        return "\\" + td[b];
      }
      function gd(b, y) {
        return b == null ? r : b[y];
      }
      function ot(b) {
        return Jc.test(b);
      }
      function yd(b) {
        return jc.test(b);
      }
      function Td(b) {
        for (var y, g = []; !(y = b.next()).done; )
          g.push(y.value);
        return g;
      }
      function wr(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(F, O) {
          g[++y] = [O, F];
        }), g;
      }
      function Da(b, y) {
        return function(g) {
          return b(y(g));
        };
      }
      function So(b, y) {
        for (var g = -1, F = b.length, O = 0, W = []; ++g < F; ) {
          var pe = b[g];
          (pe === y || pe === z) && (b[g] = z, W[O++] = g);
        }
        return W;
      }
      function an(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(F) {
          g[++y] = F;
        }), g;
      }
      function Md(b) {
        var y = -1, g = Array(b.size);
        return b.forEach(function(F) {
          g[++y] = [F, F];
        }), g;
      }
      function Id(b, y, g) {
        for (var F = g - 1, O = b.length; ++F < O; )
          if (b[F] === y)
            return F;
        return -1;
      }
      function xd(b, y, g) {
        for (var F = g + 1; F--; )
          if (b[F] === y)
            return F;
        return F;
      }
      function tt(b) {
        return ot(b) ? vd(b) : ld(b);
      }
      function je(b) {
        return ot(b) ? Nd(b) : cd(b);
      }
      function La(b) {
        for (var y = b.length; y-- && _c.test(b.charAt(y)); )
          ;
        return y;
      }
      var Sd = Sr(od);
      function vd(b) {
        for (var y = Ar.lastIndex = 0; Ar.test(b); )
          ++y;
        return y;
      }
      function Nd(b) {
        return b.match(Ar) || [];
      }
      function Fd(b) {
        return b.match(Vc) || [];
      }
      var wd = (function b(y) {
        y = y == null ? _e : nt.defaults(_e.Object(), y, nt.pick(_e, Yc));
        var g = y.Array, F = y.Date, O = y.Error, W = y.Function, pe = y.Math, Y = y.Object, Cr = y.RegExp, Cd = y.String, Ue = y.TypeError, sn = g.prototype, Ed = W.prototype, rt = Y.prototype, un = y["__core-js_shared__"], ln = Ed.toString, V = rt.hasOwnProperty, Bd = 0, Pa = (function() {
          var e = /[^.]+$/.exec(un && un.keys && un.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), cn = rt.toString, kd = ln.call(Y), Dd = _e._, Ld = Cr(
          "^" + ln.call(V).replace(pr, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), dn = ga ? y.Buffer : r, vo = y.Symbol, pn = y.Uint8Array, Ra = dn ? dn.allocUnsafe : r, fn = Da(Y.getPrototypeOf, Y), Oa = Y.create, za = rt.propertyIsEnumerable, hn = sn.splice, Ga = vo ? vo.isConcatSpreadable : r, wt = vo ? vo.iterator : r, zo = vo ? vo.toStringTag : r, mn = (function() {
          try {
            var e = Ko(Y, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), Pd = y.clearTimeout !== _e.clearTimeout && y.clearTimeout, Rd = F && F.now !== _e.Date.now && F.now, Od = y.setTimeout !== _e.setTimeout && y.setTimeout, _n = pe.ceil, bn = pe.floor, Er = Y.getOwnPropertySymbols, zd = dn ? dn.isBuffer : r, Ua = y.isFinite, Gd = sn.join, Ud = Da(Y.keys, Y), fe = pe.max, ge = pe.min, Zd = F.now, $d = y.parseInt, Za = pe.random, Kd = sn.reverse, Br = Ko(y, "DataView"), Ct = Ko(y, "Map"), kr = Ko(y, "Promise"), it = Ko(y, "Set"), Et = Ko(y, "WeakMap"), Bt = Ko(Y, "create"), An = Et && new Et(), at = {}, qd = qo(Br), Hd = qo(Ct), Wd = qo(kr), Vd = qo(it), Jd = qo(Et), gn = vo ? vo.prototype : r, kt = gn ? gn.valueOf : r, $a = gn ? gn.toString : r;
        function c(e) {
          if (se(e) && !G(e) && !(e instanceof q)) {
            if (e instanceof Ze)
              return e;
            if (V.call(e, "__wrapped__"))
              return Ks(e);
          }
          return new Ze(e);
        }
        var st = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(t) {
            if (!re(t))
              return {};
            if (Oa)
              return Oa(t);
            e.prototype = t;
            var i = new e();
            return e.prototype = r, i;
          };
        })();
        function yn() {
        }
        function Ze(e, t) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = r;
        }
        c.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: cc,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: dc,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Yi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: c
          }
        }, c.prototype = yn.prototype, c.prototype.constructor = c, Ze.prototype = st(yn.prototype), Ze.prototype.constructor = Ze;
        function q(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = to, this.__views__ = [];
        }
        function jd() {
          var e = new q(this.__wrapped__);
          return e.__actions__ = ve(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = ve(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = ve(this.__views__), e;
        }
        function Yd() {
          if (this.__filtered__) {
            var e = new q(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Xd() {
          var e = this.__wrapped__.value(), t = this.__dir__, i = G(e), s = t < 0, l = i ? e.length : 0, p = df(0, l, this.__views__), h = p.start, m = p.end, A = m - h, M = s ? m : h - 1, x = this.__iteratees__, S = x.length, N = 0, C = ge(A, this.__takeCount__);
          if (!i || !s && l == A && C == A)
            return fs(e, this.__actions__);
          var P = [];
          e:
            for (; A-- && N < C; ) {
              M += t;
              for (var Z = -1, D = e[M]; ++Z < S; ) {
                var K = x[Z], H = K.iteratee, Oe = K.type, Ie = H(D);
                if (Oe == Wl)
                  D = Ie;
                else if (!Ie) {
                  if (Oe == Hi)
                    continue e;
                  break e;
                }
              }
              P[N++] = D;
            }
          return P;
        }
        q.prototype = st(yn.prototype), q.prototype.constructor = q;
        function Go(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function Qd() {
          this.__data__ = Bt ? Bt(null) : {}, this.size = 0;
        }
        function ep(e) {
          var t = this.has(e) && delete this.__data__[e];
          return this.size -= t ? 1 : 0, t;
        }
        function op(e) {
          var t = this.__data__;
          if (Bt) {
            var i = t[e];
            return i === v ? r : i;
          }
          return V.call(t, e) ? t[e] : r;
        }
        function tp(e) {
          var t = this.__data__;
          return Bt ? t[e] !== r : V.call(t, e);
        }
        function np(e, t) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = Bt && t === r ? v : t, this;
        }
        Go.prototype.clear = Qd, Go.prototype.delete = ep, Go.prototype.get = op, Go.prototype.has = tp, Go.prototype.set = np;
        function po(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function rp() {
          this.__data__ = [], this.size = 0;
        }
        function ip(e) {
          var t = this.__data__, i = Tn(t, e);
          if (i < 0)
            return !1;
          var s = t.length - 1;
          return i == s ? t.pop() : hn.call(t, i, 1), --this.size, !0;
        }
        function ap(e) {
          var t = this.__data__, i = Tn(t, e);
          return i < 0 ? r : t[i][1];
        }
        function sp(e) {
          return Tn(this.__data__, e) > -1;
        }
        function up(e, t) {
          var i = this.__data__, s = Tn(i, e);
          return s < 0 ? (++this.size, i.push([e, t])) : i[s][1] = t, this;
        }
        po.prototype.clear = rp, po.prototype.delete = ip, po.prototype.get = ap, po.prototype.has = sp, po.prototype.set = up;
        function fo(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++t < i; ) {
            var s = e[t];
            this.set(s[0], s[1]);
          }
        }
        function lp() {
          this.size = 0, this.__data__ = {
            hash: new Go(),
            map: new (Ct || po)(),
            string: new Go()
          };
        }
        function cp(e) {
          var t = kn(this, e).delete(e);
          return this.size -= t ? 1 : 0, t;
        }
        function dp(e) {
          return kn(this, e).get(e);
        }
        function pp(e) {
          return kn(this, e).has(e);
        }
        function fp(e, t) {
          var i = kn(this, e), s = i.size;
          return i.set(e, t), this.size += i.size == s ? 0 : 1, this;
        }
        fo.prototype.clear = lp, fo.prototype.delete = cp, fo.prototype.get = dp, fo.prototype.has = pp, fo.prototype.set = fp;
        function Uo(e) {
          var t = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new fo(); ++t < i; )
            this.add(e[t]);
        }
        function hp(e) {
          return this.__data__.set(e, v), this;
        }
        function mp(e) {
          return this.__data__.has(e);
        }
        Uo.prototype.add = Uo.prototype.push = hp, Uo.prototype.has = mp;
        function Ye(e) {
          var t = this.__data__ = new po(e);
          this.size = t.size;
        }
        function _p() {
          this.__data__ = new po(), this.size = 0;
        }
        function bp(e) {
          var t = this.__data__, i = t.delete(e);
          return this.size = t.size, i;
        }
        function Ap(e) {
          return this.__data__.get(e);
        }
        function gp(e) {
          return this.__data__.has(e);
        }
        function yp(e, t) {
          var i = this.__data__;
          if (i instanceof po) {
            var s = i.__data__;
            if (!Ct || s.length < u - 1)
              return s.push([e, t]), this.size = ++i.size, this;
            i = this.__data__ = new fo(s);
          }
          return i.set(e, t), this.size = i.size, this;
        }
        Ye.prototype.clear = _p, Ye.prototype.delete = bp, Ye.prototype.get = Ap, Ye.prototype.has = gp, Ye.prototype.set = yp;
        function Ka(e, t) {
          var i = G(e), s = !i && Ho(e), l = !i && !s && Eo(e), p = !i && !s && !l && dt(e), h = i || s || l || p, m = h ? Nr(e.length, Cd) : [], A = m.length;
          for (var M in e)
            (t || V.call(e, M)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
            (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            p && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
            _o(M, A))) && m.push(M);
          return m;
        }
        function qa(e) {
          var t = e.length;
          return t ? e[Kr(0, t - 1)] : r;
        }
        function Tp(e, t) {
          return Dn(ve(e), Zo(t, 0, e.length));
        }
        function Mp(e) {
          return Dn(ve(e));
        }
        function Dr(e, t, i) {
          (i !== r && !Qe(e[t], i) || i === r && !(t in e)) && no(e, t, i);
        }
        function Dt(e, t, i) {
          var s = e[t];
          (!(V.call(e, t) && Qe(s, i)) || i === r && !(t in e)) && no(e, t, i);
        }
        function Tn(e, t) {
          for (var i = e.length; i--; )
            if (Qe(e[i][0], t))
              return i;
          return -1;
        }
        function Ip(e, t, i, s) {
          return No(e, function(l, p, h) {
            t(s, l, i(l), h);
          }), s;
        }
        function Ha(e, t) {
          return e && io(t, he(t), e);
        }
        function xp(e, t) {
          return e && io(t, Fe(t), e);
        }
        function no(e, t, i) {
          t == "__proto__" && mn ? mn(e, t, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[t] = i;
        }
        function Lr(e, t) {
          for (var i = -1, s = t.length, l = g(s), p = e == null; ++i < s; )
            l[i] = p ? r : _i(e, t[i]);
          return l;
        }
        function Zo(e, t, i) {
          return e === e && (i !== r && (e = e <= i ? e : i), t !== r && (e = e >= t ? e : t)), e;
        }
        function $e(e, t, i, s, l, p) {
          var h, m = t & B, A = t & R, M = t & ae;
          if (i && (h = l ? i(e, s, l, p) : i(e)), h !== r)
            return h;
          if (!re(e))
            return e;
          var x = G(e);
          if (x) {
            if (h = ff(e), !m)
              return ve(e, h);
          } else {
            var S = ye(e), N = S == Xt || S == Wi;
            if (Eo(e))
              return _s(e, m);
            if (S == co || S == Yo || N && !l) {
              if (h = A || N ? {} : Ls(e), !m)
                return A ? of(e, xp(h, e)) : ef(e, Ha(h, e));
            } else {
              if (!X[S])
                return l ? e : {};
              h = hf(e, S, m);
            }
          }
          p || (p = new Ye());
          var C = p.get(e);
          if (C)
            return C;
          p.set(e, h), cu(e) ? e.forEach(function(D) {
            h.add($e(D, t, i, D, e, p));
          }) : uu(e) && e.forEach(function(D, K) {
            h.set(K, $e(D, t, i, K, e, p));
          });
          var P = M ? A ? oi : ei : A ? Fe : he, Z = x ? r : P(e);
          return De(Z || e, function(D, K) {
            Z && (K = D, D = e[K]), Dt(h, K, $e(D, t, i, K, e, p));
          }), h;
        }
        function Sp(e) {
          var t = he(e);
          return function(i) {
            return Wa(i, e, t);
          };
        }
        function Wa(e, t, i) {
          var s = i.length;
          if (e == null)
            return !s;
          for (e = Y(e); s--; ) {
            var l = i[s], p = t[l], h = e[l];
            if (h === r && !(l in e) || !p(h))
              return !1;
          }
          return !0;
        }
        function Va(e, t, i) {
          if (typeof e != "function")
            throw new Ue(d);
          return Ut(function() {
            e.apply(r, i);
          }, t);
        }
        function Lt(e, t, i, s) {
          var l = -1, p = nn, h = !0, m = e.length, A = [], M = t.length;
          if (!m)
            return A;
          i && (t = te(t, Le(i))), s ? (p = Tr, h = !1) : t.length >= u && (p = Ft, h = !1, t = new Uo(t));
          e:
            for (; ++l < m; ) {
              var x = e[l], S = i == null ? x : i(x);
              if (x = s || x !== 0 ? x : 0, h && S === S) {
                for (var N = M; N--; )
                  if (t[N] === S)
                    continue e;
                A.push(x);
              } else p(t, S, s) || A.push(x);
            }
          return A;
        }
        var No = Ts(ro), Ja = Ts(Rr, !0);
        function vp(e, t) {
          var i = !0;
          return No(e, function(s, l, p) {
            return i = !!t(s, l, p), i;
          }), i;
        }
        function Mn(e, t, i) {
          for (var s = -1, l = e.length; ++s < l; ) {
            var p = e[s], h = t(p);
            if (h != null && (m === r ? h === h && !Re(h) : i(h, m)))
              var m = h, A = p;
          }
          return A;
        }
        function Np(e, t, i, s) {
          var l = e.length;
          for (i = U(i), i < 0 && (i = -i > l ? 0 : l + i), s = s === r || s > l ? l : U(s), s < 0 && (s += l), s = i > s ? 0 : pu(s); i < s; )
            e[i++] = t;
          return e;
        }
        function ja(e, t) {
          var i = [];
          return No(e, function(s, l, p) {
            t(s, l, p) && i.push(s);
          }), i;
        }
        function be(e, t, i, s, l) {
          var p = -1, h = e.length;
          for (i || (i = _f), l || (l = []); ++p < h; ) {
            var m = e[p];
            t > 0 && i(m) ? t > 1 ? be(m, t - 1, i, s, l) : xo(l, m) : s || (l[l.length] = m);
          }
          return l;
        }
        var Pr = Ms(), Ya = Ms(!0);
        function ro(e, t) {
          return e && Pr(e, t, he);
        }
        function Rr(e, t) {
          return e && Ya(e, t, he);
        }
        function In(e, t) {
          return Io(t, function(i) {
            return bo(e[i]);
          });
        }
        function $o(e, t) {
          t = wo(t, e);
          for (var i = 0, s = t.length; e != null && i < s; )
            e = e[Xe(t[i++])];
          return i && i == s ? e : r;
        }
        function Xa(e, t, i) {
          var s = t(e);
          return G(e) ? s : xo(s, i(e));
        }
        function Te(e) {
          return e == null ? e === r ? nc : oc : zo && zo in Y(e) ? cf(e) : If(e);
        }
        function Or(e, t) {
          return e > t;
        }
        function Fp(e, t) {
          return e != null && V.call(e, t);
        }
        function wp(e, t) {
          return e != null && t in Y(e);
        }
        function Cp(e, t, i) {
          return e >= ge(t, i) && e < fe(t, i);
        }
        function zr(e, t, i) {
          for (var s = i ? Tr : nn, l = e[0].length, p = e.length, h = p, m = g(p), A = 1 / 0, M = []; h--; ) {
            var x = e[h];
            h && t && (x = te(x, Le(t))), A = ge(x.length, A), m[h] = !i && (t || l >= 120 && x.length >= 120) ? new Uo(h && x) : r;
          }
          x = e[0];
          var S = -1, N = m[0];
          e:
            for (; ++S < l && M.length < A; ) {
              var C = x[S], P = t ? t(C) : C;
              if (C = i || C !== 0 ? C : 0, !(N ? Ft(N, P) : s(M, P, i))) {
                for (h = p; --h; ) {
                  var Z = m[h];
                  if (!(Z ? Ft(Z, P) : s(e[h], P, i)))
                    continue e;
                }
                N && N.push(P), M.push(C);
              }
            }
          return M;
        }
        function Ep(e, t, i, s) {
          return ro(e, function(l, p, h) {
            t(s, i(l), p, h);
          }), s;
        }
        function Pt(e, t, i) {
          t = wo(t, e), e = zs(e, t);
          var s = e == null ? e : e[Xe(qe(t))];
          return s == null ? r : ke(s, e, i);
        }
        function Qa(e) {
          return se(e) && Te(e) == Yo;
        }
        function Bp(e) {
          return se(e) && Te(e) == Nt;
        }
        function kp(e) {
          return se(e) && Te(e) == Mt;
        }
        function Rt(e, t, i, s, l) {
          return e === t ? !0 : e == null || t == null || !se(e) && !se(t) ? e !== e && t !== t : Dp(e, t, i, s, Rt, l);
        }
        function Dp(e, t, i, s, l, p) {
          var h = G(e), m = G(t), A = h ? jt : ye(e), M = m ? jt : ye(t);
          A = A == Yo ? co : A, M = M == Yo ? co : M;
          var x = A == co, S = M == co, N = A == M;
          if (N && Eo(e)) {
            if (!Eo(t))
              return !1;
            h = !0, x = !1;
          }
          if (N && !x)
            return p || (p = new Ye()), h || dt(e) ? Bs(e, t, i, s, l, p) : uf(e, t, A, i, s, l, p);
          if (!(i & ee)) {
            var C = x && V.call(e, "__wrapped__"), P = S && V.call(t, "__wrapped__");
            if (C || P) {
              var Z = C ? e.value() : e, D = P ? t.value() : t;
              return p || (p = new Ye()), l(Z, D, i, s, p);
            }
          }
          return N ? (p || (p = new Ye()), lf(e, t, i, s, l, p)) : !1;
        }
        function Lp(e) {
          return se(e) && ye(e) == Ve;
        }
        function Gr(e, t, i, s) {
          var l = i.length, p = l, h = !s;
          if (e == null)
            return !p;
          for (e = Y(e); l--; ) {
            var m = i[l];
            if (h && m[2] ? m[1] !== e[m[0]] : !(m[0] in e))
              return !1;
          }
          for (; ++l < p; ) {
            m = i[l];
            var A = m[0], M = e[A], x = m[1];
            if (h && m[2]) {
              if (M === r && !(A in e))
                return !1;
            } else {
              var S = new Ye();
              if (s)
                var N = s(M, x, A, e, t, S);
              if (!(N === r ? Rt(x, M, ee | uo, s, S) : N))
                return !1;
            }
          }
          return !0;
        }
        function es(e) {
          if (!re(e) || Af(e))
            return !1;
          var t = bo(e) ? Ld : Sc;
          return t.test(qo(e));
        }
        function Pp(e) {
          return se(e) && Te(e) == xt;
        }
        function Rp(e) {
          return se(e) && ye(e) == Je;
        }
        function Op(e) {
          return se(e) && Gn(e.length) && !!Q[Te(e)];
        }
        function os(e) {
          return typeof e == "function" ? e : e == null ? we : typeof e == "object" ? G(e) ? rs(e[0], e[1]) : ns(e) : xu(e);
        }
        function Ur(e) {
          if (!Gt(e))
            return Ud(e);
          var t = [];
          for (var i in Y(e))
            V.call(e, i) && i != "constructor" && t.push(i);
          return t;
        }
        function zp(e) {
          if (!re(e))
            return Mf(e);
          var t = Gt(e), i = [];
          for (var s in e)
            s == "constructor" && (t || !V.call(e, s)) || i.push(s);
          return i;
        }
        function Zr(e, t) {
          return e < t;
        }
        function ts(e, t) {
          var i = -1, s = Ne(e) ? g(e.length) : [];
          return No(e, function(l, p, h) {
            s[++i] = t(l, p, h);
          }), s;
        }
        function ns(e) {
          var t = ni(e);
          return t.length == 1 && t[0][2] ? Rs(t[0][0], t[0][1]) : function(i) {
            return i === e || Gr(i, e, t);
          };
        }
        function rs(e, t) {
          return ii(e) && Ps(t) ? Rs(Xe(e), t) : function(i) {
            var s = _i(i, e);
            return s === r && s === t ? bi(i, e) : Rt(t, s, ee | uo);
          };
        }
        function xn(e, t, i, s, l) {
          e !== t && Pr(t, function(p, h) {
            if (l || (l = new Ye()), re(p))
              Gp(e, t, h, i, xn, s, l);
            else {
              var m = s ? s(si(e, h), p, h + "", e, t, l) : r;
              m === r && (m = p), Dr(e, h, m);
            }
          }, Fe);
        }
        function Gp(e, t, i, s, l, p, h) {
          var m = si(e, i), A = si(t, i), M = h.get(A);
          if (M) {
            Dr(e, i, M);
            return;
          }
          var x = p ? p(m, A, i + "", e, t, h) : r, S = x === r;
          if (S) {
            var N = G(A), C = !N && Eo(A), P = !N && !C && dt(A);
            x = A, N || C || P ? G(m) ? x = m : ue(m) ? x = ve(m) : C ? (S = !1, x = _s(A, !0)) : P ? (S = !1, x = bs(A, !0)) : x = [] : Zt(A) || Ho(A) ? (x = m, Ho(m) ? x = fu(m) : (!re(m) || bo(m)) && (x = Ls(A))) : S = !1;
          }
          S && (h.set(A, x), l(x, A, s, p, h), h.delete(A)), Dr(e, i, x);
        }
        function is(e, t) {
          var i = e.length;
          if (i)
            return t += t < 0 ? i : 0, _o(t, i) ? e[t] : r;
        }
        function as(e, t, i) {
          t.length ? t = te(t, function(p) {
            return G(p) ? function(h) {
              return $o(h, p.length === 1 ? p[0] : p);
            } : p;
          }) : t = [we];
          var s = -1;
          t = te(t, Le(L()));
          var l = ts(e, function(p, h, m) {
            var A = te(t, function(M) {
              return M(p);
            });
            return { criteria: A, index: ++s, value: p };
          });
          return fd(l, function(p, h) {
            return Qp(p, h, i);
          });
        }
        function Up(e, t) {
          return ss(e, t, function(i, s) {
            return bi(e, s);
          });
        }
        function ss(e, t, i) {
          for (var s = -1, l = t.length, p = {}; ++s < l; ) {
            var h = t[s], m = $o(e, h);
            i(m, h) && Ot(p, wo(h, e), m);
          }
          return p;
        }
        function Zp(e) {
          return function(t) {
            return $o(t, e);
          };
        }
        function $r(e, t, i, s) {
          var l = s ? pd : et, p = -1, h = t.length, m = e;
          for (e === t && (t = ve(t)), i && (m = te(e, Le(i))); ++p < h; )
            for (var A = 0, M = t[p], x = i ? i(M) : M; (A = l(m, x, A, s)) > -1; )
              m !== e && hn.call(m, A, 1), hn.call(e, A, 1);
          return e;
        }
        function us(e, t) {
          for (var i = e ? t.length : 0, s = i - 1; i--; ) {
            var l = t[i];
            if (i == s || l !== p) {
              var p = l;
              _o(l) ? hn.call(e, l, 1) : Wr(e, l);
            }
          }
          return e;
        }
        function Kr(e, t) {
          return e + bn(Za() * (t - e + 1));
        }
        function $p(e, t, i, s) {
          for (var l = -1, p = fe(_n((t - e) / (i || 1)), 0), h = g(p); p--; )
            h[s ? p : ++l] = e, e += i;
          return h;
        }
        function qr(e, t) {
          var i = "";
          if (!e || t < 1 || t > Mo)
            return i;
          do
            t % 2 && (i += e), t = bn(t / 2), t && (e += e);
          while (t);
          return i;
        }
        function $(e, t) {
          return ui(Os(e, t, we), e + "");
        }
        function Kp(e) {
          return qa(pt(e));
        }
        function qp(e, t) {
          var i = pt(e);
          return Dn(i, Zo(t, 0, i.length));
        }
        function Ot(e, t, i, s) {
          if (!re(e))
            return e;
          t = wo(t, e);
          for (var l = -1, p = t.length, h = p - 1, m = e; m != null && ++l < p; ) {
            var A = Xe(t[l]), M = i;
            if (A === "__proto__" || A === "constructor" || A === "prototype")
              return e;
            if (l != h) {
              var x = m[A];
              M = s ? s(x, A, m) : r, M === r && (M = re(x) ? x : _o(t[l + 1]) ? [] : {});
            }
            Dt(m, A, M), m = m[A];
          }
          return e;
        }
        var ls = An ? function(e, t) {
          return An.set(e, t), e;
        } : we, Hp = mn ? function(e, t) {
          return mn(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: gi(t),
            writable: !0
          });
        } : we;
        function Wp(e) {
          return Dn(pt(e));
        }
        function Ke(e, t, i) {
          var s = -1, l = e.length;
          t < 0 && (t = -t > l ? 0 : l + t), i = i > l ? l : i, i < 0 && (i += l), l = t > i ? 0 : i - t >>> 0, t >>>= 0;
          for (var p = g(l); ++s < l; )
            p[s] = e[s + t];
          return p;
        }
        function Vp(e, t) {
          var i;
          return No(e, function(s, l, p) {
            return i = t(s, l, p), !i;
          }), !!i;
        }
        function Sn(e, t, i) {
          var s = 0, l = e == null ? s : e.length;
          if (typeof t == "number" && t === t && l <= Yl) {
            for (; s < l; ) {
              var p = s + l >>> 1, h = e[p];
              h !== null && !Re(h) && (i ? h <= t : h < t) ? s = p + 1 : l = p;
            }
            return l;
          }
          return Hr(e, t, we, i);
        }
        function Hr(e, t, i, s) {
          var l = 0, p = e == null ? 0 : e.length;
          if (p === 0)
            return 0;
          t = i(t);
          for (var h = t !== t, m = t === null, A = Re(t), M = t === r; l < p; ) {
            var x = bn((l + p) / 2), S = i(e[x]), N = S !== r, C = S === null, P = S === S, Z = Re(S);
            if (h)
              var D = s || P;
            else M ? D = P && (s || N) : m ? D = P && N && (s || !C) : A ? D = P && N && !C && (s || !Z) : C || Z ? D = !1 : D = s ? S <= t : S < t;
            D ? l = x + 1 : p = x;
          }
          return ge(p, jl);
        }
        function cs(e, t) {
          for (var i = -1, s = e.length, l = 0, p = []; ++i < s; ) {
            var h = e[i], m = t ? t(h) : h;
            if (!i || !Qe(m, A)) {
              var A = m;
              p[l++] = h === 0 ? 0 : h;
            }
          }
          return p;
        }
        function ds(e) {
          return typeof e == "number" ? e : Re(e) ? Jt : +e;
        }
        function Pe(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return te(e, Pe) + "";
          if (Re(e))
            return $a ? $a.call(e) : "";
          var t = e + "";
          return t == "0" && 1 / e == -Ro ? "-0" : t;
        }
        function Fo(e, t, i) {
          var s = -1, l = nn, p = e.length, h = !0, m = [], A = m;
          if (i)
            h = !1, l = Tr;
          else if (p >= u) {
            var M = t ? null : af(e);
            if (M)
              return an(M);
            h = !1, l = Ft, A = new Uo();
          } else
            A = t ? [] : m;
          e:
            for (; ++s < p; ) {
              var x = e[s], S = t ? t(x) : x;
              if (x = i || x !== 0 ? x : 0, h && S === S) {
                for (var N = A.length; N--; )
                  if (A[N] === S)
                    continue e;
                t && A.push(S), m.push(x);
              } else l(A, S, i) || (A !== m && A.push(S), m.push(x));
            }
          return m;
        }
        function Wr(e, t) {
          t = wo(t, e);
          var i = -1, s = t.length;
          if (!s)
            return !0;
          for (; ++i < s; ) {
            var l = Xe(t[i]);
            if (l === "__proto__" && !V.call(e, "__proto__") || (l === "constructor" || l === "prototype") && i < s - 1)
              return !1;
          }
          var p = zs(e, t);
          return p == null || delete p[Xe(qe(t))];
        }
        function ps(e, t, i, s) {
          return Ot(e, t, i($o(e, t)), s);
        }
        function vn(e, t, i, s) {
          for (var l = e.length, p = s ? l : -1; (s ? p-- : ++p < l) && t(e[p], p, e); )
            ;
          return i ? Ke(e, s ? 0 : p, s ? p + 1 : l) : Ke(e, s ? p + 1 : 0, s ? l : p);
        }
        function fs(e, t) {
          var i = e;
          return i instanceof q && (i = i.value()), Mr(t, function(s, l) {
            return l.func.apply(l.thisArg, xo([s], l.args));
          }, i);
        }
        function Vr(e, t, i) {
          var s = e.length;
          if (s < 2)
            return s ? Fo(e[0]) : [];
          for (var l = -1, p = g(s); ++l < s; )
            for (var h = e[l], m = -1; ++m < s; )
              m != l && (p[l] = Lt(p[l] || h, e[m], t, i));
          return Fo(be(p, 1), t, i);
        }
        function hs(e, t, i) {
          for (var s = -1, l = e.length, p = t.length, h = {}; ++s < l; ) {
            var m = s < p ? t[s] : r;
            i(h, e[s], m);
          }
          return h;
        }
        function Jr(e) {
          return ue(e) ? e : [];
        }
        function jr(e) {
          return typeof e == "function" ? e : we;
        }
        function wo(e, t) {
          return G(e) ? e : ii(e, t) ? [e] : $s(J(e));
        }
        var Jp = $;
        function Co(e, t, i) {
          var s = e.length;
          return i = i === r ? s : i, !t && i >= s ? e : Ke(e, t, i);
        }
        var ms = Pd || function(e) {
          return _e.clearTimeout(e);
        };
        function _s(e, t) {
          if (t)
            return e.slice();
          var i = e.length, s = Ra ? Ra(i) : new e.constructor(i);
          return e.copy(s), s;
        }
        function Yr(e) {
          var t = new e.constructor(e.byteLength);
          return new pn(t).set(new pn(e)), t;
        }
        function jp(e, t) {
          var i = t ? Yr(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function Yp(e) {
          var t = new e.constructor(e.source, Qi.exec(e));
          return t.lastIndex = e.lastIndex, t;
        }
        function Xp(e) {
          return kt ? Y(kt.call(e)) : {};
        }
        function bs(e, t) {
          var i = t ? Yr(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function As(e, t) {
          if (e !== t) {
            var i = e !== r, s = e === null, l = e === e, p = Re(e), h = t !== r, m = t === null, A = t === t, M = Re(t);
            if (!m && !M && !p && e > t || p && h && A && !m && !M || s && h && A || !i && A || !l)
              return 1;
            if (!s && !p && !M && e < t || M && i && l && !s && !p || m && i && l || !h && l || !A)
              return -1;
          }
          return 0;
        }
        function Qp(e, t, i) {
          for (var s = -1, l = e.criteria, p = t.criteria, h = l.length, m = i.length; ++s < h; ) {
            var A = As(l[s], p[s]);
            if (A) {
              if (s >= m)
                return A;
              var M = i[s];
              return A * (M == "desc" ? -1 : 1);
            }
          }
          return e.index - t.index;
        }
        function gs(e, t, i, s) {
          for (var l = -1, p = e.length, h = i.length, m = -1, A = t.length, M = fe(p - h, 0), x = g(A + M), S = !s; ++m < A; )
            x[m] = t[m];
          for (; ++l < h; )
            (S || l < p) && (x[i[l]] = e[l]);
          for (; M--; )
            x[m++] = e[l++];
          return x;
        }
        function ys(e, t, i, s) {
          for (var l = -1, p = e.length, h = -1, m = i.length, A = -1, M = t.length, x = fe(p - m, 0), S = g(x + M), N = !s; ++l < x; )
            S[l] = e[l];
          for (var C = l; ++A < M; )
            S[C + A] = t[A];
          for (; ++h < m; )
            (N || l < p) && (S[C + i[h]] = e[l++]);
          return S;
        }
        function ve(e, t) {
          var i = -1, s = e.length;
          for (t || (t = g(s)); ++i < s; )
            t[i] = e[i];
          return t;
        }
        function io(e, t, i, s) {
          var l = !i;
          i || (i = {});
          for (var p = -1, h = t.length; ++p < h; ) {
            var m = t[p], A = s ? s(i[m], e[m], m, i, e) : r;
            A === r && (A = e[m]), l ? no(i, m, A) : Dt(i, m, A);
          }
          return i;
        }
        function ef(e, t) {
          return io(e, ri(e), t);
        }
        function of(e, t) {
          return io(e, ks(e), t);
        }
        function Nn(e, t) {
          return function(i, s) {
            var l = G(i) ? ad : Ip, p = t ? t() : {};
            return l(i, e, L(s, 2), p);
          };
        }
        function ut(e) {
          return $(function(t, i) {
            var s = -1, l = i.length, p = l > 1 ? i[l - 1] : r, h = l > 2 ? i[2] : r;
            for (p = e.length > 3 && typeof p == "function" ? (l--, p) : r, h && Me(i[0], i[1], h) && (p = l < 3 ? r : p, l = 1), t = Y(t); ++s < l; ) {
              var m = i[s];
              m && e(t, m, s, p);
            }
            return t;
          });
        }
        function Ts(e, t) {
          return function(i, s) {
            if (i == null)
              return i;
            if (!Ne(i))
              return e(i, s);
            for (var l = i.length, p = t ? l : -1, h = Y(i); (t ? p-- : ++p < l) && s(h[p], p, h) !== !1; )
              ;
            return i;
          };
        }
        function Ms(e) {
          return function(t, i, s) {
            for (var l = -1, p = Y(t), h = s(t), m = h.length; m--; ) {
              var A = h[e ? m : ++l];
              if (i(p[A], A, p) === !1)
                break;
            }
            return t;
          };
        }
        function tf(e, t, i) {
          var s = t & Ee, l = zt(e);
          function p() {
            var h = this && this !== _e && this instanceof p ? l : e;
            return h.apply(s ? i : this, arguments);
          }
          return p;
        }
        function Is(e) {
          return function(t) {
            t = J(t);
            var i = ot(t) ? je(t) : r, s = i ? i[0] : t.charAt(0), l = i ? Co(i, 1).join("") : t.slice(1);
            return s[e]() + l;
          };
        }
        function lt(e) {
          return function(t) {
            return Mr(Mu(Tu(t).replace(Hc, "")), e, "");
          };
        }
        function zt(e) {
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return new e();
              case 1:
                return new e(t[0]);
              case 2:
                return new e(t[0], t[1]);
              case 3:
                return new e(t[0], t[1], t[2]);
              case 4:
                return new e(t[0], t[1], t[2], t[3]);
              case 5:
                return new e(t[0], t[1], t[2], t[3], t[4]);
              case 6:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
              case 7:
                return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
            }
            var i = st(e.prototype), s = e.apply(i, t);
            return re(s) ? s : i;
          };
        }
        function nf(e, t, i) {
          var s = zt(e);
          function l() {
            for (var p = arguments.length, h = g(p), m = p, A = ct(l); m--; )
              h[m] = arguments[m];
            var M = p < 3 && h[0] !== A && h[p - 1] !== A ? [] : So(h, A);
            if (p -= M.length, p < i)
              return Fs(
                e,
                t,
                Fn,
                l.placeholder,
                r,
                h,
                M,
                r,
                r,
                i - p
              );
            var x = this && this !== _e && this instanceof l ? s : e;
            return ke(x, this, h);
          }
          return l;
        }
        function xs(e) {
          return function(t, i, s) {
            var l = Y(t);
            if (!Ne(t)) {
              var p = L(i, 3);
              t = he(t), i = function(m) {
                return p(l[m], m, l);
              };
            }
            var h = e(t, i, s);
            return h > -1 ? l[p ? t[h] : h] : r;
          };
        }
        function Ss(e) {
          return mo(function(t) {
            var i = t.length, s = i, l = Ze.prototype.thru;
            for (e && t.reverse(); s--; ) {
              var p = t[s];
              if (typeof p != "function")
                throw new Ue(d);
              if (l && !h && Bn(p) == "wrapper")
                var h = new Ze([], !0);
            }
            for (s = h ? s : i; ++s < i; ) {
              p = t[s];
              var m = Bn(p), A = m == "wrapper" ? ti(p) : r;
              A && ai(A[0]) && A[1] == (lo | oe | oo | yt) && !A[4].length && A[9] == 1 ? h = h[Bn(A[0])].apply(h, A[3]) : h = p.length == 1 && ai(p) ? h[m]() : h.thru(p);
            }
            return function() {
              var M = arguments, x = M[0];
              if (h && M.length == 1 && G(x))
                return h.plant(x).value();
              for (var S = 0, N = i ? t[S].apply(this, M) : x; ++S < i; )
                N = t[S].call(this, N);
              return N;
            };
          });
        }
        function Fn(e, t, i, s, l, p, h, m, A, M) {
          var x = t & lo, S = t & Ee, N = t & To, C = t & (oe | me), P = t & tr, Z = N ? r : zt(e);
          function D() {
            for (var K = arguments.length, H = g(K), Oe = K; Oe--; )
              H[Oe] = arguments[Oe];
            if (C)
              var Ie = ct(D), ze = md(H, Ie);
            if (s && (H = gs(H, s, l, C)), p && (H = ys(H, p, h, C)), K -= ze, C && K < M) {
              var le = So(H, Ie);
              return Fs(
                e,
                t,
                Fn,
                D.placeholder,
                i,
                H,
                le,
                m,
                A,
                M - K
              );
            }
            var eo = S ? i : this, go = N ? eo[e] : e;
            return K = H.length, m ? H = xf(H, m) : P && K > 1 && H.reverse(), x && A < K && (H.length = A), this && this !== _e && this instanceof D && (go = Z || zt(go)), go.apply(eo, H);
          }
          return D;
        }
        function vs(e, t) {
          return function(i, s) {
            return Ep(i, e, t(s), {});
          };
        }
        function wn(e, t) {
          return function(i, s) {
            var l;
            if (i === r && s === r)
              return t;
            if (i !== r && (l = i), s !== r) {
              if (l === r)
                return s;
              typeof i == "string" || typeof s == "string" ? (i = Pe(i), s = Pe(s)) : (i = ds(i), s = ds(s)), l = e(i, s);
            }
            return l;
          };
        }
        function Xr(e) {
          return mo(function(t) {
            return t = te(t, Le(L())), $(function(i) {
              var s = this;
              return e(t, function(l) {
                return ke(l, s, i);
              });
            });
          });
        }
        function Cn(e, t) {
          t = t === r ? " " : Pe(t);
          var i = t.length;
          if (i < 2)
            return i ? qr(t, e) : t;
          var s = qr(t, _n(e / tt(t)));
          return ot(t) ? Co(je(s), 0, e).join("") : s.slice(0, e);
        }
        function rf(e, t, i, s) {
          var l = t & Ee, p = zt(e);
          function h() {
            for (var m = -1, A = arguments.length, M = -1, x = s.length, S = g(x + A), N = this && this !== _e && this instanceof h ? p : e; ++M < x; )
              S[M] = s[M];
            for (; A--; )
              S[M++] = arguments[++m];
            return ke(N, l ? i : this, S);
          }
          return h;
        }
        function Ns(e) {
          return function(t, i, s) {
            return s && typeof s != "number" && Me(t, i, s) && (i = s = r), t = Ao(t), i === r ? (i = t, t = 0) : i = Ao(i), s = s === r ? t < i ? 1 : -1 : Ao(s), $p(t, i, s, e);
          };
        }
        function En(e) {
          return function(t, i) {
            return typeof t == "string" && typeof i == "string" || (t = He(t), i = He(i)), e(t, i);
          };
        }
        function Fs(e, t, i, s, l, p, h, m, A, M) {
          var x = t & oe, S = x ? h : r, N = x ? r : h, C = x ? p : r, P = x ? r : p;
          t |= x ? oo : Po, t &= ~(x ? Po : oo), t & Be || (t &= -4);
          var Z = [
            e,
            t,
            l,
            C,
            S,
            P,
            N,
            m,
            A,
            M
          ], D = i.apply(r, Z);
          return ai(e) && Gs(D, Z), D.placeholder = s, Us(D, e, t);
        }
        function Qr(e) {
          var t = pe[e];
          return function(i, s) {
            if (i = He(i), s = s == null ? 0 : ge(U(s), 292), s && Ua(i)) {
              var l = (J(i) + "e").split("e"), p = t(l[0] + "e" + (+l[1] + s));
              return l = (J(p) + "e").split("e"), +(l[0] + "e" + (+l[1] - s));
            }
            return t(i);
          };
        }
        var af = it && 1 / an(new it([, -0]))[1] == Ro ? function(e) {
          return new it(e);
        } : Mi;
        function ws(e) {
          return function(t) {
            var i = ye(t);
            return i == Ve ? wr(t) : i == Je ? Md(t) : hd(t, e(t));
          };
        }
        function ho(e, t, i, s, l, p, h, m) {
          var A = t & To;
          if (!A && typeof e != "function")
            throw new Ue(d);
          var M = s ? s.length : 0;
          if (M || (t &= -97, s = l = r), h = h === r ? h : fe(U(h), 0), m = m === r ? m : U(m), M -= l ? l.length : 0, t & Po) {
            var x = s, S = l;
            s = l = r;
          }
          var N = A ? r : ti(e), C = [
            e,
            t,
            i,
            s,
            l,
            x,
            S,
            p,
            h,
            m
          ];
          if (N && Tf(C, N), e = C[0], t = C[1], i = C[2], s = C[3], l = C[4], m = C[9] = C[9] === r ? A ? 0 : e.length : fe(C[9] - M, 0), !m && t & (oe | me) && (t &= -25), !t || t == Ee)
            var P = tf(e, t, i);
          else t == oe || t == me ? P = nf(e, t, m) : (t == oo || t == (Ee | oo)) && !l.length ? P = rf(e, t, i, s) : P = Fn.apply(r, C);
          var Z = N ? ls : Gs;
          return Us(Z(P, C), e, t);
        }
        function Cs(e, t, i, s) {
          return e === r || Qe(e, rt[i]) && !V.call(s, i) ? t : e;
        }
        function Es(e, t, i, s, l, p) {
          return re(e) && re(t) && (p.set(t, e), xn(e, t, r, Es, p), p.delete(t)), e;
        }
        function sf(e) {
          return Zt(e) ? r : e;
        }
        function Bs(e, t, i, s, l, p) {
          var h = i & ee, m = e.length, A = t.length;
          if (m != A && !(h && A > m))
            return !1;
          var M = p.get(e), x = p.get(t);
          if (M && x)
            return M == t && x == e;
          var S = -1, N = !0, C = i & uo ? new Uo() : r;
          for (p.set(e, t), p.set(t, e); ++S < m; ) {
            var P = e[S], Z = t[S];
            if (s)
              var D = h ? s(Z, P, S, t, e, p) : s(P, Z, S, e, t, p);
            if (D !== r) {
              if (D)
                continue;
              N = !1;
              break;
            }
            if (C) {
              if (!Ir(t, function(K, H) {
                if (!Ft(C, H) && (P === K || l(P, K, i, s, p)))
                  return C.push(H);
              })) {
                N = !1;
                break;
              }
            } else if (!(P === Z || l(P, Z, i, s, p))) {
              N = !1;
              break;
            }
          }
          return p.delete(e), p.delete(t), N;
        }
        function uf(e, t, i, s, l, p, h) {
          switch (i) {
            case Xo:
              if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
                return !1;
              e = e.buffer, t = t.buffer;
            case Nt:
              return !(e.byteLength != t.byteLength || !p(new pn(e), new pn(t)));
            case Tt:
            case Mt:
            case It:
              return Qe(+e, +t);
            case Yt:
              return e.name == t.name && e.message == t.message;
            case xt:
            case St:
              return e == t + "";
            case Ve:
              var m = wr;
            case Je:
              var A = s & ee;
              if (m || (m = an), e.size != t.size && !A)
                return !1;
              var M = h.get(e);
              if (M)
                return M == t;
              s |= uo, h.set(e, t);
              var x = Bs(m(e), m(t), s, l, p, h);
              return h.delete(e), x;
            case Qt:
              if (kt)
                return kt.call(e) == kt.call(t);
          }
          return !1;
        }
        function lf(e, t, i, s, l, p) {
          var h = i & ee, m = ei(e), A = m.length, M = ei(t), x = M.length;
          if (A != x && !h)
            return !1;
          for (var S = A; S--; ) {
            var N = m[S];
            if (!(h ? N in t : V.call(t, N)))
              return !1;
          }
          var C = p.get(e), P = p.get(t);
          if (C && P)
            return C == t && P == e;
          var Z = !0;
          p.set(e, t), p.set(t, e);
          for (var D = h; ++S < A; ) {
            N = m[S];
            var K = e[N], H = t[N];
            if (s)
              var Oe = h ? s(H, K, N, t, e, p) : s(K, H, N, e, t, p);
            if (!(Oe === r ? K === H || l(K, H, i, s, p) : Oe)) {
              Z = !1;
              break;
            }
            D || (D = N == "constructor");
          }
          if (Z && !D) {
            var Ie = e.constructor, ze = t.constructor;
            Ie != ze && "constructor" in e && "constructor" in t && !(typeof Ie == "function" && Ie instanceof Ie && typeof ze == "function" && ze instanceof ze) && (Z = !1);
          }
          return p.delete(e), p.delete(t), Z;
        }
        function mo(e) {
          return ui(Os(e, r, Ws), e + "");
        }
        function ei(e) {
          return Xa(e, he, ri);
        }
        function oi(e) {
          return Xa(e, Fe, ks);
        }
        var ti = An ? function(e) {
          return An.get(e);
        } : Mi;
        function Bn(e) {
          for (var t = e.name + "", i = at[t], s = V.call(at, t) ? i.length : 0; s--; ) {
            var l = i[s], p = l.func;
            if (p == null || p == e)
              return l.name;
          }
          return t;
        }
        function ct(e) {
          var t = V.call(c, "placeholder") ? c : e;
          return t.placeholder;
        }
        function L() {
          var e = c.iteratee || yi;
          return e = e === yi ? os : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function kn(e, t) {
          var i = e.__data__;
          return bf(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
        }
        function ni(e) {
          for (var t = he(e), i = t.length; i--; ) {
            var s = t[i], l = e[s];
            t[i] = [s, l, Ps(l)];
          }
          return t;
        }
        function Ko(e, t) {
          var i = gd(e, t);
          return es(i) ? i : r;
        }
        function cf(e) {
          var t = V.call(e, zo), i = e[zo];
          try {
            e[zo] = r;
            var s = !0;
          } catch {
          }
          var l = cn.call(e);
          return s && (t ? e[zo] = i : delete e[zo]), l;
        }
        var ri = Er ? function(e) {
          return e == null ? [] : (e = Y(e), Io(Er(e), function(t) {
            return za.call(e, t);
          }));
        } : Ii, ks = Er ? function(e) {
          for (var t = []; e; )
            xo(t, ri(e)), e = fn(e);
          return t;
        } : Ii, ye = Te;
        (Br && ye(new Br(new ArrayBuffer(1))) != Xo || Ct && ye(new Ct()) != Ve || kr && ye(kr.resolve()) != Vi || it && ye(new it()) != Je || Et && ye(new Et()) != vt) && (ye = function(e) {
          var t = Te(e), i = t == co ? e.constructor : r, s = i ? qo(i) : "";
          if (s)
            switch (s) {
              case qd:
                return Xo;
              case Hd:
                return Ve;
              case Wd:
                return Vi;
              case Vd:
                return Je;
              case Jd:
                return vt;
            }
          return t;
        });
        function df(e, t, i) {
          for (var s = -1, l = i.length; ++s < l; ) {
            var p = i[s], h = p.size;
            switch (p.type) {
              case "drop":
                e += h;
                break;
              case "dropRight":
                t -= h;
                break;
              case "take":
                t = ge(t, e + h);
                break;
              case "takeRight":
                e = fe(e, t - h);
                break;
            }
          }
          return { start: e, end: t };
        }
        function pf(e) {
          var t = e.match(Ac);
          return t ? t[1].split(gc) : [];
        }
        function Ds(e, t, i) {
          t = wo(t, e);
          for (var s = -1, l = t.length, p = !1; ++s < l; ) {
            var h = Xe(t[s]);
            if (!(p = e != null && i(e, h)))
              break;
            e = e[h];
          }
          return p || ++s != l ? p : (l = e == null ? 0 : e.length, !!l && Gn(l) && _o(h, l) && (G(e) || Ho(e)));
        }
        function ff(e) {
          var t = e.length, i = new e.constructor(t);
          return t && typeof e[0] == "string" && V.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function Ls(e) {
          return typeof e.constructor == "function" && !Gt(e) ? st(fn(e)) : {};
        }
        function hf(e, t, i) {
          var s = e.constructor;
          switch (t) {
            case Nt:
              return Yr(e);
            case Tt:
            case Mt:
              return new s(+e);
            case Xo:
              return jp(e, i);
            case nr:
            case rr:
            case ir:
            case ar:
            case sr:
            case ur:
            case lr:
            case cr:
            case dr:
              return bs(e, i);
            case Ve:
              return new s();
            case It:
            case St:
              return new s(e);
            case xt:
              return Yp(e);
            case Je:
              return new s();
            case Qt:
              return Xp(e);
          }
        }
        function mf(e, t) {
          var i = t.length;
          if (!i)
            return e;
          var s = i - 1;
          return t[s] = (i > 1 ? "& " : "") + t[s], t = t.join(i > 2 ? ", " : " "), e.replace(bc, `{
/* [wrapped with ` + t + `] */
`);
        }
        function _f(e) {
          return G(e) || Ho(e) || !!(Ga && e && e[Ga]);
        }
        function _o(e, t) {
          var i = typeof e;
          return t = t ?? Mo, !!t && (i == "number" || i != "symbol" && Nc.test(e)) && e > -1 && e % 1 == 0 && e < t;
        }
        function Me(e, t, i) {
          if (!re(i))
            return !1;
          var s = typeof t;
          return (s == "number" ? Ne(i) && _o(t, i.length) : s == "string" && t in i) ? Qe(i[t], e) : !1;
        }
        function ii(e, t) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || Re(e) ? !0 : fc.test(e) || !pc.test(e) || t != null && e in Y(t);
        }
        function bf(e) {
          var t = typeof e;
          return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
        }
        function ai(e) {
          var t = Bn(e), i = c[t];
          if (typeof i != "function" || !(t in q.prototype))
            return !1;
          if (e === i)
            return !0;
          var s = ti(i);
          return !!s && e === s[0];
        }
        function Af(e) {
          return !!Pa && Pa in e;
        }
        var gf = un ? bo : xi;
        function Gt(e) {
          var t = e && e.constructor, i = typeof t == "function" && t.prototype || rt;
          return e === i;
        }
        function Ps(e) {
          return e === e && !re(e);
        }
        function Rs(e, t) {
          return function(i) {
            return i == null ? !1 : i[e] === t && (t !== r || e in Y(i));
          };
        }
        function yf(e) {
          var t = On(e, function(s) {
            return i.size === w && i.clear(), s;
          }), i = t.cache;
          return t;
        }
        function Tf(e, t) {
          var i = e[1], s = t[1], l = i | s, p = l < (Ee | To | lo), h = s == lo && i == oe || s == lo && i == yt && e[7].length <= t[8] || s == (lo | yt) && t[7].length <= t[8] && i == oe;
          if (!(p || h))
            return e;
          s & Ee && (e[2] = t[2], l |= i & Ee ? 0 : Be);
          var m = t[3];
          if (m) {
            var A = e[3];
            e[3] = A ? gs(A, m, t[4]) : m, e[4] = A ? So(e[3], z) : t[4];
          }
          return m = t[5], m && (A = e[5], e[5] = A ? ys(A, m, t[6]) : m, e[6] = A ? So(e[5], z) : t[6]), m = t[7], m && (e[7] = m), s & lo && (e[8] = e[8] == null ? t[8] : ge(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = l, e;
        }
        function Mf(e) {
          var t = [];
          if (e != null)
            for (var i in Y(e))
              t.push(i);
          return t;
        }
        function If(e) {
          return cn.call(e);
        }
        function Os(e, t, i) {
          return t = fe(t === r ? e.length - 1 : t, 0), function() {
            for (var s = arguments, l = -1, p = fe(s.length - t, 0), h = g(p); ++l < p; )
              h[l] = s[t + l];
            l = -1;
            for (var m = g(t + 1); ++l < t; )
              m[l] = s[l];
            return m[t] = i(h), ke(e, this, m);
          };
        }
        function zs(e, t) {
          return t.length < 2 ? e : $o(e, Ke(t, 0, -1));
        }
        function xf(e, t) {
          for (var i = e.length, s = ge(t.length, i), l = ve(e); s--; ) {
            var p = t[s];
            e[s] = _o(p, i) ? l[p] : r;
          }
          return e;
        }
        function si(e, t) {
          if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
            return e[t];
        }
        var Gs = Zs(ls), Ut = Od || function(e, t) {
          return _e.setTimeout(e, t);
        }, ui = Zs(Hp);
        function Us(e, t, i) {
          var s = t + "";
          return ui(e, mf(s, Sf(pf(s), i)));
        }
        function Zs(e) {
          var t = 0, i = 0;
          return function() {
            var s = Zd(), l = Hl - (s - i);
            if (i = s, l > 0) {
              if (++t >= ql)
                return arguments[0];
            } else
              t = 0;
            return e.apply(r, arguments);
          };
        }
        function Dn(e, t) {
          var i = -1, s = e.length, l = s - 1;
          for (t = t === r ? s : t; ++i < t; ) {
            var p = Kr(i, l), h = e[p];
            e[p] = e[i], e[i] = h;
          }
          return e.length = t, e;
        }
        var $s = yf(function(e) {
          var t = [];
          return e.charCodeAt(0) === 46 && t.push(""), e.replace(hc, function(i, s, l, p) {
            t.push(l ? p.replace(Tc, "$1") : s || i);
          }), t;
        });
        function Xe(e) {
          if (typeof e == "string" || Re(e))
            return e;
          var t = e + "";
          return t == "0" && 1 / e == -Ro ? "-0" : t;
        }
        function qo(e) {
          if (e != null) {
            try {
              return ln.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function Sf(e, t) {
          return De(Xl, function(i) {
            var s = "_." + i[0];
            t & i[1] && !nn(e, s) && e.push(s);
          }), e.sort();
        }
        function Ks(e) {
          if (e instanceof q)
            return e.clone();
          var t = new Ze(e.__wrapped__, e.__chain__);
          return t.__actions__ = ve(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
        }
        function vf(e, t, i) {
          (i ? Me(e, t, i) : t === r) ? t = 1 : t = fe(U(t), 0);
          var s = e == null ? 0 : e.length;
          if (!s || t < 1)
            return [];
          for (var l = 0, p = 0, h = g(_n(s / t)); l < s; )
            h[p++] = Ke(e, l, l += t);
          return h;
        }
        function Nf(e) {
          for (var t = -1, i = e == null ? 0 : e.length, s = 0, l = []; ++t < i; ) {
            var p = e[t];
            p && (l[s++] = p);
          }
          return l;
        }
        function Ff() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var t = g(e - 1), i = arguments[0], s = e; s--; )
            t[s - 1] = arguments[s];
          return xo(G(i) ? ve(i) : [i], be(t, 1));
        }
        var wf = $(function(e, t) {
          return ue(e) ? Lt(e, be(t, 1, ue, !0)) : [];
        }), Cf = $(function(e, t) {
          var i = qe(t);
          return ue(i) && (i = r), ue(e) ? Lt(e, be(t, 1, ue, !0), L(i, 2)) : [];
        }), Ef = $(function(e, t) {
          var i = qe(t);
          return ue(i) && (i = r), ue(e) ? Lt(e, be(t, 1, ue, !0), r, i) : [];
        });
        function Bf(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === r ? 1 : U(t), Ke(e, t < 0 ? 0 : t, s)) : [];
        }
        function kf(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === r ? 1 : U(t), t = s - t, Ke(e, 0, t < 0 ? 0 : t)) : [];
        }
        function Df(e, t) {
          return e && e.length ? vn(e, L(t, 3), !0, !0) : [];
        }
        function Lf(e, t) {
          return e && e.length ? vn(e, L(t, 3), !0) : [];
        }
        function Pf(e, t, i, s) {
          var l = e == null ? 0 : e.length;
          return l ? (i && typeof i != "number" && Me(e, t, i) && (i = 0, s = l), Np(e, t, i, s)) : [];
        }
        function qs(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : U(i);
          return l < 0 && (l = fe(s + l, 0)), rn(e, L(t, 3), l);
        }
        function Hs(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s - 1;
          return i !== r && (l = U(i), l = i < 0 ? fe(s + l, 0) : ge(l, s - 1)), rn(e, L(t, 3), l, !0);
        }
        function Ws(e) {
          var t = e == null ? 0 : e.length;
          return t ? be(e, 1) : [];
        }
        function Rf(e) {
          var t = e == null ? 0 : e.length;
          return t ? be(e, Ro) : [];
        }
        function Of(e, t) {
          var i = e == null ? 0 : e.length;
          return i ? (t = t === r ? 1 : U(t), be(e, t)) : [];
        }
        function zf(e) {
          for (var t = -1, i = e == null ? 0 : e.length, s = {}; ++t < i; ) {
            var l = e[t];
            no(s, l[0], l[1]);
          }
          return s;
        }
        function Vs(e) {
          return e && e.length ? e[0] : r;
        }
        function Gf(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = i == null ? 0 : U(i);
          return l < 0 && (l = fe(s + l, 0)), et(e, t, l);
        }
        function Uf(e) {
          var t = e == null ? 0 : e.length;
          return t ? Ke(e, 0, -1) : [];
        }
        var Zf = $(function(e) {
          var t = te(e, Jr);
          return t.length && t[0] === e[0] ? zr(t) : [];
        }), $f = $(function(e) {
          var t = qe(e), i = te(e, Jr);
          return t === qe(i) ? t = r : i.pop(), i.length && i[0] === e[0] ? zr(i, L(t, 2)) : [];
        }), Kf = $(function(e) {
          var t = qe(e), i = te(e, Jr);
          return t = typeof t == "function" ? t : r, t && i.pop(), i.length && i[0] === e[0] ? zr(i, r, t) : [];
        });
        function qf(e, t) {
          return e == null ? "" : Gd.call(e, t);
        }
        function qe(e) {
          var t = e == null ? 0 : e.length;
          return t ? e[t - 1] : r;
        }
        function Hf(e, t, i) {
          var s = e == null ? 0 : e.length;
          if (!s)
            return -1;
          var l = s;
          return i !== r && (l = U(i), l = l < 0 ? fe(s + l, 0) : ge(l, s - 1)), t === t ? xd(e, t, l) : rn(e, Fa, l, !0);
        }
        function Wf(e, t) {
          return e && e.length ? is(e, U(t)) : r;
        }
        var Vf = $(Js);
        function Js(e, t) {
          return e && e.length && t && t.length ? $r(e, t) : e;
        }
        function Jf(e, t, i) {
          return e && e.length && t && t.length ? $r(e, t, L(i, 2)) : e;
        }
        function jf(e, t, i) {
          return e && e.length && t && t.length ? $r(e, t, r, i) : e;
        }
        var Yf = mo(function(e, t) {
          var i = e == null ? 0 : e.length, s = Lr(e, t);
          return us(e, te(t, function(l) {
            return _o(l, i) ? +l : l;
          }).sort(As)), s;
        });
        function Xf(e, t) {
          var i = [];
          if (!(e && e.length))
            return i;
          var s = -1, l = [], p = e.length;
          for (t = L(t, 3); ++s < p; ) {
            var h = e[s];
            t(h, s, e) && (i.push(h), l.push(s));
          }
          return us(e, l), i;
        }
        function li(e) {
          return e == null ? e : Kd.call(e);
        }
        function Qf(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (i && typeof i != "number" && Me(e, t, i) ? (t = 0, i = s) : (t = t == null ? 0 : U(t), i = i === r ? s : U(i)), Ke(e, t, i)) : [];
        }
        function eh(e, t) {
          return Sn(e, t);
        }
        function oh(e, t, i) {
          return Hr(e, t, L(i, 2));
        }
        function th(e, t) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Sn(e, t);
            if (s < i && Qe(e[s], t))
              return s;
          }
          return -1;
        }
        function nh(e, t) {
          return Sn(e, t, !0);
        }
        function rh(e, t, i) {
          return Hr(e, t, L(i, 2), !0);
        }
        function ih(e, t) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var s = Sn(e, t, !0) - 1;
            if (Qe(e[s], t))
              return s;
          }
          return -1;
        }
        function ah(e) {
          return e && e.length ? cs(e) : [];
        }
        function sh(e, t) {
          return e && e.length ? cs(e, L(t, 2)) : [];
        }
        function uh(e) {
          var t = e == null ? 0 : e.length;
          return t ? Ke(e, 1, t) : [];
        }
        function lh(e, t, i) {
          return e && e.length ? (t = i || t === r ? 1 : U(t), Ke(e, 0, t < 0 ? 0 : t)) : [];
        }
        function ch(e, t, i) {
          var s = e == null ? 0 : e.length;
          return s ? (t = i || t === r ? 1 : U(t), t = s - t, Ke(e, t < 0 ? 0 : t, s)) : [];
        }
        function dh(e, t) {
          return e && e.length ? vn(e, L(t, 3), !1, !0) : [];
        }
        function ph(e, t) {
          return e && e.length ? vn(e, L(t, 3)) : [];
        }
        var fh = $(function(e) {
          return Fo(be(e, 1, ue, !0));
        }), hh = $(function(e) {
          var t = qe(e);
          return ue(t) && (t = r), Fo(be(e, 1, ue, !0), L(t, 2));
        }), mh = $(function(e) {
          var t = qe(e);
          return t = typeof t == "function" ? t : r, Fo(be(e, 1, ue, !0), r, t);
        });
        function _h(e) {
          return e && e.length ? Fo(e) : [];
        }
        function bh(e, t) {
          return e && e.length ? Fo(e, L(t, 2)) : [];
        }
        function Ah(e, t) {
          return t = typeof t == "function" ? t : r, e && e.length ? Fo(e, r, t) : [];
        }
        function ci(e) {
          if (!(e && e.length))
            return [];
          var t = 0;
          return e = Io(e, function(i) {
            if (ue(i))
              return t = fe(i.length, t), !0;
          }), Nr(t, function(i) {
            return te(e, xr(i));
          });
        }
        function js(e, t) {
          if (!(e && e.length))
            return [];
          var i = ci(e);
          return t == null ? i : te(i, function(s) {
            return ke(t, r, s);
          });
        }
        var gh = $(function(e, t) {
          return ue(e) ? Lt(e, t) : [];
        }), yh = $(function(e) {
          return Vr(Io(e, ue));
        }), Th = $(function(e) {
          var t = qe(e);
          return ue(t) && (t = r), Vr(Io(e, ue), L(t, 2));
        }), Mh = $(function(e) {
          var t = qe(e);
          return t = typeof t == "function" ? t : r, Vr(Io(e, ue), r, t);
        }), Ih = $(ci);
        function xh(e, t) {
          return hs(e || [], t || [], Dt);
        }
        function Sh(e, t) {
          return hs(e || [], t || [], Ot);
        }
        var vh = $(function(e) {
          var t = e.length, i = t > 1 ? e[t - 1] : r;
          return i = typeof i == "function" ? (e.pop(), i) : r, js(e, i);
        });
        function Ys(e) {
          var t = c(e);
          return t.__chain__ = !0, t;
        }
        function Nh(e, t) {
          return t(e), e;
        }
        function Ln(e, t) {
          return t(e);
        }
        var Fh = mo(function(e) {
          var t = e.length, i = t ? e[0] : 0, s = this.__wrapped__, l = function(p) {
            return Lr(p, e);
          };
          return t > 1 || this.__actions__.length || !(s instanceof q) || !_o(i) ? this.thru(l) : (s = s.slice(i, +i + (t ? 1 : 0)), s.__actions__.push({
            func: Ln,
            args: [l],
            thisArg: r
          }), new Ze(s, this.__chain__).thru(function(p) {
            return t && !p.length && p.push(r), p;
          }));
        });
        function wh() {
          return Ys(this);
        }
        function Ch() {
          return new Ze(this.value(), this.__chain__);
        }
        function Eh() {
          this.__values__ === r && (this.__values__ = du(this.value()));
          var e = this.__index__ >= this.__values__.length, t = e ? r : this.__values__[this.__index__++];
          return { done: e, value: t };
        }
        function Bh() {
          return this;
        }
        function kh(e) {
          for (var t, i = this; i instanceof yn; ) {
            var s = Ks(i);
            s.__index__ = 0, s.__values__ = r, t ? l.__wrapped__ = s : t = s;
            var l = s;
            i = i.__wrapped__;
          }
          return l.__wrapped__ = e, t;
        }
        function Dh() {
          var e = this.__wrapped__;
          if (e instanceof q) {
            var t = e;
            return this.__actions__.length && (t = new q(this)), t = t.reverse(), t.__actions__.push({
              func: Ln,
              args: [li],
              thisArg: r
            }), new Ze(t, this.__chain__);
          }
          return this.thru(li);
        }
        function Lh() {
          return fs(this.__wrapped__, this.__actions__);
        }
        var Ph = Nn(function(e, t, i) {
          V.call(e, i) ? ++e[i] : no(e, i, 1);
        });
        function Rh(e, t, i) {
          var s = G(e) ? va : vp;
          return i && Me(e, t, i) && (t = r), s(e, L(t, 3));
        }
        function Oh(e, t) {
          var i = G(e) ? Io : ja;
          return i(e, L(t, 3));
        }
        var zh = xs(qs), Gh = xs(Hs);
        function Uh(e, t) {
          return be(Pn(e, t), 1);
        }
        function Zh(e, t) {
          return be(Pn(e, t), Ro);
        }
        function $h(e, t, i) {
          return i = i === r ? 1 : U(i), be(Pn(e, t), i);
        }
        function Xs(e, t) {
          var i = G(e) ? De : No;
          return i(e, L(t, 3));
        }
        function Qs(e, t) {
          var i = G(e) ? sd : Ja;
          return i(e, L(t, 3));
        }
        var Kh = Nn(function(e, t, i) {
          V.call(e, i) ? e[i].push(t) : no(e, i, [t]);
        });
        function qh(e, t, i, s) {
          e = Ne(e) ? e : pt(e), i = i && !s ? U(i) : 0;
          var l = e.length;
          return i < 0 && (i = fe(l + i, 0)), Un(e) ? i <= l && e.indexOf(t, i) > -1 : !!l && et(e, t, i) > -1;
        }
        var Hh = $(function(e, t, i) {
          var s = -1, l = typeof t == "function", p = Ne(e) ? g(e.length) : [];
          return No(e, function(h) {
            p[++s] = l ? ke(t, h, i) : Pt(h, t, i);
          }), p;
        }), Wh = Nn(function(e, t, i) {
          no(e, i, t);
        });
        function Pn(e, t) {
          var i = G(e) ? te : ts;
          return i(e, L(t, 3));
        }
        function Vh(e, t, i, s) {
          return e == null ? [] : (G(t) || (t = t == null ? [] : [t]), i = s ? r : i, G(i) || (i = i == null ? [] : [i]), as(e, t, i));
        }
        var Jh = Nn(function(e, t, i) {
          e[i ? 0 : 1].push(t);
        }, function() {
          return [[], []];
        });
        function jh(e, t, i) {
          var s = G(e) ? Mr : Ca, l = arguments.length < 3;
          return s(e, L(t, 4), i, l, No);
        }
        function Yh(e, t, i) {
          var s = G(e) ? ud : Ca, l = arguments.length < 3;
          return s(e, L(t, 4), i, l, Ja);
        }
        function Xh(e, t) {
          var i = G(e) ? Io : ja;
          return i(e, zn(L(t, 3)));
        }
        function Qh(e) {
          var t = G(e) ? qa : Kp;
          return t(e);
        }
        function em(e, t, i) {
          (i ? Me(e, t, i) : t === r) ? t = 1 : t = U(t);
          var s = G(e) ? Tp : qp;
          return s(e, t);
        }
        function om(e) {
          var t = G(e) ? Mp : Wp;
          return t(e);
        }
        function tm(e) {
          if (e == null)
            return 0;
          if (Ne(e))
            return Un(e) ? tt(e) : e.length;
          var t = ye(e);
          return t == Ve || t == Je ? e.size : Ur(e).length;
        }
        function nm(e, t, i) {
          var s = G(e) ? Ir : Vp;
          return i && Me(e, t, i) && (t = r), s(e, L(t, 3));
        }
        var rm = $(function(e, t) {
          if (e == null)
            return [];
          var i = t.length;
          return i > 1 && Me(e, t[0], t[1]) ? t = [] : i > 2 && Me(t[0], t[1], t[2]) && (t = [t[0]]), as(e, be(t, 1), []);
        }), Rn = Rd || function() {
          return _e.Date.now();
        };
        function im(e, t) {
          if (typeof t != "function")
            throw new Ue(d);
          return e = U(e), function() {
            if (--e < 1)
              return t.apply(this, arguments);
          };
        }
        function eu(e, t, i) {
          return t = i ? r : t, t = e && t == null ? e.length : t, ho(e, lo, r, r, r, r, t);
        }
        function ou(e, t) {
          var i;
          if (typeof t != "function")
            throw new Ue(d);
          return e = U(e), function() {
            return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = r), i;
          };
        }
        var di = $(function(e, t, i) {
          var s = Ee;
          if (i.length) {
            var l = So(i, ct(di));
            s |= oo;
          }
          return ho(e, s, t, i, l);
        }), tu = $(function(e, t, i) {
          var s = Ee | To;
          if (i.length) {
            var l = So(i, ct(tu));
            s |= oo;
          }
          return ho(t, s, e, i, l);
        });
        function nu(e, t, i) {
          t = i ? r : t;
          var s = ho(e, oe, r, r, r, r, r, t);
          return s.placeholder = nu.placeholder, s;
        }
        function ru(e, t, i) {
          t = i ? r : t;
          var s = ho(e, me, r, r, r, r, r, t);
          return s.placeholder = ru.placeholder, s;
        }
        function iu(e, t, i) {
          var s, l, p, h, m, A, M = 0, x = !1, S = !1, N = !0;
          if (typeof e != "function")
            throw new Ue(d);
          t = He(t) || 0, re(i) && (x = !!i.leading, S = "maxWait" in i, p = S ? fe(He(i.maxWait) || 0, t) : p, N = "trailing" in i ? !!i.trailing : N);
          function C(le) {
            var eo = s, go = l;
            return s = l = r, M = le, h = e.apply(go, eo), h;
          }
          function P(le) {
            return M = le, m = Ut(K, t), x ? C(le) : h;
          }
          function Z(le) {
            var eo = le - A, go = le - M, Su = t - eo;
            return S ? ge(Su, p - go) : Su;
          }
          function D(le) {
            var eo = le - A, go = le - M;
            return A === r || eo >= t || eo < 0 || S && go >= p;
          }
          function K() {
            var le = Rn();
            if (D(le))
              return H(le);
            m = Ut(K, Z(le));
          }
          function H(le) {
            return m = r, N && s ? C(le) : (s = l = r, h);
          }
          function Oe() {
            m !== r && ms(m), M = 0, s = A = l = m = r;
          }
          function Ie() {
            return m === r ? h : H(Rn());
          }
          function ze() {
            var le = Rn(), eo = D(le);
            if (s = arguments, l = this, A = le, eo) {
              if (m === r)
                return P(A);
              if (S)
                return ms(m), m = Ut(K, t), C(A);
            }
            return m === r && (m = Ut(K, t)), h;
          }
          return ze.cancel = Oe, ze.flush = Ie, ze;
        }
        var am = $(function(e, t) {
          return Va(e, 1, t);
        }), sm = $(function(e, t, i) {
          return Va(e, He(t) || 0, i);
        });
        function um(e) {
          return ho(e, tr);
        }
        function On(e, t) {
          if (typeof e != "function" || t != null && typeof t != "function")
            throw new Ue(d);
          var i = function() {
            var s = arguments, l = t ? t.apply(this, s) : s[0], p = i.cache;
            if (p.has(l))
              return p.get(l);
            var h = e.apply(this, s);
            return i.cache = p.set(l, h) || p, h;
          };
          return i.cache = new (On.Cache || fo)(), i;
        }
        On.Cache = fo;
        function zn(e) {
          if (typeof e != "function")
            throw new Ue(d);
          return function() {
            var t = arguments;
            switch (t.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, t[0]);
              case 2:
                return !e.call(this, t[0], t[1]);
              case 3:
                return !e.call(this, t[0], t[1], t[2]);
            }
            return !e.apply(this, t);
          };
        }
        function lm(e) {
          return ou(2, e);
        }
        var cm = Jp(function(e, t) {
          t = t.length == 1 && G(t[0]) ? te(t[0], Le(L())) : te(be(t, 1), Le(L()));
          var i = t.length;
          return $(function(s) {
            for (var l = -1, p = ge(s.length, i); ++l < p; )
              s[l] = t[l].call(this, s[l]);
            return ke(e, this, s);
          });
        }), pi = $(function(e, t) {
          var i = So(t, ct(pi));
          return ho(e, oo, r, t, i);
        }), au = $(function(e, t) {
          var i = So(t, ct(au));
          return ho(e, Po, r, t, i);
        }), dm = mo(function(e, t) {
          return ho(e, yt, r, r, r, t);
        });
        function pm(e, t) {
          if (typeof e != "function")
            throw new Ue(d);
          return t = t === r ? t : U(t), $(e, t);
        }
        function fm(e, t) {
          if (typeof e != "function")
            throw new Ue(d);
          return t = t == null ? 0 : fe(U(t), 0), $(function(i) {
            var s = i[t], l = Co(i, 0, t);
            return s && xo(l, s), ke(e, this, l);
          });
        }
        function hm(e, t, i) {
          var s = !0, l = !0;
          if (typeof e != "function")
            throw new Ue(d);
          return re(i) && (s = "leading" in i ? !!i.leading : s, l = "trailing" in i ? !!i.trailing : l), iu(e, t, {
            leading: s,
            maxWait: t,
            trailing: l
          });
        }
        function mm(e) {
          return eu(e, 1);
        }
        function _m(e, t) {
          return pi(jr(t), e);
        }
        function bm() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function Am(e) {
          return $e(e, ae);
        }
        function gm(e, t) {
          return t = typeof t == "function" ? t : r, $e(e, ae, t);
        }
        function ym(e) {
          return $e(e, B | ae);
        }
        function Tm(e, t) {
          return t = typeof t == "function" ? t : r, $e(e, B | ae, t);
        }
        function Mm(e, t) {
          return t == null || Wa(e, t, he(t));
        }
        function Qe(e, t) {
          return e === t || e !== e && t !== t;
        }
        var Im = En(Or), xm = En(function(e, t) {
          return e >= t;
        }), Ho = Qa(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? Qa : function(e) {
          return se(e) && V.call(e, "callee") && !za.call(e, "callee");
        }, G = g.isArray, Sm = ya ? Le(ya) : Bp;
        function Ne(e) {
          return e != null && Gn(e.length) && !bo(e);
        }
        function ue(e) {
          return se(e) && Ne(e);
        }
        function vm(e) {
          return e === !0 || e === !1 || se(e) && Te(e) == Tt;
        }
        var Eo = zd || xi, Nm = Ta ? Le(Ta) : kp;
        function Fm(e) {
          return se(e) && e.nodeType === 1 && !Zt(e);
        }
        function wm(e) {
          if (e == null)
            return !0;
          if (Ne(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || Eo(e) || dt(e) || Ho(e)))
            return !e.length;
          var t = ye(e);
          if (t == Ve || t == Je)
            return !e.size;
          if (Gt(e))
            return !Ur(e).length;
          for (var i in e)
            if (V.call(e, i))
              return !1;
          return !0;
        }
        function Cm(e, t) {
          return Rt(e, t);
        }
        function Em(e, t, i) {
          i = typeof i == "function" ? i : r;
          var s = i ? i(e, t) : r;
          return s === r ? Rt(e, t, r, i) : !!s;
        }
        function fi(e) {
          if (!se(e))
            return !1;
          var t = Te(e);
          return t == Yt || t == ec || typeof e.message == "string" && typeof e.name == "string" && !Zt(e);
        }
        function Bm(e) {
          return typeof e == "number" && Ua(e);
        }
        function bo(e) {
          if (!re(e))
            return !1;
          var t = Te(e);
          return t == Xt || t == Wi || t == Ql || t == tc;
        }
        function su(e) {
          return typeof e == "number" && e == U(e);
        }
        function Gn(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Mo;
        }
        function re(e) {
          var t = typeof e;
          return e != null && (t == "object" || t == "function");
        }
        function se(e) {
          return e != null && typeof e == "object";
        }
        var uu = Ma ? Le(Ma) : Lp;
        function km(e, t) {
          return e === t || Gr(e, t, ni(t));
        }
        function Dm(e, t, i) {
          return i = typeof i == "function" ? i : r, Gr(e, t, ni(t), i);
        }
        function Lm(e) {
          return lu(e) && e != +e;
        }
        function Pm(e) {
          if (gf(e))
            throw new O(f);
          return es(e);
        }
        function Rm(e) {
          return e === null;
        }
        function Om(e) {
          return e == null;
        }
        function lu(e) {
          return typeof e == "number" || se(e) && Te(e) == It;
        }
        function Zt(e) {
          if (!se(e) || Te(e) != co)
            return !1;
          var t = fn(e);
          if (t === null)
            return !0;
          var i = V.call(t, "constructor") && t.constructor;
          return typeof i == "function" && i instanceof i && ln.call(i) == kd;
        }
        var hi = Ia ? Le(Ia) : Pp;
        function zm(e) {
          return su(e) && e >= -Mo && e <= Mo;
        }
        var cu = xa ? Le(xa) : Rp;
        function Un(e) {
          return typeof e == "string" || !G(e) && se(e) && Te(e) == St;
        }
        function Re(e) {
          return typeof e == "symbol" || se(e) && Te(e) == Qt;
        }
        var dt = Sa ? Le(Sa) : Op;
        function Gm(e) {
          return e === r;
        }
        function Um(e) {
          return se(e) && ye(e) == vt;
        }
        function Zm(e) {
          return se(e) && Te(e) == rc;
        }
        var $m = En(Zr), Km = En(function(e, t) {
          return e <= t;
        });
        function du(e) {
          if (!e)
            return [];
          if (Ne(e))
            return Un(e) ? je(e) : ve(e);
          if (wt && e[wt])
            return Td(e[wt]());
          var t = ye(e), i = t == Ve ? wr : t == Je ? an : pt;
          return i(e);
        }
        function Ao(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === Ro || e === -Ro) {
            var t = e < 0 ? -1 : 1;
            return t * Jl;
          }
          return e === e ? e : 0;
        }
        function U(e) {
          var t = Ao(e), i = t % 1;
          return t === t ? i ? t - i : t : 0;
        }
        function pu(e) {
          return e ? Zo(U(e), 0, to) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (Re(e))
            return Jt;
          if (re(e)) {
            var t = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = re(t) ? t + "" : t;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = Ea(e);
          var i = xc.test(e);
          return i || vc.test(e) ? rd(e.slice(2), i ? 2 : 8) : Ic.test(e) ? Jt : +e;
        }
        function fu(e) {
          return io(e, Fe(e));
        }
        function qm(e) {
          return e ? Zo(U(e), -Mo, Mo) : e === 0 ? e : 0;
        }
        function J(e) {
          return e == null ? "" : Pe(e);
        }
        var Hm = ut(function(e, t) {
          if (Gt(t) || Ne(t)) {
            io(t, he(t), e);
            return;
          }
          for (var i in t)
            V.call(t, i) && Dt(e, i, t[i]);
        }), hu = ut(function(e, t) {
          io(t, Fe(t), e);
        }), mu = ut(function(e, t, i, s) {
          io(t, Fe(t), e, s);
        }), mi = ut(function(e, t, i, s) {
          io(t, he(t), e, s);
        }), Wm = mo(Lr);
        function Vm(e, t) {
          var i = st(e);
          return t == null ? i : Ha(i, t);
        }
        var Jm = $(function(e, t) {
          e = Y(e);
          var i = -1, s = t.length, l = s > 2 ? t[2] : r;
          for (l && Me(t[0], t[1], l) && (s = 1); ++i < s; )
            for (var p = t[i], h = Fe(p), m = -1, A = h.length; ++m < A; ) {
              var M = h[m], x = e[M];
              (x === r || Qe(x, rt[M]) && !V.call(e, M)) && (e[M] = p[M]);
            }
          return e;
        }), jm = $(function(e) {
          return e.push(r, Es), ke(_u, r, e);
        });
        function Ym(e, t) {
          return Na(e, L(t, 3), ro);
        }
        function Xm(e, t) {
          return Na(e, L(t, 3), Rr);
        }
        function Qm(e, t) {
          return e == null ? e : Pr(e, L(t, 3), Fe);
        }
        function e_(e, t) {
          return e == null ? e : Ya(e, L(t, 3), Fe);
        }
        function o_(e, t) {
          return e && ro(e, L(t, 3));
        }
        function t_(e, t) {
          return e && Rr(e, L(t, 3));
        }
        function n_(e) {
          return e == null ? [] : In(e, he(e));
        }
        function r_(e) {
          return e == null ? [] : In(e, Fe(e));
        }
        function _i(e, t, i) {
          var s = e == null ? r : $o(e, t);
          return s === r ? i : s;
        }
        function i_(e, t) {
          return e != null && Ds(e, t, Fp);
        }
        function bi(e, t) {
          return e != null && Ds(e, t, wp);
        }
        var a_ = vs(function(e, t, i) {
          t != null && typeof t.toString != "function" && (t = cn.call(t)), e[t] = i;
        }, gi(we)), s_ = vs(function(e, t, i) {
          t != null && typeof t.toString != "function" && (t = cn.call(t)), V.call(e, t) ? e[t].push(i) : e[t] = [i];
        }, L), u_ = $(Pt);
        function he(e) {
          return Ne(e) ? Ka(e) : Ur(e);
        }
        function Fe(e) {
          return Ne(e) ? Ka(e, !0) : zp(e);
        }
        function l_(e, t) {
          var i = {};
          return t = L(t, 3), ro(e, function(s, l, p) {
            no(i, t(s, l, p), s);
          }), i;
        }
        function c_(e, t) {
          var i = {};
          return t = L(t, 3), ro(e, function(s, l, p) {
            no(i, l, t(s, l, p));
          }), i;
        }
        var d_ = ut(function(e, t, i) {
          xn(e, t, i);
        }), _u = ut(function(e, t, i, s) {
          xn(e, t, i, s);
        }), p_ = mo(function(e, t) {
          var i = {};
          if (e == null)
            return i;
          var s = !1;
          t = te(t, function(p) {
            return p = wo(p, e), s || (s = p.length > 1), p;
          }), io(e, oi(e), i), s && (i = $e(i, B | R | ae, sf));
          for (var l = t.length; l--; )
            Wr(i, t[l]);
          return i;
        });
        function f_(e, t) {
          return bu(e, zn(L(t)));
        }
        var h_ = mo(function(e, t) {
          return e == null ? {} : Up(e, t);
        });
        function bu(e, t) {
          if (e == null)
            return {};
          var i = te(oi(e), function(s) {
            return [s];
          });
          return t = L(t), ss(e, i, function(s, l) {
            return t(s, l[0]);
          });
        }
        function m_(e, t, i) {
          t = wo(t, e);
          var s = -1, l = t.length;
          for (l || (l = 1, e = r); ++s < l; ) {
            var p = e == null ? r : e[Xe(t[s])];
            p === r && (s = l, p = i), e = bo(p) ? p.call(e) : p;
          }
          return e;
        }
        function __(e, t, i) {
          return e == null ? e : Ot(e, t, i);
        }
        function b_(e, t, i, s) {
          return s = typeof s == "function" ? s : r, e == null ? e : Ot(e, t, i, s);
        }
        var Au = ws(he), gu = ws(Fe);
        function A_(e, t, i) {
          var s = G(e), l = s || Eo(e) || dt(e);
          if (t = L(t, 4), i == null) {
            var p = e && e.constructor;
            l ? i = s ? new p() : [] : re(e) ? i = bo(p) ? st(fn(e)) : {} : i = {};
          }
          return (l ? De : ro)(e, function(h, m, A) {
            return t(i, h, m, A);
          }), i;
        }
        function g_(e, t) {
          return e == null ? !0 : Wr(e, t);
        }
        function y_(e, t, i) {
          return e == null ? e : ps(e, t, jr(i));
        }
        function T_(e, t, i, s) {
          return s = typeof s == "function" ? s : r, e == null ? e : ps(e, t, jr(i), s);
        }
        function pt(e) {
          return e == null ? [] : Fr(e, he(e));
        }
        function M_(e) {
          return e == null ? [] : Fr(e, Fe(e));
        }
        function I_(e, t, i) {
          return i === r && (i = t, t = r), i !== r && (i = He(i), i = i === i ? i : 0), t !== r && (t = He(t), t = t === t ? t : 0), Zo(He(e), t, i);
        }
        function x_(e, t, i) {
          return t = Ao(t), i === r ? (i = t, t = 0) : i = Ao(i), e = He(e), Cp(e, t, i);
        }
        function S_(e, t, i) {
          if (i && typeof i != "boolean" && Me(e, t, i) && (t = i = r), i === r && (typeof t == "boolean" ? (i = t, t = r) : typeof e == "boolean" && (i = e, e = r)), e === r && t === r ? (e = 0, t = 1) : (e = Ao(e), t === r ? (t = e, e = 0) : t = Ao(t)), e > t) {
            var s = e;
            e = t, t = s;
          }
          if (i || e % 1 || t % 1) {
            var l = Za();
            return ge(e + l * (t - e + nd("1e-" + ((l + "").length - 1))), t);
          }
          return Kr(e, t);
        }
        var v_ = lt(function(e, t, i) {
          return t = t.toLowerCase(), e + (i ? yu(t) : t);
        });
        function yu(e) {
          return Ai(J(e).toLowerCase());
        }
        function Tu(e) {
          return e = J(e), e && e.replace(Fc, _d).replace(Wc, "");
        }
        function N_(e, t, i) {
          e = J(e), t = Pe(t);
          var s = e.length;
          i = i === r ? s : Zo(U(i), 0, s);
          var l = i;
          return i -= t.length, i >= 0 && e.slice(i, l) == t;
        }
        function F_(e) {
          return e = J(e), e && lc.test(e) ? e.replace(ji, bd) : e;
        }
        function w_(e) {
          return e = J(e), e && mc.test(e) ? e.replace(pr, "\\$&") : e;
        }
        var C_ = lt(function(e, t, i) {
          return e + (i ? "-" : "") + t.toLowerCase();
        }), E_ = lt(function(e, t, i) {
          return e + (i ? " " : "") + t.toLowerCase();
        }), B_ = Is("toLowerCase");
        function k_(e, t, i) {
          e = J(e), t = U(t);
          var s = t ? tt(e) : 0;
          if (!t || s >= t)
            return e;
          var l = (t - s) / 2;
          return Cn(bn(l), i) + e + Cn(_n(l), i);
        }
        function D_(e, t, i) {
          e = J(e), t = U(t);
          var s = t ? tt(e) : 0;
          return t && s < t ? e + Cn(t - s, i) : e;
        }
        function L_(e, t, i) {
          e = J(e), t = U(t);
          var s = t ? tt(e) : 0;
          return t && s < t ? Cn(t - s, i) + e : e;
        }
        function P_(e, t, i) {
          return i || t == null ? t = 0 : t && (t = +t), $d(J(e).replace(fr, ""), t || 0);
        }
        function R_(e, t, i) {
          return (i ? Me(e, t, i) : t === r) ? t = 1 : t = U(t), qr(J(e), t);
        }
        function O_() {
          var e = arguments, t = J(e[0]);
          return e.length < 3 ? t : t.replace(e[1], e[2]);
        }
        var z_ = lt(function(e, t, i) {
          return e + (i ? "_" : "") + t.toLowerCase();
        });
        function G_(e, t, i) {
          return i && typeof i != "number" && Me(e, t, i) && (t = i = r), i = i === r ? to : i >>> 0, i ? (e = J(e), e && (typeof t == "string" || t != null && !hi(t)) && (t = Pe(t), !t && ot(e)) ? Co(je(e), 0, i) : e.split(t, i)) : [];
        }
        var U_ = lt(function(e, t, i) {
          return e + (i ? " " : "") + Ai(t);
        });
        function Z_(e, t, i) {
          return e = J(e), i = i == null ? 0 : Zo(U(i), 0, e.length), t = Pe(t), e.slice(i, i + t.length) == t;
        }
        function $_(e, t, i) {
          var s = c.templateSettings;
          i && Me(e, t, i) && (t = r), e = J(e), t = mi({}, t, s, Cs);
          var l = mi({}, t.imports, s.imports, Cs), p = he(l), h = Fr(l, p);
          De(p, function(D) {
            if (Xi.test(D))
              throw new O(T);
          });
          var m, A, M = 0, x = t.interpolate || en, S = "__p += '", N = Cr(
            (t.escape || en).source + "|" + x.source + "|" + (x === Yi ? Mc : en).source + "|" + (t.evaluate || en).source + "|$",
            "g"
          ), C = "//# sourceURL=" + (V.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Xc + "]") + `
`;
          e.replace(N, function(D, K, H, Oe, Ie, ze) {
            return H || (H = Oe), S += e.slice(M, ze).replace(wc, Ad), K && (m = !0, S += `' +
__e(` + K + `) +
'`), Ie && (A = !0, S += `';
` + Ie + `;
__p += '`), H && (S += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), M = ze + D.length, D;
          }), S += `';
`;
          var P = V.call(t, "variable") && t.variable;
          if (!P)
            S = `with (obj) {
` + S + `
}
`;
          else if (Xi.test(P))
            throw new O(_);
          S = (A ? S.replace(ic, "") : S).replace(ac, "$1").replace(sc, "$1;"), S = "function(" + (P || "obj") + `) {
` + (P ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (m ? ", __e = _.escape" : "") + (A ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + S + `return __p
}`;
          var Z = Iu(function() {
            return W(p, C + "return " + S).apply(r, h);
          });
          if (Z.source = S, fi(Z))
            throw Z;
          return Z;
        }
        function K_(e) {
          return J(e).toLowerCase();
        }
        function q_(e) {
          return J(e).toUpperCase();
        }
        function H_(e, t, i) {
          if (e = J(e), e && (i || t === r))
            return Ea(e);
          if (!e || !(t = Pe(t)))
            return e;
          var s = je(e), l = je(t), p = Ba(s, l), h = ka(s, l) + 1;
          return Co(s, p, h).join("");
        }
        function W_(e, t, i) {
          if (e = J(e), e && (i || t === r))
            return e.slice(0, La(e) + 1);
          if (!e || !(t = Pe(t)))
            return e;
          var s = je(e), l = ka(s, je(t)) + 1;
          return Co(s, 0, l).join("");
        }
        function V_(e, t, i) {
          if (e = J(e), e && (i || t === r))
            return e.replace(fr, "");
          if (!e || !(t = Pe(t)))
            return e;
          var s = je(e), l = Ba(s, je(t));
          return Co(s, l).join("");
        }
        function J_(e, t) {
          var i = $l, s = Kl;
          if (re(t)) {
            var l = "separator" in t ? t.separator : l;
            i = "length" in t ? U(t.length) : i, s = "omission" in t ? Pe(t.omission) : s;
          }
          e = J(e);
          var p = e.length;
          if (ot(e)) {
            var h = je(e);
            p = h.length;
          }
          if (i >= p)
            return e;
          var m = i - tt(s);
          if (m < 1)
            return s;
          var A = h ? Co(h, 0, m).join("") : e.slice(0, m);
          if (l === r)
            return A + s;
          if (h && (m += A.length - m), hi(l)) {
            if (e.slice(m).search(l)) {
              var M, x = A;
              for (l.global || (l = Cr(l.source, J(Qi.exec(l)) + "g")), l.lastIndex = 0; M = l.exec(x); )
                var S = M.index;
              A = A.slice(0, S === r ? m : S);
            }
          } else if (e.indexOf(Pe(l), m) != m) {
            var N = A.lastIndexOf(l);
            N > -1 && (A = A.slice(0, N));
          }
          return A + s;
        }
        function j_(e) {
          return e = J(e), e && uc.test(e) ? e.replace(Ji, Sd) : e;
        }
        var Y_ = lt(function(e, t, i) {
          return e + (i ? " " : "") + t.toUpperCase();
        }), Ai = Is("toUpperCase");
        function Mu(e, t, i) {
          return e = J(e), t = i ? r : t, t === r ? yd(e) ? Fd(e) : dd(e) : e.match(t) || [];
        }
        var Iu = $(function(e, t) {
          try {
            return ke(e, r, t);
          } catch (i) {
            return fi(i) ? i : new O(i);
          }
        }), X_ = mo(function(e, t) {
          return De(t, function(i) {
            i = Xe(i), no(e, i, di(e[i], e));
          }), e;
        });
        function Q_(e) {
          var t = e == null ? 0 : e.length, i = L();
          return e = t ? te(e, function(s) {
            if (typeof s[1] != "function")
              throw new Ue(d);
            return [i(s[0]), s[1]];
          }) : [], $(function(s) {
            for (var l = -1; ++l < t; ) {
              var p = e[l];
              if (ke(p[0], this, s))
                return ke(p[1], this, s);
            }
          });
        }
        function e0(e) {
          return Sp($e(e, B));
        }
        function gi(e) {
          return function() {
            return e;
          };
        }
        function o0(e, t) {
          return e == null || e !== e ? t : e;
        }
        var t0 = Ss(), n0 = Ss(!0);
        function we(e) {
          return e;
        }
        function yi(e) {
          return os(typeof e == "function" ? e : $e(e, B));
        }
        function r0(e) {
          return ns($e(e, B));
        }
        function i0(e, t) {
          return rs(e, $e(t, B));
        }
        var a0 = $(function(e, t) {
          return function(i) {
            return Pt(i, e, t);
          };
        }), s0 = $(function(e, t) {
          return function(i) {
            return Pt(e, i, t);
          };
        });
        function Ti(e, t, i) {
          var s = he(t), l = In(t, s);
          i == null && !(re(t) && (l.length || !s.length)) && (i = t, t = e, e = this, l = In(t, he(t)));
          var p = !(re(i) && "chain" in i) || !!i.chain, h = bo(e);
          return De(l, function(m) {
            var A = t[m];
            e[m] = A, h && (e.prototype[m] = function() {
              var M = this.__chain__;
              if (p || M) {
                var x = e(this.__wrapped__), S = x.__actions__ = ve(this.__actions__);
                return S.push({ func: A, args: arguments, thisArg: e }), x.__chain__ = M, x;
              }
              return A.apply(e, xo([this.value()], arguments));
            });
          }), e;
        }
        function u0() {
          return _e._ === this && (_e._ = Dd), this;
        }
        function Mi() {
        }
        function l0(e) {
          return e = U(e), $(function(t) {
            return is(t, e);
          });
        }
        var c0 = Xr(te), d0 = Xr(va), p0 = Xr(Ir);
        function xu(e) {
          return ii(e) ? xr(Xe(e)) : Zp(e);
        }
        function f0(e) {
          return function(t) {
            return e == null ? r : $o(e, t);
          };
        }
        var h0 = Ns(), m0 = Ns(!0);
        function Ii() {
          return [];
        }
        function xi() {
          return !1;
        }
        function _0() {
          return {};
        }
        function b0() {
          return "";
        }
        function A0() {
          return !0;
        }
        function g0(e, t) {
          if (e = U(e), e < 1 || e > Mo)
            return [];
          var i = to, s = ge(e, to);
          t = L(t), e -= to;
          for (var l = Nr(s, t); ++i < e; )
            t(i);
          return l;
        }
        function y0(e) {
          return G(e) ? te(e, Xe) : Re(e) ? [e] : ve($s(J(e)));
        }
        function T0(e) {
          var t = ++Bd;
          return J(e) + t;
        }
        var M0 = wn(function(e, t) {
          return e + t;
        }, 0), I0 = Qr("ceil"), x0 = wn(function(e, t) {
          return e / t;
        }, 1), S0 = Qr("floor");
        function v0(e) {
          return e && e.length ? Mn(e, we, Or) : r;
        }
        function N0(e, t) {
          return e && e.length ? Mn(e, L(t, 2), Or) : r;
        }
        function F0(e) {
          return wa(e, we);
        }
        function w0(e, t) {
          return wa(e, L(t, 2));
        }
        function C0(e) {
          return e && e.length ? Mn(e, we, Zr) : r;
        }
        function E0(e, t) {
          return e && e.length ? Mn(e, L(t, 2), Zr) : r;
        }
        var B0 = wn(function(e, t) {
          return e * t;
        }, 1), k0 = Qr("round"), D0 = wn(function(e, t) {
          return e - t;
        }, 0);
        function L0(e) {
          return e && e.length ? vr(e, we) : 0;
        }
        function P0(e, t) {
          return e && e.length ? vr(e, L(t, 2)) : 0;
        }
        return c.after = im, c.ary = eu, c.assign = Hm, c.assignIn = hu, c.assignInWith = mu, c.assignWith = mi, c.at = Wm, c.before = ou, c.bind = di, c.bindAll = X_, c.bindKey = tu, c.castArray = bm, c.chain = Ys, c.chunk = vf, c.compact = Nf, c.concat = Ff, c.cond = Q_, c.conforms = e0, c.constant = gi, c.countBy = Ph, c.create = Vm, c.curry = nu, c.curryRight = ru, c.debounce = iu, c.defaults = Jm, c.defaultsDeep = jm, c.defer = am, c.delay = sm, c.difference = wf, c.differenceBy = Cf, c.differenceWith = Ef, c.drop = Bf, c.dropRight = kf, c.dropRightWhile = Df, c.dropWhile = Lf, c.fill = Pf, c.filter = Oh, c.flatMap = Uh, c.flatMapDeep = Zh, c.flatMapDepth = $h, c.flatten = Ws, c.flattenDeep = Rf, c.flattenDepth = Of, c.flip = um, c.flow = t0, c.flowRight = n0, c.fromPairs = zf, c.functions = n_, c.functionsIn = r_, c.groupBy = Kh, c.initial = Uf, c.intersection = Zf, c.intersectionBy = $f, c.intersectionWith = Kf, c.invert = a_, c.invertBy = s_, c.invokeMap = Hh, c.iteratee = yi, c.keyBy = Wh, c.keys = he, c.keysIn = Fe, c.map = Pn, c.mapKeys = l_, c.mapValues = c_, c.matches = r0, c.matchesProperty = i0, c.memoize = On, c.merge = d_, c.mergeWith = _u, c.method = a0, c.methodOf = s0, c.mixin = Ti, c.negate = zn, c.nthArg = l0, c.omit = p_, c.omitBy = f_, c.once = lm, c.orderBy = Vh, c.over = c0, c.overArgs = cm, c.overEvery = d0, c.overSome = p0, c.partial = pi, c.partialRight = au, c.partition = Jh, c.pick = h_, c.pickBy = bu, c.property = xu, c.propertyOf = f0, c.pull = Vf, c.pullAll = Js, c.pullAllBy = Jf, c.pullAllWith = jf, c.pullAt = Yf, c.range = h0, c.rangeRight = m0, c.rearg = dm, c.reject = Xh, c.remove = Xf, c.rest = pm, c.reverse = li, c.sampleSize = em, c.set = __, c.setWith = b_, c.shuffle = om, c.slice = Qf, c.sortBy = rm, c.sortedUniq = ah, c.sortedUniqBy = sh, c.split = G_, c.spread = fm, c.tail = uh, c.take = lh, c.takeRight = ch, c.takeRightWhile = dh, c.takeWhile = ph, c.tap = Nh, c.throttle = hm, c.thru = Ln, c.toArray = du, c.toPairs = Au, c.toPairsIn = gu, c.toPath = y0, c.toPlainObject = fu, c.transform = A_, c.unary = mm, c.union = fh, c.unionBy = hh, c.unionWith = mh, c.uniq = _h, c.uniqBy = bh, c.uniqWith = Ah, c.unset = g_, c.unzip = ci, c.unzipWith = js, c.update = y_, c.updateWith = T_, c.values = pt, c.valuesIn = M_, c.without = gh, c.words = Mu, c.wrap = _m, c.xor = yh, c.xorBy = Th, c.xorWith = Mh, c.zip = Ih, c.zipObject = xh, c.zipObjectDeep = Sh, c.zipWith = vh, c.entries = Au, c.entriesIn = gu, c.extend = hu, c.extendWith = mu, Ti(c, c), c.add = M0, c.attempt = Iu, c.camelCase = v_, c.capitalize = yu, c.ceil = I0, c.clamp = I_, c.clone = Am, c.cloneDeep = ym, c.cloneDeepWith = Tm, c.cloneWith = gm, c.conformsTo = Mm, c.deburr = Tu, c.defaultTo = o0, c.divide = x0, c.endsWith = N_, c.eq = Qe, c.escape = F_, c.escapeRegExp = w_, c.every = Rh, c.find = zh, c.findIndex = qs, c.findKey = Ym, c.findLast = Gh, c.findLastIndex = Hs, c.findLastKey = Xm, c.floor = S0, c.forEach = Xs, c.forEachRight = Qs, c.forIn = Qm, c.forInRight = e_, c.forOwn = o_, c.forOwnRight = t_, c.get = _i, c.gt = Im, c.gte = xm, c.has = i_, c.hasIn = bi, c.head = Vs, c.identity = we, c.includes = qh, c.indexOf = Gf, c.inRange = x_, c.invoke = u_, c.isArguments = Ho, c.isArray = G, c.isArrayBuffer = Sm, c.isArrayLike = Ne, c.isArrayLikeObject = ue, c.isBoolean = vm, c.isBuffer = Eo, c.isDate = Nm, c.isElement = Fm, c.isEmpty = wm, c.isEqual = Cm, c.isEqualWith = Em, c.isError = fi, c.isFinite = Bm, c.isFunction = bo, c.isInteger = su, c.isLength = Gn, c.isMap = uu, c.isMatch = km, c.isMatchWith = Dm, c.isNaN = Lm, c.isNative = Pm, c.isNil = Om, c.isNull = Rm, c.isNumber = lu, c.isObject = re, c.isObjectLike = se, c.isPlainObject = Zt, c.isRegExp = hi, c.isSafeInteger = zm, c.isSet = cu, c.isString = Un, c.isSymbol = Re, c.isTypedArray = dt, c.isUndefined = Gm, c.isWeakMap = Um, c.isWeakSet = Zm, c.join = qf, c.kebabCase = C_, c.last = qe, c.lastIndexOf = Hf, c.lowerCase = E_, c.lowerFirst = B_, c.lt = $m, c.lte = Km, c.max = v0, c.maxBy = N0, c.mean = F0, c.meanBy = w0, c.min = C0, c.minBy = E0, c.stubArray = Ii, c.stubFalse = xi, c.stubObject = _0, c.stubString = b0, c.stubTrue = A0, c.multiply = B0, c.nth = Wf, c.noConflict = u0, c.noop = Mi, c.now = Rn, c.pad = k_, c.padEnd = D_, c.padStart = L_, c.parseInt = P_, c.random = S_, c.reduce = jh, c.reduceRight = Yh, c.repeat = R_, c.replace = O_, c.result = m_, c.round = k0, c.runInContext = b, c.sample = Qh, c.size = tm, c.snakeCase = z_, c.some = nm, c.sortedIndex = eh, c.sortedIndexBy = oh, c.sortedIndexOf = th, c.sortedLastIndex = nh, c.sortedLastIndexBy = rh, c.sortedLastIndexOf = ih, c.startCase = U_, c.startsWith = Z_, c.subtract = D0, c.sum = L0, c.sumBy = P0, c.template = $_, c.times = g0, c.toFinite = Ao, c.toInteger = U, c.toLength = pu, c.toLower = K_, c.toNumber = He, c.toSafeInteger = qm, c.toString = J, c.toUpper = q_, c.trim = H_, c.trimEnd = W_, c.trimStart = V_, c.truncate = J_, c.unescape = j_, c.uniqueId = T0, c.upperCase = Y_, c.upperFirst = Ai, c.each = Xs, c.eachRight = Qs, c.first = Vs, Ti(c, (function() {
          var e = {};
          return ro(c, function(t, i) {
            V.call(c.prototype, i) || (e[i] = t);
          }), e;
        })(), { chain: !1 }), c.VERSION = a, De(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          c[e].placeholder = c;
        }), De(["drop", "take"], function(e, t) {
          q.prototype[e] = function(i) {
            i = i === r ? 1 : fe(U(i), 0);
            var s = this.__filtered__ && !t ? new q(this) : this.clone();
            return s.__filtered__ ? s.__takeCount__ = ge(i, s.__takeCount__) : s.__views__.push({
              size: ge(i, to),
              type: e + (s.__dir__ < 0 ? "Right" : "")
            }), s;
          }, q.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), De(["filter", "map", "takeWhile"], function(e, t) {
          var i = t + 1, s = i == Hi || i == Vl;
          q.prototype[e] = function(l) {
            var p = this.clone();
            return p.__iteratees__.push({
              iteratee: L(l, 3),
              type: i
            }), p.__filtered__ = p.__filtered__ || s, p;
          };
        }), De(["head", "last"], function(e, t) {
          var i = "take" + (t ? "Right" : "");
          q.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), De(["initial", "tail"], function(e, t) {
          var i = "drop" + (t ? "" : "Right");
          q.prototype[e] = function() {
            return this.__filtered__ ? new q(this) : this[i](1);
          };
        }), q.prototype.compact = function() {
          return this.filter(we);
        }, q.prototype.find = function(e) {
          return this.filter(e).head();
        }, q.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, q.prototype.invokeMap = $(function(e, t) {
          return typeof e == "function" ? new q(this) : this.map(function(i) {
            return Pt(i, e, t);
          });
        }), q.prototype.reject = function(e) {
          return this.filter(zn(L(e)));
        }, q.prototype.slice = function(e, t) {
          e = U(e);
          var i = this;
          return i.__filtered__ && (e > 0 || t < 0) ? new q(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), t !== r && (t = U(t), i = t < 0 ? i.dropRight(-t) : i.take(t - e)), i);
        }, q.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, q.prototype.toArray = function() {
          return this.take(to);
        }, ro(q.prototype, function(e, t) {
          var i = /^(?:filter|find|map|reject)|While$/.test(t), s = /^(?:head|last)$/.test(t), l = c[s ? "take" + (t == "last" ? "Right" : "") : t], p = s || /^find/.test(t);
          l && (c.prototype[t] = function() {
            var h = this.__wrapped__, m = s ? [1] : arguments, A = h instanceof q, M = m[0], x = A || G(h), S = function(K) {
              var H = l.apply(c, xo([K], m));
              return s && N ? H[0] : H;
            };
            x && i && typeof M == "function" && M.length != 1 && (A = x = !1);
            var N = this.__chain__, C = !!this.__actions__.length, P = p && !N, Z = A && !C;
            if (!p && x) {
              h = Z ? h : new q(this);
              var D = e.apply(h, m);
              return D.__actions__.push({ func: Ln, args: [S], thisArg: r }), new Ze(D, N);
            }
            return P && Z ? e.apply(this, m) : (D = this.thru(S), P ? s ? D.value()[0] : D.value() : D);
          });
        }), De(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var t = sn[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(e);
          c.prototype[e] = function() {
            var l = arguments;
            if (s && !this.__chain__) {
              var p = this.value();
              return t.apply(G(p) ? p : [], l);
            }
            return this[i](function(h) {
              return t.apply(G(h) ? h : [], l);
            });
          };
        }), ro(q.prototype, function(e, t) {
          var i = c[t];
          if (i) {
            var s = i.name + "";
            V.call(at, s) || (at[s] = []), at[s].push({ name: t, func: i });
          }
        }), at[Fn(r, To).name] = [{
          name: "wrapper",
          func: r
        }], q.prototype.clone = jd, q.prototype.reverse = Yd, q.prototype.value = Xd, c.prototype.at = Fh, c.prototype.chain = wh, c.prototype.commit = Ch, c.prototype.next = Eh, c.prototype.plant = kh, c.prototype.reverse = Dh, c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = Lh, c.prototype.first = c.prototype.head, wt && (c.prototype[wt] = Bh), c;
      }), nt = wd();
      Oo ? ((Oo.exports = nt)._ = nt, gr._ = nt) : _e._ = nt;
    }).call(Gy);
  })(qt, qt.exports)), qt.exports;
}
var Ht = Uy();
const WT = (o, n) => {
  const r = Ht.mapValues(o, (u) => u === "" || u === void 0 ? null : u);
  return Ht.omit(r, n);
}, VT = (o, n, r) => {
  const a = r ? Ht.omitBy(r, (u) => u === null) : {};
  Ht.assign(o, n, Ht.pick(a, Object.keys(o)));
}, JT = (o) => {
  const { properties: n } = o, { context: r } = n;
  return {
    addressNumber: r.address?.address_number,
    alternate: r.region?.alternate?.name,
    country: r.country?.name,
    countryCode: r.country?.country_code,
    fullAddress: n.full_address,
    latitude: n.coordinates.latitude,
    longitude: n.coordinates.longitude,
    mapboxId: n.mapbox_id,
    place: r.place?.name,
    postcode: r.postcode?.name,
    region: r.region?.name,
    regionCode: r.region?.region_code_full,
    streetName: r.street?.name
  };
}, jT = (o, n) => {
  if (n == null)
    return null;
  const r = n.trim();
  if (r.length === 0)
    return null;
  const a = Cy[o] ?? [];
  if (a.length === 0)
    return r.toUpperCase();
  const u = r.toLowerCase(), f = a.find((d) => d.code.toLowerCase() === u || d.name.toLowerCase() === u);
  return f ? f.code.toUpperCase() : null;
}, YT = (o) => {
  if (typeof o != "string") return !1;
  const n = o.replace(/-\d{1,2}$/, ""), r = /^\d+$/.test(n), a = /^[a-zA-Z0-9]+$/.test(n), u = n.length;
  return r && u >= 8 && u <= 10 || a && u === 17;
}, XT = (o, n) => {
  if (typeof o != "number" || !Number.isInteger(o)) return !1;
  const r = -(2 ** (n - 1)), a = 2 ** (n - 1) - 1;
  return o >= r && o <= a;
}, Zy = [
  { threshold: 0, step: 1 },
  { threshold: 10, step: 5 },
  { threshold: 50, step: 10 },
  { threshold: 100, step: 50 },
  { threshold: 1e3, step: 100 },
  { threshold: 5e3, step: 200 },
  { threshold: 1e4, step: 500 },
  { threshold: 5e4, step: 1e3 }
];
class Ol {
  constructor(n) {
    if (!n[0])
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.tiers = [...n].sort((a, u) => a.threshold - u.threshold);
    const r = this.tiers[0];
    if (!r)
      throw new Error("SaleSteppedPrice requires at least one tier");
    this.firstTier = r;
  }
  /** Creates an instance with the default MVP1 tiers (see DEFAULT_SALE_STEP_TIERS). */
  static createDefault() {
    return new Ol(Zy);
  }
  /**
   * Checks whether an amount falls on the stepped price grid.
   *
   * @example validateAmount(1200) // true  (tier 1000-4999, step 100: (1200-1000) % 100 === 0)
   * @example validateAmount(1250) // false (tier 1000-4999, step 100: (1250-1000) % 100 !== 0)
   */
  validateAmount(n) {
    if (n < 0)
      return !1;
    const r = this.getTierForAmount(n, "up");
    return (n - r.threshold) % r.step === 0;
  }
  /**
   * Rounds an amount down (floor) to the nearest valid step value.
   *
   * @example getStepRoundedAmount(5300) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedAmount(n) {
    return this.getStepRoundedValue(n, Math.floor);
  }
  /**
   * Rounds a reserve price up (ceil) to the nearest valid step value.
   *
   * @example getStepRoundedReservePrice(5100) // 5200 (tier 5000-9999, step 200)
   */
  getStepRoundedReservePrice(n) {
    return this.getStepRoundedValue(n, Math.ceil);
  }
  /**
   * Computes the Nth stepped amount past baseAmount. Positive deltaSteps moves up,
   * negative moves down. Correctly switches step size when crossing tier boundaries.
   * Throws if baseAmount is not itself a stepped amount, unless allowFreeBaseAmount
   * is set: a free base then counts as one move, landing on the first stepped amount
   * past it before the remaining steps are applied.
   *
   * @example getDeltaStepsAmount(4900, 2)  // 5200 (4900+100=5000, then 5000+200=5200)
   * @example getDeltaStepsAmount(5000, -1) // 4900 (at boundary, uses lower tier step 100)
   * @example getDeltaStepsAmount(9010, 1, { allowFreeBaseAmount: true }) // 9200, not 9400
   */
  getDeltaStepsAmount(n, r, { allowFreeBaseAmount: a = !1 } = {}) {
    if (this.validateAmount(n))
      return this.computeDeltaStepsAmount(n, r);
    if (!a)
      throw new Error(
        "Error in SaleSteppedPrice.getDeltaStepsAmount, base is not a valid amount (pass allowFreeBaseAmount to step from a free one)"
      );
    if (r === 0)
      return n;
    const u = this.getStepRoundedValue(n, r > 0 ? Math.ceil : Math.floor);
    return this.computeDeltaStepsAmount(u, r - Math.sign(r));
  }
  /**
   * Computes a default starting price for an auction given its reserve price.
   * Uses an exponential decay formula (BSD-3693) so the gap between starting
   * and reserve grows fast for cheap items and plateaus at ~25.000 for expensive ones.
   *
   * @example getAuctionStartingPriceDefaultValue(10000)  // 4600
   * @example getAuctionStartingPriceDefaultValue(100000) // 76500
   */
  getAuctionStartingPriceDefaultValue(n) {
    const a = n - 25e3 * (1 - Math.exp(-25e-6 * n));
    return this.getStepRoundedAmount(a);
  }
  /**
   * Returns the minimum negotiation offer for a direct sale: 30% of the price,
   * rounded down to the nearest valid step.
   *
   * @example getDirectSaleMinNegotiationOfferDefaultValue(10000) // 3000
   */
  getDirectSaleMinNegotiationOfferDefaultValue(n) {
    return this.getStepRoundedAmount(n * 0.3);
  }
  /**
   * Computes the suggested (discounted) price for a direct sale.
   * Uses a sigmoid that yields ~76% for low prices, trending toward
   * 100% for very high prices. Result is rounded down to the nearest valid step.
   *
   * @example getDirectSaleSuggestedPriceDefaultValue(5000)   // 4050  (~81%)
   * @example getDirectSaleSuggestedPriceDefaultValue(100000) // 88000 (~89%)
   */
  getDirectSaleSuggestedPriceDefaultValue(n) {
    const u = 0.98 - 0.16999999999999993 * Math.exp(-6e-6 * n);
    return this.getStepRoundedAmount(n * u);
  }
  /**
   * Finds the applicable tier for a given amount.
   * - direction 'up': returns the tier whose threshold is <= amount (used for validation/rounding)
   * - direction 'down': returns the tier whose threshold is < amount (at a boundary, picks the lower tier)
   */
  getTierForAmount(n, r) {
    const a = r === "up" ? (u) => u <= n : (u) => u < n;
    for (let u = this.tiers.length - 1; u >= 0; u--) {
      const f = this.tiers[u];
      if (f && a(f.threshold))
        return f;
    }
    return this.firstTier;
  }
  /** Rounds a value to the nearest valid step using the given rounding function (floor or ceil). */
  getStepRoundedValue(n, r) {
    const a = this.getTierForAmount(n, "up"), u = n - a.threshold;
    return r(u / a.step) * a.step + a.threshold;
  }
  /** Recursive implementation of getDeltaStepsAmount. Moves one step per call, recalculating the tier each time. */
  computeDeltaStepsAmount(n, r) {
    if (r === 0)
      return n;
    const a = r / Math.abs(r), u = r > 0 ? "up" : "down", f = this.getTierForAmount(n, u);
    return this.computeDeltaStepsAmount(n + f.step * a, r - a);
  }
}
const QT = ({
  reservePrice: o,
  isToBeScraped: n,
  isOneEuro: r
}) => {
  const a = n || o < 5e3 ? 50 : o < 1e4 ? 100 : o < 5e4 ? 500 : 1e3, u = n ? 50 : o < 5e3 ? 100 : o < 1e4 ? 500 : (o < 5e4, 1e3), f = n ? 1e3 : o < 5e3 ? 5e3 : o < 1e4 ? 1e4 : 5e4, d = n || r ? 250 : o <= 5e4 ? 500 : 1e3;
  return {
    minStepDefaultValue: a,
    maxStepDefaultValue: u,
    thresholdDefaultValue: f,
    bailDefaultValue: d
  };
};
function bt(o) {
  const n = Object.prototype.toString.call(o);
  return o instanceof Date || typeof o == "object" && n === "[object Date]" ? new o.constructor(+o) : typeof o == "number" || n === "[object Number]" || typeof o == "string" || n === "[object String]" ? new Date(o) : /* @__PURE__ */ new Date(NaN);
}
function $y(o, n) {
  const r = bt(o), a = bt(n);
  return r.getTime() > a.getTime();
}
function Ky(o, n) {
  const r = bt(o), a = bt(n);
  return +r < +a;
}
function ju(o, n) {
  const r = bt(o), a = bt(n);
  return +r == +a;
}
function Ki(o) {
  throw new Error("Should not have reached this line");
}
var ao = /* @__PURE__ */ ((o) => (o.Seller = "Seller", o.Buyer = "Buyer", o))(ao || {}), so = /* @__PURE__ */ ((o) => (o.FixedPercentage = "FixedPercentage", o.FixedAmount = "FixedAmount", o.Standard = "Standard", o))(so || {});
const qy = /* @__PURE__ */ new Date("2025-11-24"), Hy = /* @__PURE__ */ new Date("2025-11-28"), ht = 250, Ei = 0.0875, zl = 0.0375, Gl = 5250, Bi = 1e5, Ul = 2500, Wy = (o, [n, r]) => (ju(o, n) || $y(o, n)) && (Ky(o, r) || ju(o, r)), Zl = ({
  feeTarget: o,
  baseAmount: n,
  assetsCount: r,
  feeConfiguration: a
}) => {
  const u = {
    [ao.Seller]: 1,
    [ao.Buyer]: -1
  }[o], f = n / r;
  return (() => {
    if (!a || a.type === so.Standard) {
      const d = Ul - ht * u;
      return (() => {
        if (f <= d) return f + ht * u;
        const T = Bi - ht * u - Ei * Bi * u;
        return f <= T ? (f + ht * u) / (1 - Ei * u) : (f + Gl * u) / (1 - zl * u);
      })() * r;
    }
    if (a.type === so.FixedPercentage)
      return n / (1 - a.feeOverrideValue * u);
    if (a.type === so.FixedAmount)
      return n + a.feeOverrideValue * u;
    Ki(a.type);
  })();
}, eM = ({
  feeTarget: o,
  baseAmount: n,
  assetsCount: r,
  referenceDate: a,
  feeConfiguration: u
}) => {
  const f = n / r, d = (() => {
    if (!u || u.type === so.Standard)
      return f <= Ul ? ht * r : f <= Bi ? (ht + Ei * f) * r : (Gl + zl * f) * r;
    if (u.type === so.FixedPercentage)
      return n * u.feeOverrideValue;
    if (u.type === so.FixedAmount)
      return u.feeOverrideValue;
    Ki(u.type);
  })(), T = o === ao.Buyer && a && Wy(a, [qy, Hy]) ? d * 0.5 : d;
  return {
    grossTotal: Math.ceil(o === ao.Buyer ? n + d : n),
    grossNet: Math.ceil(o === ao.Buyer ? n : n - d),
    grossFees: Math.ceil(d),
    total: Math.ceil(o === ao.Buyer ? n + T : n),
    net: Math.ceil(o === ao.Buyer ? n : n - T),
    fees: Math.ceil(T)
  };
}, oM = ({
  sellerReservePrice: o,
  assetsCount: n,
  feeConfiguration: r
}) => {
  const a = Math.ceil(
    Zl({
      feeTarget: ao.Seller,
      baseAmount: o,
      assetsCount: n,
      feeConfiguration: r
    })
  );
  return {
    sellerReservePrice: o,
    fees: a - o,
    reservePrice: a
  };
}, tM = ({
  buyerBudget: o,
  assetsCount: n,
  feeConfiguration: r
}) => {
  const a = Math.ceil(
    Zl({
      feeTarget: ao.Buyer,
      baseAmount: o,
      assetsCount: n,
      feeConfiguration: r
    })
  );
  return {
    buyerBudget: o,
    fees: o - a,
    buyerMaxOffer: a
  };
}, nM = ({
  sellerReservePrice: o,
  feeConfiguration: n
}) => {
  const r = (() => {
    if (!n || n.type === so.Standard)
      return o <= 2250 ? 250 : o <= 91e3 ? (o + 250) / 0.9125 : (o + 5250) / 0.9625;
    if (n.type === so.FixedPercentage)
      return o / (1 - n.feeOverrideValue);
    if (n.type === so.FixedAmount)
      return o + n.feeOverrideValue;
    Ki(n.type);
  })();
  return Math.ceil(r);
}, rM = ({
  isSeller: o,
  isCustomerService: n,
  isAssignedSalesRep: r
}) => o || n || r, Vy = [
  "MinibusCityIntercity",
  "MinibusTouristic",
  "AutobusNormalFloor2Axle",
  "AutobusNormalFloor3Axle",
  "AutobusLowFloorLowEntry8_12Mt",
  "Autobus18Mt",
  "DoubleDecker"
];
function iM(o) {
  return typeof o == "string" && Vy.includes(o);
}
const Jy = My, jy = Iy, qi = 10, Yy = qi - 1, er = [
  ...Object.values(Jy).map(
    (o) => ({
      name: o.name,
      kind: "image",
      isInternal: !1,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType
    })
  ),
  ...Object.values(jy).map(
    (o) => ({
      name: o.name,
      kind: "video",
      isInternal: o.isInternal,
      label: o.label,
      group: o.group,
      positionByType: o.positionByType,
      positionAdminByType: o.positionAdminByType
    })
  )
], or = new Map(er.map((o) => [o.name, o]));
function aM(o) {
  return or.get(o)?.isInternal ?? !1;
}
function sM(o) {
  return o === "DoubleDecker";
}
function uM(o) {
  const n = or.get(o);
  return n ? n.kind === "image" ? "IMAGES_BASE" : o === "video_engine_working" ? "VIDEOS_ENGINE" : o === "video_warranty" ? "VIDEOS_WARRANTY" : "VIDEOS_OTHER" : null;
}
function Ni(o) {
  return er.filter((n) => n.positionAdminByType?.[o] !== void 0).sort((n, r) => (n.positionAdminByType?.[o] ?? 0) - (r.positionAdminByType?.[o] ?? 0)).map((n) => ({
    name: n.name,
    kind: n.kind,
    isInternal: n.isInternal,
    label: n.label,
    group: n.group,
    positionInspection: n.positionAdminByType?.[o] ?? 0,
    positionFleequid: n.positionByType?.[o] ?? null
  }));
}
function lM(o) {
  return Number.isInteger(o) && o > 0 && o % qi !== 0;
}
function Xy(o) {
  return o.anchor === void 0 ? null : { anchor: o.anchor, offset: o.position % qi };
}
function cM({
  anchorPositionInspection: o,
  siblingOffsets: n,
  takenPositions: r
}) {
  const a = new Set(n), u = new Set(r);
  for (let f = 1; f <= Yy; f++) {
    const d = o + f;
    if (!a.has(f) && !u.has(d))
      return d;
  }
  return null;
}
function dM(o, n) {
  const r = Xy(n), a = r === null ? void 0 : or.get(r.anchor);
  if (r === null || !a || a.isInternal)
    return null;
  const u = a.positionByType?.[o];
  return u === void 0 ? null : u + r.offset;
}
function pM(o) {
  return er.filter((n) => !n.isInternal && n.positionByType?.[o] !== void 0).sort((n, r) => (n.positionByType?.[o] ?? 0) - (r.positionByType?.[o] ?? 0)).map((n) => n.name);
}
function fM(o, n) {
  const r = or.get(n);
  return !r || r.isInternal ? null : r.positionByType?.[o] ?? null;
}
function hM(o) {
  return er.filter((n) => n.positionAdminByType?.[o] !== void 0).map((n) => n.name);
}
function mM({
  from: o,
  to: n,
  held: r
}) {
  const a = new Set(Ni(o).map((_) => _.name)), u = new Set(Ni(n).map((_) => _.name)), f = { kept: [], dropped: [], missing: [], keptExtras: [], droppedExtras: [], untouched: [] };
  for (const { name: _, anchor: T } of r)
    a.has(_) || u.has(_) ? (u.has(_) ? f.kept : f.dropped).push(_) : T === void 0 ? f.untouched.push(_) : (u.has(T) ? f.keptExtras : f.droppedExtras).push(_);
  const d = new Set(r.map(({ name: _ }) => _));
  for (const _ of Ni(n))
    d.has(_.name) || f.missing.push(_.name);
  return f;
}
var Qy = /* @__PURE__ */ ((o) => (o.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", o.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", o.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", o.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", o.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", o))(Qy || {});
const _M = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  Py as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  OT as AdminUserPasswordResetTokenPayloadSchema,
  fT as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  My as BUS_ASSET_BASE_IMAGES,
  hT as BUS_ASSET_COVER_IMAGES,
  Iy as BUS_ASSET_VIDEOS,
  cT as CalcomBookingMetadataSchema,
  Zy as DEFAULT_SALE_STEP_TIERS,
  TT as FILE_UPLOAD_EXTENSIONS,
  yT as FILE_UPLOAD_PDF_MAX_SIZE,
  ao as FeeTarget,
  so as FeeType,
  Sy as ITALIAN_REGIONS,
  By as LanguageISO6391Schema,
  ET as MAPBOX_API_CONFIG,
  Yy as MAX_DISCRETIONARY_PHOTOS_PER_GAP,
  pT as ONE_EURO_STARTING_PRICE,
  Qy as PowertrainWarrantyIneligibilityReason,
  LT as SEARCH_SUGGEST_MAX_QUERY_LENGTH,
  DT as SEARCH_SUGGEST_MIN_QUERY_LENGTH,
  dT as STEP_LOWEST_COMMON_DENOMINATOR,
  Ol as SaleSteppedPrice,
  ST as TEXT_INPAINT_DEFAULT_PROMPT,
  _M as VAS_CLAIM_CONFIGURATION,
  WT as adaptFormDataToDto,
  JT as adaptMapboxFeatureToAddressBody,
  PT as addressFormFieldSchema,
  uT as busClasses,
  eT as busDossierDocumentKeys,
  R0 as busRegistrationDependentFieldKeys,
  sT as busTypes,
  tM as computeBuyerMaxOfferAndFees,
  eM as computeFees,
  rM as computeIsSellerPov,
  nM as computeReservePrice,
  QT as computeSaleDefaultValues,
  oM as computeSellerReservePriceAndFees,
  KT as convertKwToHp,
  Zi as countriesConfig,
  Bl as countryIso2List,
  wT as customerServiceEmail,
  CT as customerServicePhone,
  HT as fetchFormatQuery,
  RT as getAddressFormFieldSchema,
  bT as getAsCountryISO2,
  AT as getAsCountryISO3,
  MT as getAsLanguageISO6391,
  xT as getAsTaxCodeOrigin,
  Oy as getAsTin,
  aT as getBusDossierDocumentResponsibility,
  tT as getBusDossierFieldResponsibility,
  nT as getBusDossierRequiredVaryingFields,
  _T as getCountryCodesByContinent,
  gT as getCountryISO3FromISO2,
  mT as getCountryNameInEnglish,
  pM as getFleequidOrder,
  FT as getHubspotFlagUrl,
  vT as getHubspotSalesRepImageUrl,
  Ni as getInspectionSequence,
  BT as getLanguage6391FromCountryIso2,
  uM as getMediaTypeForName,
  hM as getRequiredMedia,
  NT as hubspotDefaultSalesRepImageUrl,
  $i as hubspotPublicFilesBaseUrl,
  VT as initFormData,
  qT as insertIf,
  lM as isAnchoredPosition,
  rT as isBusDossierDocumentHidden,
  iT as isBusDossierDocumentRequired,
  oT as isBusDossierFieldHidden,
  Z0 as isBusDossierFieldRequired,
  Yu as isBusToBeRegistered,
  Fy as isCountryISO2,
  wy as isCountryISO3,
  XT as isDbIntegerValidator,
  sM as isDoubleDecker,
  aM as isInternalMedia,
  Dy as isTaxCodeOrigin,
  ZT as isTin,
  iM as isTrustReportType,
  O0 as isWaivedByBusRegistration,
  IT as languageNames,
  kT as languageToRepresentativeCountryMap,
  $T as parseAsTin,
  zT as phoneValidator,
  Ll as phoneValidatorE164,
  Cy as provinces,
  mM as reconcileForTrustReportTypeChange,
  Xy as resolveDiscretionaryAnchor,
  fM as resolveFleequidPosition,
  dM as resolveInterlacedFleequidPosition,
  cM as resolveNextAnchoredPosition,
  jT as resolveProvinceCode,
  lT as suggestedLuggageCapacity,
  ky as taxCodeOriginList,
  Vy as trustReportTypes,
  YT as vinValidator,
  GT as zodPhoneE164,
  UT as zodPhoneE164Optional
};
//# sourceMappingURL=shared.mjs.map
